// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/RobotoRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/RobotoRegular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg width=%2766%27 height=%2766%27 xmlns=%27http://www.w3.org/2000/svg%27%3E %3Cdefs%3E %3ClinearGradient x1=%2770.883%25%27 y1=%274.637%25%27 x2=%2750%25%27 y2=%27100%25%27 id=%27a%27%3E %3Cstop stop-color=%27%235CB3FF%27 offset=%270%25%27/%3E %3Cstop stop-color=%27%23F6F7F8%27 stop-opacity=%270%27 offset=%27100%25%27/%3E %3C/linearGradient%3E %3C/defs%3E %3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E %3Cpath d=%27M33 65.5C15.05 65.5.5 50.95.5 33S15.05.5 33 .5 65.5 15.05 65.5 33 50.95 65.5 33 65.5zm0-7c14.083 0 25.5-11.417 25.5-25.5S47.083 7.5 33 7.5 7.5 18.917 7.5 33 18.917 58.5 33 58.5z%27 stroke=%27%23D7DDE2%27 fill=%27%23FFF%27/%3E %3Cpath d=%27M51.908 8.236l-2.358 3.245A26.894 26.894 0 0 0 32 5C17.088 5 5 17.088 5 32s12.088 27 27 27c1.129 0 2.242-.07 3.334-.204l4.435 3.222C37.286 62.66 34.683 63 32 63 14.88 63 1 49.12 1 32 1 14.88 14.88 1 32 1c7.579 0 14.522 2.72 19.908 7.236z%27 fill=%27url%28%23a%29%27 transform=%27translate%281 1%29%27/%3E %3Cpath d=%27M48.564 13c1.92 0 3.557-.64 4.075-2.367.112-.375.361-.67.361-1.08C53 7.248 51.572 5 49.234 5S45 6.867 45 9.17c0 2.304 1.225 3.83 3.564 3.83z%27 stroke=%27%234DACFF%27 fill=%27%2352AEFF%27/%3E %3C/g%3E %3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23080c11%22%20d%3D%22M0%200h10L5%205z%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg width=%2740%27 height=%2740%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M35.37 26.457a15.282 15.282 0 000-21.918c-6.176-6.052-16.187-6.052-22.361 0a15.274 15.274 0 00-1.541 20.166c-.367.147-.713.37-1.014.665L.926 34.709a3.056 3.056 0 000 4.383 3.208 3.208 0 004.472 0l9.528-9.339c.352-.345.604-.753.756-1.186 6.137 3.831 14.347 3.124 19.687-2.11zM24.193 4.043c6.454 0 11.686 5.129 11.686 11.455 0 6.326-5.232 11.455-11.686 11.455-6.455 0-11.687-5.129-11.687-11.455 0-6.326 5.232-11.455 11.687-11.455z%27 fill=%27%233a87cf%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 128 128%27%3E%3Cpath fill=%27%23004872%27 fill-rule=%27evenodd%27 d=%27M69.028 64l22.628 22.627-5.029 5.029L64 69.028 41.373 91.656l-5.029-5.029L58.972 64 36.344 41.373l5.029-5.029L64 58.972l22.627-22.628 5.029 5.029L69.028 64z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAA81BMVEUAAABaPhVcDwE7CQA6gJIAAAAATQAkTlsATgBcPxYrHAciGgkAAABcPxU0coUARgAxNTgnU2IoV2YzNjoAUgAtYXEzODovZngAUQAAUAAwNDg0dIk2d4sAOgAjKCgAGAAADQA+hJVZPBRcPxb62AAA4gD/rz1VSQBk2f//KgQiSldXDgEATQCOmqNXOxQwNDdoRhiGWx+tHAJiEAFZw+b1KAMAywDlnTb5qjv7rDzpnzdMpcNJn7xFlrGMmKGEj5g4eY82d4xxe4IyboIwaHskT15GTFEA2gAArAAAnAAAfgAAfABg0vddyu5cZGpg0fbOjTE6oyFAAAAAJHRSTlMA7cc4Kgj9+vbBJB4GypVn9vPu5t/Y18O8n4B/ckY6FRMdmtlkVn4PAAACq0lEQVRYw+2YaVPaUBSGqWbTWsK+b9pC6ek1lypGW1T2RUDb//9rmpsm3Nyc1DQfOhMc3k/cyUzmfeY5BxISh+xXzi7eJ/Y5ZyfGu30msPobQQSf/5KEmKZeymlarqQ3g28vJfMZVc3kk1LUYkdfA3OE+/duv3GCaACtskKcKOVWQP0i7FKMiHAcDHAc0L9zxwgQwKeAiAB1jZD1ylwuzdWaEK3u71BTAUaD/nbbH4wA1FpUBVdffLliAnD/DieIBKArZGO2nZgboujiLZIA437XSX8MkIyo4PpG7H9zzQTg/pwgEkBdIU9tT56IIjioATx0PXkAqEVWgAXg/pwgEkBLY/1FAq3lmX+V9RcJVLwHcqWQShUqcpgCLgD35wRRAMpk0/ZlQ8r8BkUY27XvZ/P57N7+OIaiv2QjS+1kG2EKuADcHxOEAzQVYvoBTKI0dwIA2Pw/T8HO9JntAYDk60/pYjIcThaUNkIUcAG4PyYIB9DJuo2yJjrf4FHXyhTSVUmqpmHKTiPfHstZ+vJ4aeXxhWblYAVYAO6PCcIBSmSFAVak5F7Pw4DND6TP2ek8DWyKBpAXClbogvVnBAtaCVaABeD+mCAcIMcmCM9Qzr2esSdoBtU/xyrM7BnKCAULdHLpZEILr2wBEnBhGL86OHc94+M/AmhkiQGWRHOvq7C1Gs/doZdgbh23oAr9UnToAgxp6pUvIrQB8gej9wP1/24ZOP2fAD+jAHAFXAAmwP1jNUK2Ai4AE+D+sVpiRwEXgAhQ/3h9jboKuABMIPaP1w8ZV8AFIAKhf8weJXYKBAGIgPeP2cMcVyAIwARu/7g9TnMFggBM4PSP2wuNR4EgABPc2v1j90rpUSAIwAQG6x+7l3qvAkEAJmD94/e3ileBIAATnJwmDjnkTeU3PTFjExFNx+YAAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg width=%2764%27 height=%2764%27 xmlns=%27http://www.w3.org/2000/svg%27%3E %3Cdefs%3E %3ClinearGradient x1=%2765.479%25%27 y1=%27-8.436%25%27 x2=%2750%25%27 y2=%27100%25%27 id=%27a%27%3E %3Cstop stop-color=%27%234dacff%27 offset=%270%25%27/%3E %3Cstop stop-color=%27%234dacff%27 stop-opacity=%270%27 offset=%27100%25%27/%3E %3C/linearGradient%3E %3C/defs%3E %3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E %3Cpath d=%27M32 64C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm0-6c14.36 0 26-11.64 26-26S46.36 6 32 6 6 17.64 6 32s11.64 26 26 26z%27 fill=%27rgba%280,0,0,.3%29%27/%3E %3Cpath d=%27M51.908 8.236l-2.358 3.245A26.894 26.894 0 0 0 32 5C17.088 5 5 17.088 5 32s12.088 27 27 27c1.129 0 2.242-.07 3.334-.204l4.435 3.222C37.286 62.66 34.683 63 32 63 14.88 63 1 49.12 1 32 1 14.88 14.88 1 32 1c7.579 0 14.522 2.72 19.908 7.236z%27 fill=%27url%28%23a%29%27/%3E %3Cpath d=%27M47.564 12c1.92 0 3.557-.64 4.075-2.367.112-.375.361-.67.361-1.08C52 6.248 50.572 4 48.234 4S44 5.867 44 8.17c0 2.304 1.225 3.83 3.564 3.83z%27 fill=%27%234dacff%27/%3E %3C/g%3E %3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg width=%2740%27 height=%2740%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M35.37 26.457a15.282 15.282 0 000-21.918c-6.176-6.052-16.187-6.052-22.361 0a15.274 15.274 0 00-1.541 20.166c-.367.147-.713.37-1.014.665L.926 34.709a3.056 3.056 0 000 4.383 3.208 3.208 0 004.472 0l9.528-9.339c.352-.345.604-.753.756-1.186 6.137 3.831 14.347 3.124 19.687-2.11zM24.193 4.043c6.454 0 11.686 5.129 11.686 11.455 0 6.326-5.232 11.455-11.686 11.455-6.455 0-11.687-5.129-11.687-11.455 0-6.326 5.232-11.455 11.687-11.455z%27 fill=%27%23005a92%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%0A%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 128 128%27%3E%3Cpath fill=%27%233a87cf%27 fill-rule=%27evenodd%27 d=%27M69.028 64l22.628 22.627-5.029 5.029L64 69.028 41.373 91.656l-5.029-5.029L58.972 64 36.344 41.373l5.029-5.029L64 58.972l22.627-22.628 5.029 5.029L69.028 64z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAAgVBMVEUAAAD/tQv/swL/OTn/PDzftl9W8QBW8AAtzP8v0P9Z9gD/tAP/uQb/tAItzf8tzf+eqK2ep60uzP9X8QCfqK4uzf8uzf9X8QAuzP9X8ACeqK4vzP9Y8QAuzv9Y8gCeqq4wz/8xzv9A1f9Y8QD/tAP86DpW8AD/swL/ODgtzP+ep63tgXPUAAAAJXRSTlMAGNfAQAv98/IdG8Io52zz8+DZ2dC9trabm4F+a05OQjAaDG6dAJcYcwAAAfdJREFUWMPtmNlygkAQRScyrBp3QTZFNBj8/w9MCGI3dBOHMg9jyvOmVFnn1HUSULx4LibjN/HMTN7Po2cu+PY/cwUfPYg2XhKsbHsVJJ5gcaf+cjZb+lN3qJjxyWIw/lAwNMALreKKFTIJh215Y3sYFiD5AEn9oWBowM4uEPau65A6JcJJ/2ACg/pDwdCAo1W0sI6ixbTsMH18Akn9oWBgwK7xh4LWBmlJSB+dwCD+pEA5wLMLgo3OwcGpvzhxludZfH1Bz4EZrefzdWSqTSCJPylQDggLhhA+oD6/G7d+5W7qk9yV3C8uPyz2KhMYxJ8UKAd4Fhdg3SZwa3/4wLrA7fhfbuwVJpDEnxQoByQFS9I6wQ7ydR16js0FBCzMuxMY1J8WqAYEfEDQXPcr3RjbxNU7vsBEF0R0dwJJ/LkCxYAVH7Bqri8r3QzbZNU7S4FZ44B1/ymgA4zPfZwUA2w+wG6uzyrdHMvk1TszgZnjgLmgyL4T8Dbq8R+bWgUIgw4ABby/Vl8hIckAUMD7a3WIYQIYgC0Af73+jOIJpKAF1F+vf2QwAQxAC7C/ZrcSeAIpegvAX7ObOZgABiAF2F+322mYAAagBeCv2wMNTEAGIAWVv3aPlDABDMAW1P7aPdQjDBiALaj89ftZBSGl+LXgZIoXL/4VXyptNwzuHR/QAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20128%20128%22%3E%0A%20%20%3Cpath%20fill%3D%22%23FF3030%22%20fill-rule%3D%22evenodd%22%20d%3D%22M64.031%205c8.461%200%2068.88%20107.243%2063.648%20114.184-5.232%206.942-120.805%205.477-127.212%200C-5.941%20113.708%2055.57%205%2064.03%205zm3.45%2075.894l1.822-34.893H56.946l1.82%2034.893h8.715zM56.803%2093.108c0%201.929.547%203.423%201.643%204.483%201.095%201.06%202.642%201.589%204.642%201.589%201.953%200%203.477-.542%204.572-1.625%201.095-1.084%201.643-2.566%201.643-4.447%200-1.952-.542-3.452-1.625-4.5-1.084-1.047-2.613-1.571-4.59-1.571-2.047%200-3.607.512-4.678%201.536-1.072%201.023-1.607%202.535-1.607%204.535z%22%2F%3E%0A%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20style%3D%22transform%3A%20rotate%28180deg%29%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23080c11%22%20d%3D%22M0%200h10L5%205z%22%20fill-rule%3D%22evenodd%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000000%22%20fill-opacity%3D%22.3%22%20stroke%3D%22%2314202c%22%20d%3D%22M32%2C63.5%20C49.3969696%2C63.5%2063.5%2C49.3969696%2063.5%2C32%20C63.5%2C14.6030304%2049.3969696%2C0.5%2032%2C0.5%20C14.6030304%2C0.5%200.5%2C14.6030304%200.5%2C32%20C0.5%2C49.3969696%2014.6030304%2C63.5%2032%2C63.5%20Z%20M32%2C56.5%20C18.4690236%2C56.5%207.5%2C45.5309764%207.5%2C32%20C7.5%2C18.4690236%2018.4690236%2C7.5%2032%2C7.5%20C45.5309764%2C7.5%2056.5%2C18.4690236%2056.5%2C32%20C56.5%2C45.5309764%2045.5309764%2C56.5%2032%2C56.5%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%234dacff%22%20fill-rule%3D%22nonzero%22%20d%3D%22M32%2C61.9354839%20C30.9333606%2C61.9354839%2030.0686785%2C61.0708018%2030.0686785%2C60.0041623%20C30.0686785%2C58.9375229%2030.9333606%2C58.0728408%2032%2C58.0728408%20C40.1954904%2C58.0728408%2047.7578267%2C54.2689176%2052.6662672%2C47.8987622%20C56.1526582%2C43.3741373%2058.0728408%2C37.8356396%2058.0728408%2C32%20C58.0728408%2C17.6003676%2046.3996324%2C5.92715921%2032%2C5.92715921%20C17.6003676%2C5.92715921%205.92715921%2C17.6003676%205.92715921%2C32%20C5.92715921%2C33.0666394%205.0624771%2C33.9313215%203.99583767%2C33.9313215%20C2.92919824%2C33.9313215%202.06451613%2C33.0666394%202.06451613%2C32%20C2.06451613%2C15.4670888%2015.4670888%2C2.06451613%2032%2C2.06451613%20C48.5329112%2C2.06451613%2061.9354839%2C15.4670888%2061.9354839%2C32%20C61.9354839%2C38.6961574%2059.7285058%2C45.0618765%2055.7259583%2C50.2563674%20C50.0938506%2C57.5656952%2041.4065535%2C61.9354839%2032%2C61.9354839%20Z%22%20%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%276%27 height=%276%27%3E %3Cdefs%3E %3ClinearGradient id=%27a%27 x1=%2750%25%27 x2=%2750%25%27 y1=%270%25%27 y2=%27100%25%27%3E %3Cstop offset=%270%25%27 stop-color=%27%23000%27/%3E %3Cstop offset=%27100%25%27 stop-color=%27%23023861%27 stop-opacity=%270%27/%3E %3C/linearGradient%3E %3C/defs%3E %3Ccircle cx=%273%27 cy=%273%27 r=%273%27 fill=%27url%28%23a%29%27 fill-rule=%27evenodd%27/%3E %3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

:root {
  --thumbSize: var(--controlOptionSize);
  --thumbShadow: 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);
  --thumbShadowHover: 0 6px 10px rgba(0, 0, 0, 0.14), 0 1px 18px rgba(0, 0, 0, 0.12), 0 3px 5px rgba(0, 0, 0, 0.2);
  --thumbShadowActive: inset 0 0 0 4px var(--primary), 0 1px 3px rgba(0, 0, 0, 0.14), 0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.2);
  --trackHeight: 3px;
  --trackCursor: pointer;
  --step: 1;
  --min: 0;
  --max: 100;
  --ticksThickness: 1px;
  --ticksHeight: 3px;
  --ticksColor: var(--primaryDark);

  --progressPadding: 2px 0 0 2px;
  --progressRadius: 10px 10px 10px 10px;
  --progressHeight: 14px;
  --progressWidth: calc(100% - 4px);

  --padding: 0.5rem;
  --paddingLeft: 0.5rem;
  --paddingRight: 0.5rem;
  --paddingTop: 0.25rem;
  --paddingBottom: 0.25rem;

  --disabledControlOpacity: 0.4;
  --disabledControlCursor: not-allowed;
  --disabledOpacity: 0.4;
  --disabledCursor: not-allowed;
  --buttonBorderRadius: 3px;
  --defaultBorderRadius: 3px;
  --controlOptionSize: 1.125rem;
  /* 18px */
  --controlBorderRadius: 3px;
  --labelFontSize: 1rem;
  --smallLabelFontSize: 0.875rem;
  --largeLabelFontSize: 1.125rem;
  /* Typography */
  --fontFamily: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --fontSize: 1rem;
  /* 16px */
  --fontSizeXL: 1.125rem;
  --fontSizeLG: 1rem;
  --fontSizeMD: 0.875rem;
  --fontSizeSM: 0.75rem;
  --fontSizeXS: 0.65rem;
  --fontFamilyLight: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  --fontFamilyMono: 'Roboto Mono', monospace;
  --colorBlack: rgb(0, 0, 0);
  --colorWhite: rgb(255, 255, 255);
  --colorGray: rgb(204, 204, 204);
  --colorPrimary: rgb(0, 90, 143);
  --colorSecondary: rgb(77, 172, 255);
  --colorTertiary: rgb(40, 63, 88);
  --colorQuaternary: rgb(206, 214, 228);
  --statusDarkCritical: rgb(255, 56, 56);
  --statusDarkSerious: rgb(255, 179, 0);
  --statusDarkCaution: rgb(252, 232, 58);
  --statusDarkNormal: rgb(86, 240, 0);
  --statusDarkStandby: rgb(45, 204, 255);
  --statusDarkOff: rgb(158, 167, 173);
  --statusLightCritical: rgb(255, 42, 4);
  --statusLightSerious: rgb(255, 175, 61);
  --statusLightCaution: rgb(250, 216, 0);
  --statusLightNormal: rgb(0, 226, 0);
  --statusLightStandby: rgb(100, 217, 255);
  --statusLightOff: rgb(142, 154, 163);
  --classificationTopSecretSCIBackgroundColor: rgba(252, 232, 58);
  --classificationTopSecretBackgroundColor: rgba(255, 140, 0);
  --classificationSecretBackgroundColor: rgba(200, 16, 46);
  --classificationConfidentialBackgroundColor: rgba(0, 51, 160);
  --classificationControlledBackgroundColor: rgba(80, 43, 133);
  --classificationUnclassifiedBackgroundColor: rgba(0, 122, 51);
  --colorTag1: rgb(25, 199, 202);
  --colorTag2: rgb(120, 112, 208);
  --colorTag3: rgb(160, 13, 190);
  --colorTag4: rgb(216, 83, 30);
  --colorPrimaryLighten5: rgb(51, 123, 165);
  --colorPrimaryLighten1: rgb(51, 123, 165);
  --colorPrimaryLighten2: rgb(102, 156, 188);
  --colorPrimaryLighten3: rgb(153, 189, 210);
  --colorPrimaryLighten4: rgb(204, 222, 233);
  --colorPrimaryDarken1: rgb(0, 72, 114);
  --colorPrimaryDarken2: rgb(0, 54, 86);
  --colorPrimaryDarken3: rgb(0, 36, 57);
  --colorPrimaryDarken4: rgb(0, 18, 29);
  --colorSecondaryLighten1: rgb(113, 189, 255);
  --colorSecondaryLighten2: rgb(146, 203, 255);
  --colorSecondaryLighten3: rgb(184, 222, 255);
  --colorSecondaryLighten4: rgb(219, 238, 255);
  --colorSecondaryDarken1: rgb(62, 138, 204);
  --colorSecondaryDarken2: rgb(46, 103, 153);
  --colorSecondaryDarken3: rgb(31, 69, 102);
  --colorSecondaryDarken4: rgb(15, 34, 51);
  --colorTertiaryLighten1: rgb(82, 102, 122);
  --colorTertiaryLighten2: rgb(126, 140, 155);
  --colorTertiaryLighten3: rgb(169, 178, 188);
  --colorTertiaryLighten4: rgb(212, 217, 222);
  --colorTertiaryDarken1: rgb(31, 51, 71);
  --color-dark-background: rgb(24, 38, 53);
  --color-dark-border: rgb(16, 25, 35);
  --colorTertiaryDarken4: rgb(8, 13, 18);
  --colorQuaternaryLighten1: rgb(217, 222, 233);
  --colorQuaternaryLighten2: rgb(225, 230, 239);
  --colorQuaternaryLighten3: rgb(236, 239, 244);
  --colorQuaternaryLighten4: rgb(245, 246, 249);
  --colorQuaternaryDarken1: rgb(166, 171, 182);
  --colorQuaternaryDarken2: rgb(124, 128, 136);
  --colorQuaternaryDarken3: rgb(83, 86, 91);
  --colorQuaternaryDarken4: rgb(41, 43, 45);
  --colorCriticalLighten1: rgb(255, 96, 96);
  --colorCriticalLighten2: rgb(255, 136, 136);
  --colorCriticalLighten3: rgb(255, 175, 175);
  --colorCriticalLighten4: rgb(255, 215, 215);
  --colorCriticalDarken1: rgb(204, 45, 45);
  --colorCriticalDarken2: rgb(153, 34, 34);
  --colorCriticalDarken3: rgb(102, 22, 22);
  --colorCriticalDarken4: rgb(51, 11, 11);
  --colorSeriousLighten1: rgb(255, 194, 51);
  --colorSeriousLighten2: rgb(255, 209, 102);
  --colorSeriousLighten3: rgb(255, 225, 153);
  --colorSeriousLighten4: rgb(255, 240, 204);
  --colorSeriousDarken1: rgb(204, 143, 0);
  --colorSeriousDarken2: rgb(153, 107, 0);
  --colorSeriousDarken3: rgb(102, 72, 0);
  --colorSeriousDarken4: rgb(51, 36, 0);
  --colorCautionLighten1: rgb(253, 237, 97);
  --colorCautionLighten2: rgb(253, 241, 137);
  --colorCautionLighten3: rgb(254, 246, 176);
  --colorCautionLighten4: rgb(254, 250, 216);
  --colorCautionDarken1: rgb(202, 186, 46);
  --colorCautionDarken2: rgb(151, 139, 35);
  --colorCautionDarken3: rgb(101, 93, 23);
  --colorCautionDarken4: rgb(50, 46, 12);
  --colorNormalLighten1: rgb(120, 243, 51);
  --colorNormalLighten2: rgb(154, 246, 102);
  --colorNormalLighten3: rgb(187, 249, 153);
  --colorNormalLighten4: rgb(221, 252, 204);
  --colorNormalDarken1: rgb(69, 192, 0);
  --colorNormalDarken2: rgb(52, 144, 0);
  --colorNormalDarken3: rgb(34, 96, 0);
  --colorNormalDarken4: rgb(17, 48, 0);
  --colorStandbyLighten1: rgb(87, 214, 255);
  --colorStandbyLighten2: rgb(129, 224, 255);
  --colorStandbyLighten3: rgb(171, 235, 255);
  --colorStandbyLighten4: rgb(213, 245, 255);
  --colorStandbyDarken1: rgb(36, 163, 204);
  --colorStandbyDarken2: rgb(27, 122, 153);
  --colorStandbyDarken3: rgb(18, 82, 102);
  --colorStandbyDarken4: rgb(9, 41, 51);
  --colorOffLighten1: rgb(177, 185, 189);
  --colorOffLighten2: rgb(197, 202, 206);
  --colorOffLighten3: rgb(216, 220, 222);
  --colorOffLighten4: rgb(236, 237, 239);
  --colorOffDarken1: rgb(126, 134, 138);
  --colorOffDarken2: rgb(95, 100, 104);
  --colorOffDarken3: rgb(63, 67, 69);
  --colorOffDarken4: rgb(32, 33, 35);
  --colorTag1Lighten1: rgb(71, 210, 213);
  --colorTag1Lighten2: rgb(117, 221, 223);
  --colorTag1Lighten3: rgb(163, 233, 234);
  --colorTag1Lighten4: rgb(209, 244, 244);
  --colorTag1Darken1: rgb(20, 159, 162);
  --colorTag1Darken2: rgb(15, 119, 121);
  --colorTag1Darken3: rgb(10, 80, 81);
  --colorTag1Darken4: rgb(5, 40, 40);
  --colorTag2Lighten1: rgb(147, 141, 217);
  --colorTag2Lighten2: rgb(174, 169, 227);
  --colorTag2Lighten3: rgb(201, 198, 236);
  --colorTag2Lighten4: rgb(228, 226, 246);
  --colorTag2Darken1: rgb(96, 90, 166);
  --colorTag2Darken2: rgb(72, 67, 125);
  --colorTag2Darken3: rgb(48, 45, 83);
  --colorTag2Darken4: rgb(24, 22, 42);
  --colorTag3Lighten1: rgb(179, 61, 203);
  --colorTag3Lighten2: rgb(198, 110, 216);
  --colorTag3Lighten3: rgb(217, 158, 229);
  --colorTag3Lighten4: rgb(236, 207, 242);
  --colorTag3Darken1: rgb(128, 10, 152);
  --colorTag3Darken2: rgb(96, 8, 114);
  --colorTag3Darken3: rgb(64, 5, 76);
  --colorTag3Darken4: rgb(32, 3, 38);
  --colorTag4Lighten1: rgb(224, 117, 75);
  --colorTag4Lighten2: rgb(232, 152, 120);
  --colorTag4Lighten3: rgb(239, 186, 165);
  --colorTag4Lighten4: rgb(247, 221, 210);
  --colorTag4Darken1: rgb(173, 66, 24);
  --colorTag4Darken2: rgb(130, 50, 18);
  --colorTag4Darken3: rgb(86, 33, 12);
  --colorTag4Darken4: rgb(43, 17, 6);
  --colorWhiteLighten1: rgb(255, 255, 255);
  --colorWhiteLighten2: rgb(255, 255, 255);
  --colorWhiteLighten3: rgb(255, 255, 255);
  --colorWhiteLighten4: rgb(255, 255, 255);
  --colorWhiteDarken1: rgb(204, 204, 204);
  --colorWhiteDarken2: rgb(153, 153, 153);
  --colorWhiteDarken3: rgb(102, 102, 102);
  --colorWhiteDarken4: rgb(51, 51, 51);
  --colorBlackLighten1: rgb(51, 51, 51);
  --colorBlackLighten2: rgb(102, 102, 102);
  --colorBlackLighten3: rgb(153, 153, 153);
  --colorBlackLighten4: rgb(204, 204, 204);
  --colorBlackDarken1: rgb(0, 0, 0);
  --colorBlackDarken2: rgb(0, 0, 0);
  --colorBlackDarken3: rgb(0, 0, 0);
  --colorBlackDarken4: rgb(0, 0, 0);
  --colorGrayLighten1: rgb(214, 214, 214);
  --colorGrayLighten2: rgb(224, 224, 224);
  --colorGrayLighten3: rgb(235, 235, 235);
  --colorGrayLighten4: rgb(245, 245, 245);
  --colorGrayDarken1: rgb(163, 163, 163);
  --colorGrayDarken2: rgb(122, 122, 122);
  --colorGrayDarken3: rgb(82, 82, 82);
  --colorGrayDarken4: rgb(41, 41, 41);
}

/* Regular */
@font-face {
  font-family: 'Roboto';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 400;
  font-style: normal;
}

.light-theme {
  /*

    Global Colors
    ==========================================================================
	*/
  /* Astro 5 Simplified Color Palette */
  --backgroundColor: var(--colorQuaternaryLighten3, #eaeef4);
  --defaultText: var(--colorQuaternaryDarken4, #292a2d);
  --secondaryText: var(--colorQuaternaryDarken3, #51555b);
  --globalAppHeader: var(--color-dark-background, #172635);
  --surfaceElements: var(--colorWhite, #ffffff);
  --primary: var(--colorPrimary, #005a8f);
  --primaryLight: var(--colorPrimaryLighten1, #2f7aa7);
  --primaryDark: var(--colorPrimaryDarken1, #004872);
  --primaryDarkHover: #0048724d;
  /* TODO: this is a temporary fix, the use of opacity from Sketch is new and not accounted for in CSS */
  --primaryElementText: var(--colorWhite, #ffffff);
  --inputBackground: var(--colorWhite, #ffffff);
  --inputDark: #080c11;
  /* styles */
  --fontColor: var(--defaultText);
  --fontLowContrastColor: var(--secondaryText);
  --fontInvertedColor: var(--primary);
  --fontInvertedBackgroundColor: var(--backgroundColor);
  --fontLinkColor: var(--primary);
  --fontLinkHoverColor: var(--primaryDark);
  --wcagCompliance: rgba(0, 0, 0, 0.5);
  --criticalBorder: #7f1c1c;
  --colorCritical: var(--statusLightCritical, rgb(255, 42, 4));
  --colorSerious: var(--statusLightSerious, rgb(255, 175, 61));
  --colorCaution: var(--statusLightCaution, rgb(250, 216, 0));
  --colorNormal: var(--statusLightNormal, rgb(0, 226, 0));
  --colorStandby: var(--statusLightStandby, rgb(100, 217, 255));
  --colorOff: var(--statusLightOff, rgb(142, 154, 163));
  /*

    Button Colors
    ==========================================================================
    For standard and outline buttons

  */
  /* Button */
  --buttonTextColor: var(--primaryElementText);
  --buttonBackgroundColor: var(--primary);
  --buttonBorderColor: var(--primary);
  /* Button Hover State */
  --buttonHoverTextColor: var(--primaryElementText);
  --buttonHoverBackgroundColor: var(--primaryDark);
  --buttonHoverBorderColor: var(--primaryDark);
  /* Button Active State */
  --buttonActiveControlTextColor: var(--defaultText);
  --buttonActiveBackgroundColor: var(--primary);
  --buttonActiveBorderColor: var(--primary);
  /* Outline Button Variant */
  --buttonOutlineTextColor: var(--colorPrimary, rgb(0, 90, 143));
  --buttonOutlineBackgroundColor: transparent;
  --buttonOutlineBorderColor: var(--colorPrimary, rgb(0, 90, 143));
  /* Outline Button Variant Hover State */
  --buttonOutlineHoverTextColor: var(--primaryDark);
  --buttonOutlineHoverBackgroundColor: transparent;
  --buttonOutlineHoverBorderColor: var(--primaryDark);
  /*

    Control Colors
    ==========================================================================
    For checkboxes, radio buttons etc …

  */
  --controlTextColor: var(--primaryElementText);
  --controlLabelColor: var(--defaultText);
  --controlBackgroundColor: var(--primary);
  --controlBorderColor: var(--primary);
  --controlAccentColor: var(--primary);
  --controlSelectedTextColor: var(--defaultText);
  --controlSelectedBackgroundColor: transparent;
  --controlSelectedBorderColor: var(--primary);
  --controlHoverOutlineBackgroundColor: none;
  --controlHoverBorderColor: var(--primaryDark);
  --controlSelectedOutlineBorderColor: var(--primary);
  --controlSelectedOutlineBackgroundColor: none;
  /*

    Progress Bar Colors
    ==========================================================================

  */
  --progressDeterminateBarBackgroundColor: var(--primary);
  --progressDeterminateTrackBackgroundColor: var(--inputBackground);
  --progressDeterminateTrackBorderColor: var(--primaryDark);
  --progressIndeterminate: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  /*

    Popup Menu Colors
    ==========================================================================

  */
  --popupMenuBackgroundColor: var(--inputBackground);
  --popupMenuBorderColor: var(--primary);
  --popupMenuTextColor: var(--defaultText);
  --popupCaretBackgroundColor: var(--primary);
  --popupMenuItemBackgroundColor: var(--inputBackground);
  --popupMenuItemHoverBackgroundColor: var(--primaryDark);
  --popupMenuItemHoverTextColor: var(--primaryElementText);
  --popupMenuItemSeperatorBorderColor: var(--defaultText);
  /*

    Slider Colors
    ==========================================================================

  */
  --sliderThumbBackgroundColor: var(--primaryDark);
  --sliderThumbBorderColor: var(--inputBackground);
  --sliderHoverThumbBackgroundColor: var(--primaryDark);
  --sliderHoverThumbBorderColor: var(--inputBackground);
  --sliderTrackBorderColor: var(--secondaryText);
  --sliderTrackBackgroundColor: var(--inputBackground);
  --sliderSelectedThumbBorderColor: var(--primaryLight);
  --sliderSelectedTrackBackgroundColor: var(--primary);
  --sliderThumbBorderSize: 1px;
  --sliderTrackBorderSize: 0.25px;
  /*

    Segmented Button Colors
    ==========================================================================

  */
  --segmentedButtonBorderColor: var(--primary);
  --segmentedButtonBackgroundColor: none;
  --segmentedButtonTextColor: var(--primary);
  /* Segmented Hover */
  --segmentedButtonHoverBackgroundColor: var(--primaryDark);
  --segmentedButtonHoverTextColor: var(--primaryElementText);
  --segmentedButtonHoverBorderColor: var(--primaryDark);
  /* Segmented Select */
  --segmentedButtonSelectedBackgroundColor: var(--primary);
  --segmentedButtonSelectedTextColor: var(--primaryElementText);
  /*

    Drop Down/Select Colors
    ==========================================================================

  */
  --selectHoverOptBackgroundColor: var(--primaryDark);
  --selectCaret: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  /*

    Switch Colors
    ==========================================================================

  */
  --switchOffColor: var(--secondaryText);
  --switchOnColor: var(--primary);
  --switchHoverOnColor: var(--primaryDark);
  --switchHoverOffColor: var(--primaryDark);
  --switchDisabledOnColor: var(--primary);
  --switchDisabledOffColor: var(--secondaryText);
  /*

    Push Button Colors
    ==========================================================================

  */
  --pushbuttonBackgroundColor: none;
  --pushbuttonBorderColor: var(--primary);
  --pushbuttonTextColor: var(--primary);
  --pushbuttonSelectedBackgroundColor: var(--colorNormal);
  --pushbuttonSelectedBorderColor: var(--colorNormal);
  --pushbuttonSelectedTextColor: var(--defaultText);
  /*

    Clock Colors
    ==========================================================================

  */
  --clockTextColor: var(--primaryElementText);
  --clockBackgroundColor: #101923;
  --clockBorderColor: #1b2d3e;
  --clockLabelColor: var(--primaryElementText);
  /*

    Modal Colors
    ==========================================================================

  */
  --modalTitleColor: var(--primaryElementText);
  --modalTextColor: var(--defaultText);
  --modalBackgroundColor: var(--surfaceElements);
  --modalBorderColor: var(--primary);
  /*

    Log Colors
    ==========================================================================

  */
  --logTextColor: var(--defaultText);
  --logBackgroundColor: var(--surfaceElements);
  --logBorderColor: var(--secondaryText);
  --logHeaderTextColor: var(--defaultText);
  --logHeaderBackgroundColor: var(--backgroundColor);
  --logFilterBackgroundColor: var(--primaryLight);
  --logFilterTextColor: var(--primaryElementText);
  /*

    Tree Colors
    ==========================================================================

  */
  --treeTextColor: var(--defaultText);
  --treeBackgroundColor: var(--surfaceElements);
  --treeBorderColor: var(--primaryDark);
  --treeItemBorderColor: var(--primaryDark);
  --treeAccentColor: var(--primary);
  /* Hover */
  --treeHoverBackgroundColor: var(--primaryDark);
  --treeHoverTextColor: var(--primaryElementText);
  --treeHoverAccentColor: var(--primary);
  /* Selected */
  --treeSelectedBackgroundColor: var(--surfaceElements);
  --treeSelectedBorderColor: var(--primaryDark);
  --treeSelectedTextColor: var(--defaultText);
  --treeSelectedAccentColor: var(--primary);
  --treeChildrenBackgroundColor: var(--surfaceElements);
  --treeExpandedBorderColor: var(--backgroundColor);
  /*

    Tab Colors
    ==========================================================================

  */
  --tabTextColor: var(--primary);
  --tabBackgroundColor: transparent;
  --tabBorderColor: transparent;
  --tabHoverTextColor: var(--defaultText);
  --tabSelectedTextColor: var(--defaultText);
  --tabSelectedBorderColor: var(--primary);
  /*

    Notification Colors
    ==========================================================================

	*/
  --notificationTextColor: var(--defaultText);
  /*

    Classification Colors
    ==========================================================================

	*/
  --classificationTextColorLight: var(--primaryElementText);
  --classificationTextColorDark: var(--defaultText);
  /*

    Card Colors
    ==========================================================================

  */
  --cardBackgroundColor: var(--colorQuaternaryLighten2);
  --cardHeaderBackgroundColor: var(--colorQuaternaryLighten1);
  --cardHeaderTextColor: var(--colorWhite, #fff);
  /*

    Input/Text Field Colors
    ==========================================================================

  */
  --inputBackgroundColor: var(--inputBackground);
  --inputBorderColor: var(--primaryLight);
  --inputBorderColorAlt: var(--inputDark);
  --inputBorderColorDisabled: #292a2d;
  --inputTextColor: var(--defaultText);
  --inputFocusBorderColor: var(--primary);
  --inputFocusTextColor: var(--defaultText);
  --inputInvalidBorderColor: var(--colorCritical);
  --inputSearchIcon: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  --inputSearchCancel: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  /*

    Icon Default Colors
    ==========================================================================

	*/
  --iconDefaultColor: var(--primary);
  /*

    Status Symbols
    ==========================================================================

  */
  --statusSymbols: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  /*


    Scrollbar Colors -- Light
    ==========================================================================

  */
  --scrollBarThumbBackgroundColor: var(--colorQuaternaryDarken1, #9ba0aa);
  --scrollBarThumbBackgroundHoverColor: var(--colorQuaternaryDarken2, #676a71);
  --scrollBarTrackBackgroundColor: transparent;
  --scrollBarTrackCornerBackgroundColor: var(--colorQuaternaryLighten4, #f2f4f7);
  /*

    Timeline Colors -- Dark
    ==========================================================================

  */
  --timelineHeaderBackgroundColor: var(--surfaceElements);
  --timelineHeaderTextColor: var(--defaultText);
  --timelineRulerBackgroundColor: var(--surfaceElements);
  --timelineRulerTextColor: var(--defaultText);
  --timelineTrackLabelBackgroundColor: var(--surfaceElements);
  --timelineTrackBackgroundColor: var(--surfaceElements);
  --timelineRegionBackgroundColor: var(--backgroundColor);
  --timelineRegionTextColor: var(--defaultText);
  --timelineRegionBorderColor: var(--primary);
  --timelineRegionSelectedBorderColor: var(--defaultText);
  --timelineRegionSelectedBackgroundColor: var(--primaryDark);
  --timelineRegionSelectedTextColor: var(--primaryElementText);
  --timelineRegionStatusColorNormal: var(--colorNormal);
  --timelineRegionStatusColorCritical: var(--colorCritical);
  --timelineRegionStatusColorSerious: var(--colorSerious);
  --timelineRegionStatusColorCaution: var(--colorCautiom);
  --timelineRegionStatusColorStandby: var(--colorStandby);
  --timelineRegionStatusColorOff: var(--colorOff);
  /*

    ACCORDION COLORS
    ==========================================================================

  */
  --accordionBorderColor: rgb(207, 214, 227);
  --accordionContentBackground: rgb(226, 230, 238);
  --accordionClosedLabelBackground: rgb(255, 255, 255);
  --accordionOpenLabelBackground: rgb(245, 247, 249);
  --accordionHoverLabelBackground: rgb(236, 239, 244);
  --accordionColor: rgb(0, 0, 0);
  /*

    TABLE COLORS
    ==========================================================================

  */
  --tableBorderColor: var(--backgroundColor);
  --tableHeaderBackgroundColor: var(--globalAppHeader);
  --tableHeaderBorderColor: var(--surfaceElements);
  --tableHeaderTextColor: var(--primaryElementText);
  --tableHeaderBoxShadow: 0 0.1rem 0.45rem rgba(0, 0, 0, 0.2);
  --tableHeaderAccentColor: var(--primary);
  --tableRowBackgroundColor: var(--surfaceElements);
  --tableRowBorderColor: var(--backgroundColor);
  --tableRowTextColor: var(--defaultText);
  --tableRowHoverBackgroundColor: var(--primaryDarkHover);
  --tableRowHoverTextColor: var(--defaultText);
  --tableRowSelectedBackgroundColor: var(--backgroundColor);
  --tableRowSelectedBorderColor: var(--primary);
  --tableControlsBackgroundColor: var(--primary);
  --tableFilterBorderColor: var(--primary);
  --tableFilterDisabledBorderColor: var(--backgroundColor);
  --tableFilterDisabledBackgroundColor: var(--surfaceElements);
}

li.light-theme {
  display: none;
}

.dark-theme {
  /*

    Global Colors
    =========================================================================
	*/
  /* Astro 5 Simplified Colors */
  --backgroundColor: var(--color-dark-border, #101923);
  --defaultText: var(--colorWhite, #ffffff);
  --secondaryText: var(--colorTertiaryLighten4, #d4d8dd);
  --globalAppHeader: var(--color-dark-background, #172635);
  --surfaceElements: #1b2d3e;
  /* TODO: this is an unofficial Astro color, but a required KM color */
  --primary: var(--colorSecondary, #4dacff);
  --primaryLight: var(--colorSecondaryLighten2, #92cbff);
  --primaryLightHover: #92cbff4d;
  /* TODO: this is a temporary fix, the use of opacity from Sketch is new and not accounted for in CSS */
  --primaryDark: var(--colorSecondaryDarken1, #3a87cf);
  --primaryDarkHover: #6b8ca5;
  --primaryElementText: var(--colorTertiaryDarken4, #080c11);
  --inputBackground: var(--colorWhite, #ffffff);
  --inputDark: var(--colorTertiaryDarken4, #080c11);
  /* styles */
  --fontColor: var(--defaultText);
  --fontLowContrastColor: var(--secondaryText);
  --fontInvertedColor: var(--primary);
  --fontInvertedBackgroundColor: var(--backgroundColor);
  --fontLinkColor: var(--primary);
  --fontLinkHoverColor: var(--primaryLight);
  /* Status Custom */
  --wcagCompliance: rgba(255, 255, 255, 0);
  --criticalBorder: var(--colorCritical, rgb(255, 56, 56));
  --colorCritical: var(--statusDarkCritical, rgb(255, 42, 4));
  --colorSerious: var(--statusDarkSerious, rgb(255, 175, 61));
  --colorCaution: var(--statusDarkCaution, rgb(250, 216, 0));
  --colorNormal: var(--statusDarkNormal, rgb(0, 226, 0));
  --colorStandby: var(--statusDarkStandby, rgb(45, 204, 255));
  --colorOff: var(--statusDarkOff, rgb(142, 154, 163));
  /*

    Button Colors
    ==========================================================================
    For standard and outline buttons

  */
  /* Button */
  --buttonTextColor: var(--primaryElementText);
  --buttonBackgroundColor: var(--primary);
  --buttonBorderColor: transparent;
  /* Button Hover State */
  --buttonHoverTextColor: var(--primaryElementText);
  --buttonHoverBackgroundColor: var(--primaryLight);
  --buttonHoverBorderColor: transparent;
  /* Button Active State */
  --buttonActiveControlTextColor: var(--defaultText);
  --buttonActiveBackgroundColor: var(--primary);
  --buttonActiveBorderColor: var(--primary);
  /* Outline Button Variant */
  --buttonOutlineTextColor: var(--primary);
  --buttonOutlineBackgroundColor: transparent;
  --buttonOutlineBorderColor: var(--colorPrimary, rgb(0, 90, 143));
  /* Outline Button Variant Hover State */
  --buttonOutlineHoverTextColor: var(--primaryLight);
  --buttonOutlineHoverBackgroundColor: transparent;
  --buttonOutlineHoverBorderColor: var(--primaryLight);
  /*

    Control Colors
    ==========================================================================
    For checkboxes, radio buttons etc …

  */
  --controlTextColor: var(--primaryElementText);
  --controlLabelColor: var(--defaultText);
  --controlBackgroundColor: var(--primary);
  --controlBorderColor: var(--primary);
  --controlAccentColor: var(--primary);
  --controlSelectedTextColor: var(--defaultText);
  --controlSelectedBackgroundColor: var(--primaryDark);
  --controlSelectedBorderColor: var(--primary);
  --controlHoverBorderColor: var(--primaryLight);
  --controlSelectedOutlineBorderColor: var(--primary);
  /*

    Progress Colors
    ==========================================================================

  */
  --progressDeterminateBarBackgroundColor: var(--colorSecondary, rgb(77, 172, 255));
  --progressDeterminateTrackBackgroundColor: rgba(0, 0, 0, 0.3);
  --progressDeterminateTrackBorderColor: var(--primaryDark);
  --progressIndeterminate: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  /*

    Slider Colors
    ==========================================================================

  */
  --sliderThumbBackgroundColor: var(--primaryDark);
  --sliderThumbBorderColor: var(--inputBackground);
  --sliderHoverThumbBackgroundColor: var(--primaryDark);
  --sliderHoverThumbBorderColor: var(--inputBackground);
  --sliderTrackBorderColor: transparent;
  --sliderTrackBackgroundColor: var(--secondaryText);
  --sliderSelectedThumbBorderColor: var(--primaryLight);
  --sliderSelectedTrackBackgroundColor: var(--primary);
  --sliderThumbBorderSize: 1px;
  --sliderTrackBorderSize: 1px;
  /*

    Segmented Button Colors
    ==========================================================================

  */
  --segmentedButtonBorderColor: var(--primary);
  --segmentedButtonBackgroundColor: none;
  --segmentedButtonTextColor: var(--primary);
  /* Segmented Hover */
  --segmentedButtonHoverBackgroundColor: var(--primaryLight);
  --segmentedButtonHoverTextColor: var(--primaryElementText);
  --segmentedButtonHoverBorderColor: var(--primaryLight);
  /* Segmented Select */
  --segmentedButtonSelectedBackgroundColor: var(--primary);
  --segmentedButtonSelectedTextColor: var(--primaryElementText);
  /*

    Drop Down/Select Colors
    ==========================================================================

  */
  --selectHoverOptBackgroundColor: var(--primaryLight);
  /*

    Switch Colors
    ==========================================================================

  */
  --switchOffColor: var(--secondaryText);
  --switchOnColor: var(--primary);
  --switchHoverOnColor: var(--primaryLight);
  --switchHoverOffColor: var(--primaryLight);
  --switchDisabledOnColor: var(--primary);
  --switchDisabledOffColor: var(--secondaryText);
  /*

    Popup Menu Colors
    ==========================================================================

  */
  --popupMenuBackgroundColor: var(--inputBackground);
  --popupMenuBorderColor: var(--primary);
  --popupMenuTextColor: var(--primaryElementText);
  --popupCaretBackgroundColor: var(--primary);
  --popupMenuItemBackgroundColor: var(--primary);
  --popupMenuItemHoverBackgroundColor: var(--primaryLight);
  --popupMenuItemHoverTextColor: var(--primaryElementText);
  --popupMenuItemSeperatorBorderColor: var(--primaryElementText);
  /*

    Pushbutton Colors
    ==========================================================================

  */
  --pushbuttonBackgroundColor: none;
  --pushbuttonBorderColor: var(--primary);
  --pushbuttonTextColor: var(--primary);
  --pushbuttonSelectedBackgroundColor: var(--colorNormal);
  --pushbuttonSelectedBorderColor: var(--colorNormal);
  --pushbuttonSelectedTextColor: var(--primaryElementText);
  /*

    Clock Colors
    ==========================================================================

  */
  --clockTextColor: var(--defaultText);
  --clockBackgroundColor: var(--backgroundColor);
  --clockBorderColor: var(--surfaceElements);
  --clockLabelColor: var(--defaultText);
  /*

    Modal Colors
    ==========================================================================

  */
  --modalTitleColor: var(--primaryElementText);
  --modalTextColor: var(--defaultText);
  --modalBackgroundColor: var(--surfaceElements);
  --modalBorderColor: var(--primary);
  /*

  /*

    Log Colors
    ==========================================================================

  */
  --logTextColor: var(--defaultText);
  --logBackgroundColor: var(--surfaceElements);
  --logBorderColor: var(--backgroundColor);
  --logHeaderTextColor: var(--defaultText);
  --logHeaderBackgroundColor: var(--globalAppHeader);
  --logFilterBackgroundColor: var(--primaryDark);
  --logFilterTextColor: var(--primaryElementText);
  /*

    Tree Colors
    ==========================================================================

  */
  --treeTextColor: var(--defaultText);
  --treeBackgroundColor: var(--surfaceElements);
  --treeBorderColor: var(--primaryDark);
  --treeItemBorderColor: var(--primaryDark);
  --treeAccentColor: var(--primary);
  /* Hover*/
  --treeHoverBackgroundColor: var(--primaryLight);
  --treeHoverTextColor: var(--primaryElementText);
  --treeHoverAccentColor: var(--primary);
  /* Selected */
  --treeSelectedBackgroundColor: var(--surfaceElements);
  --treeSelectedBorderColor: var(--primaryDark);
  --treeSelectedTextColor: var(--defaultText);
  --treeSelectedAccentColor: var(--primary);
  --treeChildrenBackgroundColor: var(--surfaceElements);
  --treeExpandedBorderColor: var(--backgroundColor);
  /*

    Tab Colors
    ==========================================================================

  */
  --tabTextColor: var(--primary);
  --tabBackgroundColor: transparent;
  --tabBorderColor: transparent;
  --tabHoverTextColor: var(--defaultText);
  --tabSelectedTextColor: var(--defaultText);
  --tabSelectedBorderColor: var(--primary);
  /*

    Notification Colors
    ==========================================================================

	*/
  --notificationTextColor: var(--primaryElementText);
  /*

    Classification Colors
    ==========================================================================

	*/
  --classificationTextColorLight: var(--defaultText);
  --classificationTextColorDark: var(--primaryElementText);
  /*

    Card Colors
    ==========================================================================

  */
  --cardBackgroundColor: var(--colorTertiaryDarken1);
  --cardHeaderBackgroundColor: var(--color-dark-border);
  --cardHeaderTextColor: var(--colorWhite, #fff);
  /*

    Input/Text Field Colors
    ==========================================================================

  */
  --inputBackgroundColor: var(--inputBackground);
  --inputBorderColor: var(--surfaceElements);
  --inputBorderColorAlt: var(--inputDark);
  --inputBorderColorDisabled: #292a2d;
  --inputTextColor: var(--primaryElementText);
  /* Input Focus */
  --inputFocusBorderColor: var(--primary);
  --inputFocusTextColor: var(--primaryElementText);
  --inputInvalidBorderColor: var(--colorCritical);
  --inputSearchIcon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  --inputSearchCancel: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  /*

    Icon Default Colors
    ==========================================================================

	*/
  --iconDefaultColor: var(--primary);
  /*

    Status Symbols
    ==========================================================================

  */
  --statusSymbols: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  /*

    Scrollbar Colors -- Dark
    ==========================================================================

  */
  --scrollBarThumbBackgroundColor: var(--colorSecondaryDarken2, rgb(46, 103, 153));
  --scrollBarThumbBackgroundHoverColor: var(--colorSecondaryDarken1, rgb(58, 129, 191));
  --scrollBarTrackBackgroundColor: var(--colorTertiaryDarken1, rgb(32, 50, 70));
  --scrollBarTrackCornerBackgroundColor: var(--colorTertiaryDarken1, rgb(32, 50, 70));
  /*

    Timeline Colors -- Dark
    ==========================================================================

  */
  --timelineHeaderBackgroundColor: var(--surfaceElements);
  --timelineHeaderTextColor: var(--defaultText);
  --timelineRulerBackgroundColor: var(--surfaceElements);
  --timelineRulerTextColor: var(--defaultText);
  --timelineTrackLabelBackgroundColor: var(--surfaceElements);
  --timelineTrackBackgroundColor: var(--surfaceElements);
  --timelineRegionBackgroundColor: var(--backgroundColor);
  --timelineRegionTextColor: var(--defaultText);
  --timelineRegionBorderColor: var(--primary);
  --timelineRegionSelectedBorderColor: var(--inputBackground);
  --timelineRegionSelectedBackgroundColor: var(--primaryDark);
  --timelineRegionSelectedTextColor: var(--defaultText);
  --timelineRegionStatusColorNormal: var(--colorNormal);
  --timelineRegionStatusColorCritical: var(--colorCritical);
  --timelineRegionStatusColorSerious: var(--colorSerious);
  --timelineRegionStatusColorCaution: var(--colorCautiom);
  --timelineRegionStatusColorStandby: var(--colorStandby);
  --timelineRegionStatusColorOff: var(--colorOff);
  /*

    ACCORDION COLORS
    ==========================================================================

  */
  --accordionBorderColor: rgb(40, 63, 88);
  --accordionContentBackground: rgb(20, 32, 44);
  --accordionClosedLabelBackground: rgb(32, 50, 70);
  --accordionOpenLabelBackground: rgb(40, 63, 88);
  --accordionHoverLabelBackground: rgb(46, 103, 153);
  --accordionColor: rgb(255, 255, 255);
  /*

    TABLE COLORS
    ==========================================================================

  */
  --tableBorderColor: var(--backgroundColor);
  --tableHeaderBackgroundColor: var(--globalAppHeader);
  --tableHeaderBorderColor: var(--surfaceElements);
  --tableHeaderTextColor: var(--defaultText);
  --tableHeaderBoxShadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.45);
  --tableHeaderAccentColor: var(--primary);
  --tableRowBackgroundColor: var(--surfaceElements);
  --tableRowTextColor: var(--defaultText);
  --tableRowBorderColor: var(--backgroundColor);
  --tableRowHoverBackgroundColor: var(--primaryLightHover);
  --tableRowHoverTextColor: var(--defaultText);
  --tableRowSelectedBackgroundColor: var(--backgroundColor);
  --tableRowSelectedBorderColor: var(--primary);
  --tableControlsBackgroundColor: var(--primary);
  --tableFilterBorderColor: var(--primary);
  --tableFilterDisabledBorderColor: var(--backgroundColor);
  --tableFilterDisabledBackgroundColor: var(--surfaceElements);
}

li.dark-theme {
  display: none;
}

h1,
h2,
h3 {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-weight: 400;
  color: var(--defaultText);
  margin: 0 0 0.5rem 0;
}

h1,
.h1 {
  font-size: 2.125rem;
}

h2,
.h2 {
  font-size: 1.5rem;
}

h3,
.h3 {
  font-size: 1.25rem;
  font-weight: 500;
}

p {
  margin: 0 0 1rem 0;
  color: var(--defaultText);
}

a {
  color: var(--fontLinkColor);
  text-decoration: none;
}

a:hover {
  color: var(--fontLinkHoverColor);
}

dt {
  font-weight: 600;
  margin: 0;
}

dd {
  margin: 0 0 0.5rem 0;
}

.light {
  font-weight: 300;
}

.regular {
  font-weight: 500;
}

.semi-bold {
  font-weight: 600;
}

.bold {
  font-weight: 700;
}

.italic {
  font-style: italic;
}

.condensed {
  font-stretch: condensed;
}

.monospace {
  font-family: 'Roboto Mono', sans-serif;
}

.invert,
.inverted {
  background-color: var(--fontInvertedBackgroundColor);
  color: var(--fontInvertedColor);
  padding: 0 0.25rem;
}

.low-contrast {
  opacity: 0.2;
}

/* Size Options */
.xl {
  font-size: 1.125rem;
  font-size: var(--fontSizeXL);
}

.lg {
  font-size: 1rem;
  font-size: var(--fontSize);
}

.md {
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
}

.sm {
  font-size: 0.75rem;
  font-size: var(--fontSizeSM);
}

.xs {
  font-size: 0.65rem;
  font-size: var(--fontSizeXS);
}

/*
**	This is as close as we get to a CSS reset in Astro, moving everything to
**	the old IE border-box model of including padding in the overall size.
*/
html {
  box-sizing: border-box;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

/*
**
**
**
*/
body {
  margin: 0;
  padding: 0;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-size: 1rem;
  color: white;
  color: var(--fontColor, white);
  background-color: var(--backgroundColor);
  scrollbar-color: var(--scrollBarThumbBackgroundColor) var(--scrollBarTrackCornerBackgroundColor);
}

label {
  user-select: none;
}

/*
** CSS-styled Scrollbars for IE & Webkit browsers
** Dark theme by default.
**
*/
::-webkit-scrollbar {
  width: 18px;
  height: 18px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #2e6799;
  background-color: var(--scrollBarThumbBackgroundColor, #2e6799);
  border-radius: 10px;
  border: 3px solid transparent;
  background-clip: padding-box;
}

/* visually "centers" because the dark edge of the shadow gives the illusion this is offset */
::-webkit-scrollbar-thumb:vertical {
  border-left-width: 4px;
}

::-webkit-scrollbar-thumb:horizontal {
  border-top-width: 4px;
}

::-webkit-scrollbar-thumb:active,
::-webkit-scrollbar-thumb:hover {
  background-color: #3a81bf;
  background-color: var(--scrollBarThumbBackgroundHoverColor, #3a81bf);
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-corner {
  background-color: #203246;
  background-color: var(--scrollBarTrackCornerBackgroundColor, #203246);
}

::-webkit-scrollbar-track:vertical {
  box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.15);
}

::-webkit-scrollbar-track:horizontal {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);
}

/*
**
** 	ASTRO BUTTON
** 	==========================================================================
**  3.0 Notes
**  - Removed Master Off Button Style
**  - Replaced various properties with css custom properties to support
**  - Removed .satcom class definition
**  - Removed narrow/short definitions
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Disabled user selection of text on all buttons
**	- Removed redundant background hover from 'disabled' state by using :not() on the :hover state
** 	- Removed redundant background hover from 'master off' by using :not() on the :hover state // deprecate after 1.4
**  - Fixed Firefox alignment issue where text was misaligned vertically
**  - Renamed half-height to short and half-width to narrow (Note: rux_ only, satcom_ retains old syntax)
**  - Removed user-select and placed it in astro.css to apply to all input types
**  - Embedded master off icon and removed the additional states required to handle icons and gradient backgrounds
*/
.rux-button-group {
  display: flex;
  margin-left: auto;
  align-self: flex-end;
}

.rux-button-group .rux-button:not(:last-child) {
  margin-right: 0.625rem;
}

/* Global Button Styles */
.rux-button {
  display: flex;
  position: relative;
  margin: 0;
  padding: 0 1rem;
  height: 2.125rem;
  min-width: 2.25rem;
  border-radius: 3px;
  border-radius: var(--buttonBorderRadius);
  color: var(--buttonTextColor);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: center;
  align-items: center;
  user-select: none;
}

/*

  Disabled States

*/
/* disabled state */
.rux-button:disabled {
  opacity: 0.4;
  opacity: var(--disabledOpacity);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-button:focus {
  outline: none;
}

.rux-button:not(.rux-button--outline) {
  border: 1px solid var(--buttonBorderColor);
  background-color: var(--buttonBackgroundColor);
}

/* Outline Button Specific Styles */
.rux-button--outline {
  color: var(--buttonOutlineTextColor);
  background-color: var(--buttonOutlineBackgroundColor);
  border: 1px solid var(--buttonOutlineBorderColor);
}

/*

  Press/Active States

*/
.rux-button:active:not([hover]):not([disabled]) {
  border-color: var(--buttonActiveBorderColor) !important;
  background-color: var(--buttonActiveBackgroundColor) !important;
}

.rux-button--outline:active:not([hover]):not([disabled]) {
  border-color: var(--buttonOutlineBorderColor) !important;
  background-color: var(--buttonOutlineBackgroundColor) !important;
}

/*

  Hover States

*/
.rux-button:hover:not([active]):not([disabled]):not(.rux-button--outline) {
  border-color: var(--buttonHoverBorderColor);
  background-color: var(--buttonHoverBackgroundColor);
}

.rux-button--outline:hover:not([disabled]) {
  color: var(--buttonOutlineTextColor);
  background-color: var(--buttonOutlineHoverBackgroundColor);
  border-color: var(--buttonOutlineHoverBorderColor);
}

/*

  Icons

*/
.rux-button--small {
  font-size: 0.875rem;
  font-size: var(--smallLabelFontSize);
  height: 1.625rem;
  padding: 0 1rem;
  line-height: 1;
}

.rux-button--large {
  font-size: 1.125rem;
  font-size: var(--largeLabelFontSize);
  height: 2.875rem;
  min-width: 3rem;
  padding: 0 1rem;
}

.rux-button__icon {
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 0.625rem;
  margin-left: -0.625rem;
}

.rux-button--icon-only .rux-button__icon {
  margin-left: -0.625rem;
  margin-right: -0.625rem;
}

.rux-button--large.rux-button--icon-only .rux-button__icon {
  margin-left: -1rem;
  margin-right: -1rem;
}

.rux-button--small .rux-button__icon {
  height: 0.875rem;
  width: 0.875rem;
}

.rux-button--large .rux-button__icon {
  height: 1.75rem;
  width: 1.75rem;
  margin-left: -0.8rem;
}

.rux-button__icon .rux-icon {
  height: auto;
  width: 100%;
  fill: var(--buttonTextColor);
  color: var(--buttonTextColor);
}

.rux-button.rux-button--critical,
.rux-button.rux-button--critical:active:not([hover]):not([disabled]):not(.rux-button--outline) {
  background-color: rgb(204, 45, 45) !important;
  background-color: var(--colorCriticalDarken1) !important;
  border-color: rgb(204, 45, 45) !important;
  border-color: var(--colorCriticalDarken1) !important;
}

.rux-button.rux-button--critical:hover:not([active]):not([disabled]) {
  background-color: var(--colorCritical);
  border-color: var(--colorCritical);
}

.rux-card {
  background-color: #1e2f42;
  background-color: var(--cardBackgroundColor, #1e2f42);
  padding: 1px;
  overflow: hidden;
}

.rux-card__header {
  color: white;
  color: var(--cardHeaderTextColor, white);
  background-color: #14202c;
  background-color: var(--cardHeaderBackgroundColor, #14202c);
  margin: 0;
  padding: 0.325rem 0.625rem;
  display: flex;
  align-items: center;
}

.rux-card__header h1 {
  padding: 0;
  margin: 0;
  font-size: 1.75rem;
}

.rux-card__content {
  padding: 0.625rem;
}

/*
**
** 	ASTRO CHECKBOX BUTTON
** 	==========================================================================
**  3.0 Notes
**  - Added Custom CSS Properties to support light/dark theming
**  - Added fallback properties for IE11
**  2.0 Notes
**  - Removed hand cursor on checkbox
**  - Updated styles to Astro 2.0
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**  - Added line-height to label to fix minor alignment issue
**  - Moved user-select to parent element
**  - Removed user-select and placed it in astro.css to apply to all input types
*/
.rux-checkbox {
  display: flex;
  position: relative;
  margin: 0 0 1rem 0;
  line-height: 1.2;
}

.rux-checkbox input[type='checkbox'] {
  -webkit-appearance: none;
  display: none;
}

.rux-checkbox input[type='checkbox']+label {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--controlLabelColor);
  letter-spacing: 0.5px;
  cursor: pointer;
}

/* Box */
.rux-checkbox input[type='checkbox']+label::before {
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  content: '';
  align-self: start;
  height: 1.125rem;
  height: var(--controlOptionSize);
  width: 1.125rem;
  width: var(--controlOptionSize);
  margin: 0 0.625rem 0 0;
  border: 1px solid var(--controlBorderColor);
  border-radius: 2px;
}

.rux-checkbox input[type='checkbox']:checked+label::before {
  background-color: var(--primary);
  border-color: var(--controlSelectedOutlineBorderColor);
}

.rux-checkbox input[type='checkbox']:not(:disabled):hover+label:before,
.rux-checkbox input[type='checkbox']:not(:disabled):checked:hover+label:before {
  border-color: var(--controlHoverBorderColor);
}

.rux-checkbox input[type='checkbox']:not(:disabled):checked:hover+label:before {
  background-color: var(--controlHoverBorderColor);
}

/* Checkmark */
.rux-checkbox input[type='checkbox']:checked+label::after {
  position: absolute;
  top: 5px;
  display: flex;
  content: '';
  height: 6px;
  width: 12px;
  left: 3px;
  border-right: 2px solid var(--controlTextColor);
  border-top: 2px solid var(--controlTextColor);
  transform: rotate(125deg);
}

.rux-checkbox--indeterminate input[type='checkbox']:checked+label::after {
  width: 10px;
  height: 5px;
  transform: rotate(0deg);
  border-right: 0px;
  border-top: 0px;
  border-bottom: 2px solid var(--controlTextColor);
  left: 4px;
}

.rux-checkbox input[type='checkbox']:disabled+label {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
  opacity: 0.4;
  opacity: var(--disabledOpacity);
}

.rux-form-element {
  display: flex;
  align-items: baseline;
}

.rux-form-element label {
  color: white;
}

.rux-form__invalid {
  border: 1px solid var(--colorCritical);
  border-left-width: 20px;
  color: var(--colorCritical);
  padding: 20px 10px;
  background-color: var(--inputBackground);
}

.rux-form__invalid p {
  line-height: 100%;
  text-align: left;
  vertical-align: middle;
  color: var(--colorCritical);
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-weight: bold;
  margin: 0;
  padding-left: 1.625rem;
  width: fit-content;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: 1rem;
  background-position: center left 0rem;
}

.rux-help-text {
  color: var(--secondaryText);
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-weight: normal;
  letter-spacing: 0.5px;
}

.rux-form-field .rux-help-text {
  -webkit-order: 3;
  order: 3;
  margin-top: 0.625rem;
}

.rux-error-text {
  color: var(--colorCritical);
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-weight: bold;
}

.rux-form-field .rux-error-text,
.rux-select+.rux-error-text {
  padding-left: 1.625rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-size: 1rem;
  background-position: center left 0rem;
  text-align: left;
  width: fit-content;
  -webkit-order: 3;
  order: 3;
  margin-top: 0.625rem;
}

/*
**
** 	ASTRO INPUT TEXT FIELDS
** 	==========================================================================
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**  - Updated text entry field to WCAG
*/
/*
**
** 	INPUT TEXT
** 	==========================================================================
*/
/* 	REQUIRED CLASSES */
.rux-form-field {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-size: 1rem;
  font-size: var(--fontSize);
  color: var(--fontColor);
}

.rux-form-field input:required+label::after {
  content: '*';
  margin-left: 0.25rem;
  color: var(--inputTextColor);
}

.rux-form-field__label {
  display: flex;
  order: 1;
  margin: 0 0 0.15rem 0;
  width: 100%;
  align-content: center;
  align-items: center;
  color: var(--defaultText);
  user-select: none;
}

.rux-form-field input {
  box-sizing: border-box;
  order: 2;
  height: 2.125rem;
  width: 100%;
  padding: 0 0.625rem;
  border: 1px solid var(--inputBorderColor);
  border-radius: 4px;
  font-size: 1rem;
  font-size: var(--fontSize, 1rem);
  color: var(--inputTextColor);
}

.rux-form-field textarea {
  box-sizing: border-box;
  -webkit-order: 2;
  order: 2;
  min-height: 4.25rem;
  width: 100%;
  padding: 0.5rem;
  border: 1px solid transparent;
  border: 1px solid var(--inputBorderColor);
  border-radius: 3px;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-size: 1rem;
  font-size: var(--fontSize, 1rem);
  color: black;
  color: var(--inputTextColor);
}

/* input */
.rux-form-field input::-webkit-input-placeholder,
.rux-form-field input::-moz-placeholder,
.rux-form-field input:-ms-input-placeholder,
.rux-form-field textarea::-webkit-input-placeholder,
.rux-form-field textarea::-moz-placeholder,
.rux-form-field textarea:-ms-input-placeholder {
  font-size: 1rem;
  font-weight: normal;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
}

.rux-form-field input[type='date']::-webkit-inner-spin-button,
.rux-form-field input[type='date']::-webkit-outer-spin-button,
.rux-form-field input[type='date']::-webkit-calendar-picker-indicator {
  -webkit-appearance: none;
  display: none;
}

/* VALIDATION */
.rux-form-field input:invalid {
  border: 1px solid var(--inputInvalidBorderColor);
}

/* FOCUS RULES */
.rux-form-field input:not([type='search']):focus,
.rux-form-field input:not([type='search']):invalid:focus {
  border: 1px solid var(--inputFocusBorderColor) !important;
}

.rux-form-field input::selection {
  background-color: rgb(184, 222, 255);
  background-color: var(--colorSecondaryLighten3);
}

.rux-form-field__validation-message {
  display: none;
  position: absolute;
  max-width: 16rem;
  background-color: var(--colorCritical);
  width: 100%;
  padding: 0.25rem;
  right: 0;
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
}

.rux-form-field input:invalid .rux-form-field__validation-message {
  display: block;
}

.rux-form-field input:disabled {
  opacity: 0.4;
  opacity: var(--disabledOpacity);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-form-field--large,
.rux-form-field--large label,
.rux-form-field--large input,
.rux-form-field--large textarea {
  font-size: 1.125rem;
  font-size: var(--fontSizeXL);
}

.rux-form-field--small,
.rux-form-field--small label,
.rux-form-field--small input,
.rux-form-field--small textarea {
  font-size: 0.875rem;
  font-size: var(--fontSizeMD);
}

.rux-form-field--large input,
.rux-form-field--large textarea {
  padding: 0.5rem;
}

.rux-form-field--large input {
  height: 2.5rem;
}

.rux-form-field--small input,
.rux-form-field--small textarea {
  padding: 0.3rem;
}

.rux-form-field--small input {
  height: 1.625rem;
}

.rux-form-field--large input:invalid {
  background-size: 1.375rem;
  background-position: center right 0.5rem;
  padding: 0.5rem 1.875rem 0.5rem 0.5rem;
}

.rux-form-field input:focus,
.rux-form-field input:invalid:focus,
.rux-form-field textarea:focus {
  border-color: var(--inputFocusBorderColor);
  outline: none;
  color: var(--inputFocusTextColor);
}

.rux-form-field input[type='search']::-webkit-search-decoration {
  -webkit-appearance: textfield;
}

/* SEARCH VARIANT */
.rux-form-field input[type='search'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 0.5rem 0.5rem 0.5rem 2rem;
  background: var(--inputBackgroundColor) var(--inputSearchIcon) 10px/0.975rem no-repeat;
}

.rux-form-field--large input[type='search'] {
  padding: 0.5rem 0 0.5rem 2rem;
}

.rux-form-field--small input[type='search'] {
  padding: 0.3rem 0 0.3rem 2rem;
}

.rux-form-field input[type='search']::-webkit-search-cancel-button {
  position: relative;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  background-image: var(--inputSearchCancel);
  background-repeat: no-repeat;
}

.rux-form-field input[type='search']::-ms-clear {
  position: relative;
  right: 0.25rem;
  width: 20px;
  height: 20px;
  background-color: var(--inputInvalidBorderColor);
}

/*
**
** 	ASTRO RADIO BUTTONS
** 	==========================================================================
**  3.0 Notes
**  - Added Custom CSS Properties to support light/dark theming
**  - Added fallback properties for IE11
**  2.0 Notes
**  - Removed hand cursor on checkbox
**  - Updated styles to Astro 2.0
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**  - Added line-height to label to fix minor alignment issue
**  - Moved user-select to parent element
**  - Removed user-select and placed it in astro.css to apply to all input types
*/
.rux-radio-button {
  display: flex;
  position: relative;
  margin: 0 0 1rem 0;
  line-height: 1.2;
}

.rux-radio-button input[type='radio'] {
  -webkit-appearance: none;
  display: none;
}

.rux-radio-button input[type='radio']+label {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--controlLabelColor);
  letter-spacing: 0.5px;
  cursor: pointer;
}

.rux-radio-button input[type='radio']+label::before {
  display: flex;
  flex-shrink: 0;
  flex-grow: 0;
  content: '';
  align-self: start;
  height: 1.125rem;
  height: var(--controlOptionSize);
  width: 1.125rem;
  width: var(--controlOptionSize);
  margin: 0 0.625rem 0 0;
  border: 1px solid var(--controlBorderColor);
  border-radius: 100%;
  background-color: transparent;
}

.rux-radio-button input[type='radio']:checked+label::before {
  background-color: var(--controlSelectedOutlineBackgroundColor);
  border-color: var(--controlSelectedOutlineBorderColor);
}

.rux-radio-button input[type='radio']:not(:disabled):hover+label:before,
.rux-radio-button input[type='radio']:not(:disabled):checked:hover+label:before {
  border-color: var(--controlHoverBorderColor);
}

.rux-radio-button input[type='radio']:not(:disabled):checked:hover+label:after {
  background-color: var(--controlHoverBorderColor);
}

.rux-radio-button input[type='radio']:checked+label::after {
  position: absolute;
  top: 5px;
  display: flex;
  content: '';
  left: 5px;
  height: 8px;
  width: 8px;
  border-radius: 100%;
  background-color: var(--primary);
}

.rux-radio-button input[type='radio']:disabled+label {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
  opacity: 0.4;
  opacity: var(--disabledOpacity);
}

/*
**
** 	ASTRO SELECT
** 	==========================================================================
**	2.0.1 Notes
*/
.rux-select {
  --selectInactiveCaret: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --selectActiveCaret: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  position: relative;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid var(--inputBorderColorAlt);
  border-radius: 3px;
  border-radius: var(--buttonBorderRadius);
  color: var(--inputDark);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
  font-weight: normal;
  font-size: 1rem;
  padding: 0.438rem 3.125rem 0.438rem 0.5rem;
  background-color: var(--inputBackground);
  background-image: var(--selectInactiveCaret);
  background-position: center right 0.625rem;
  background-repeat: no-repeat;
  user-select: none;
}

.rux-select .rux-select optgroup,
.rux-select option {
  color: var(--inputDark);
  background-color: var(--inputBackground);
}

.rux-select .rux-select optgroup:hover,
.rux-select option:hover {
  background-color: var(--selectHoverOptBackgroundColor);
}

.rux-select:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  border-color: var(--inputBorderColorDisabled);
}

.rux-select:disabled:hover {
  cursor: not-allowed;
}

.rux-select:focus {
  outline: none;
  border: 1px solid var(--primary);
  border-radius: 3px;
  border-radius: var(--buttonBorderRadius);
}

.rux-select:active:not(:disabled) {
  background-image: var(--selectActiveCaret);
}

.rux-select:hover {
  cursor: pointer;
}

.rux-select::-ms-expand {
  display: none;
}

.rux-select:focus::-ms-value {
  background: transparent;
}

.rux-select:invalid {
  border: 1px solid var(--inputInvalidBorderColor);
}

/*
**
** 	TABLE
** 	==========================================================================
*/
.rux-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px;
  color: var(--tableRowTextColor);
  border-style: solid;
  border-width: 1px;
  border-color: var(--tableBorderColor);
  background: var(--tableRowBackgroundColor);
  text-align: left;
  overflow: scroll;
}

.rux-table__column-head th,
.rux-table th {
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: var(--tableHeaderBorderColor);
  background: var(--tableHeaderBackgroundColor);
  color: var(--tableHeaderTextColor);
  font-size: 1.125rem;
  font-size: var(--fontSizeXL);
  font-weight: 400;
  height: 2.625rem;
  padding: 0.625rem 1rem;
  white-space: nowrap;
}

.rux-table__column-head {
  box-shadow: var(--tableHeaderBoxShadow);
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: var(--tableHeaderBorderColor);
}

.rux-table tr[data-selected],
.rux-table tr.selected {
  background: var(--tableRowSelectedBackgroundColor);
}

.rux-table tr[data-selected] td,
.rux-table tr.selected td {
  border-color: var(--tableRowSelectedBorderColor);
}

.rux-table tr:hover:not([data-selected]),
.rux-table tr.selected:hover:not([data-selected]) {
  background: var(--tableRowHoverBackgroundColor);
  color: var(--tableRowHoverTextColor);
}

.rux-table td {
  border-width: 1px 0;
  border-style: solid;
  border-color: var(--tableRowBorderColor);
  padding: 0.625rem 1rem;
  white-space: nowrap;
}

.rux-table__column-head th:first-child,
.rux-table th:first-child,
.rux-table td:first-child {
  padding-left: 1.875rem;
}

.rux-table__column-head th:last-child,
.rux-table th:last-child,
.rux-table td:last-child {
  padding-right: 1.875rem;
}

.rux-table .rux-checkbox {
  margin: 0;
}

.rux-table .rux-checkbox input[type='checkbox']:checked+label::before,
.rux-table .rux-radio-button input[type='radio']:checked+label::before {
  background-color: var(--controlBackgroundColor);
  border-color: var(--controlBorderColor);
}

.rux-table .rux-checkbox input[type='checkbox']:checked+label::after,
.rux-table .rux-radio-button input[type='radio']:checked+label::after {
  border-color: var(--inputBackground);
}

.rux-table tr:hover .rux-checkbox input[type='checkbox']:not(:checked)+label::before,
.rux-table tr:hover .rux-checkbox input[type='radio']+label::before {
  border-color: var(--controlSelectedBorderColor);
}

.rux-advanced-status {
  position: relative;
  margin: 0 0.75rem;
  line-height: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.rux-advanced-status__icon-group {
  position: relative;
  display: flex;
  justify-content: center;
  max-width: 6.25rem;
  min-width: 4rem;
  /* fauxicon grid. Usefull for gross alignment */
}

.rux-advanced-status__status-icon {
  margin: 0 2px 0 auto;
  order: 1;
}

.rux-advanced-status__icon {
  order: 2;
  margin: 0 auto;
}

.rux-advanced-status__icon::before {
  content: '';
  display: block;
  position: relative;
  margin-bottom: -12px;
  margin-left: -18px !important;
  height: 16px;
  width: 16px;
}

.rux-advanced-status__badge:empty {
  display: none;
}

.rux-advanced-status__badge {
  display: block;
  z-index: 2;
  order: 3;
  position: absolute;
  bottom: -0.75rem;
  right: -0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 3px;
  padding: 0.65rem 0.25rem;
  font-size: 0.775rem;
  text-align: center;
  color: #fff;
  background-color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rux-advanced-status__label {
  text-align: center;
  color: white;
  color: var(--fontColor, white);
  font-size: 0.875rem;
  line-height: 1.2;
  margin-top: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 6.25rem;
  white-space: nowrap;
}

.rux-advanced-status__label__sub-label {
  font-size: 0.65em;
  color: rgba(255, 255, 255, 0.6);
  display: block;
}

.rux-clock {
  display: flex;
  color: var(--clockTextColor);
  font-size: 1.15rem;
}

.rux-clock__segment {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rux-clock__segment__value {
  display: flex;
  align-items: center;
  font-family: 'Roboto Mono', monospace;
  font-family: var(--fontFamilyMono);
  font-weight: 700;
  border: 1px solid var(--clockBorderColor);
  background-color: var(--clockBackgroundColor);
  margin-bottom: 0.25rem;
  white-space: nowrap;
  overflow-y: hidden;
  text-overflow: ellipsis;
}

.rux-clock--small .rux-clock__segment__value {
  height: 2.75rem;
  padding: 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 500;
}

.rux-clock__day-of-the-year .rux-clock__segment__value {
  border-right: none;
}

.rux-clock:not(.rux-clock--small) .rux-clock__segment__value {
  font-size: 1.75rem;
  height: 2.75rem;
  padding: 0 0.75rem;
}

.rux-clock__segment__label {
  font-size: 0.875rem;
  color: var(--clockLabelColor);
}

.rux-clock__aos {
  margin-left: 1em;
}

.rux-clock__los {
  margin-left: 0.5em;
}

.rux-icon {
  margin: 0 auto;
  width: 2.8rem;
  height: 2.8rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  fill: var(--iconDefaultColor);
  -webkit-mask-size: cover;
  mask-size: cover;
}

.rux-icon svg {
  fill: var(--iconDefaultColor);
}

i.rux-icon {
  display: block;
  width: 2.8rem;
  height: 2.8rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
}

.rux-log {
  display: block;
  font-size: 1rem;
  background-color: var(--logBackgroundColor);
}

.rux-log-header {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: var(--logHeaderBackgroundColor);
}

.rux-log-header-title {
  margin: 0 0 1rem 0;
  display: none;
  font-size: 1.25rem;
  font-weight: 300;
}

.rux-log__header-labels {
  display: flex;
  width: 100%;
  color: var(--logHeaderTextColor);
}

.rux-log__header-labels,
.rux-log__events {
  padding: 0;
  margin: 0;
  list-style: none;
}

.rux-log__header-labels,
.rux-log__log-event {
  display: flex;
  align-content: flex-start;
}

.rux-log__events {
  height: 100%;
  overflow-y: scroll;
}

.log-event__timestamp {
  flex-shrink: 0;
  text-align: left;
  width: 5rem;
}

.rux-log__log-event {
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--logBorderColor);
}

.rux-log__log-event:last-child {
  border-bottom: none;
}

.rux-log__header-labels li:not(:first-child),
.rux-log__log-event>* {
  margin: 0 0.5rem;
}

.rux-log__header-labels li:first-child {
  margin: 0 0.5rem 0 0;
}

.rux-log__log-event .log-event__timestamp {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
}

.log-event__status {
  flex-grow: 0;
  flex-shrink: 0;
  text-align: center;
  width: 1rem;
  overflow: hidden;
}

.log-event__message {
  flex-grow: 1;
  text-align: left;
}

.log-header__message {
  display: flex;
  justify-content: space-between;
}

.rux-log__filter-enabled {
  position: sticky;
  top: 0;
  left: 0;
  align-content: center;
  color: var(--logFilterTextColor);
  background-color: var(--logFilterBackgroundColor);
  padding: 0.5rem;
}

.rux-log__filter-enabled .rux-icon {
  margin-right: 0.5rem;
}

.rux-modal {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--modalBackgroundColor);
  width: 28rem;
  height: 13.5rem;
  border: 2px solid var(--modalBorderColor);
  border-radius: 4px;
  margin: auto;
  padding: 0;
  user-select: none;
  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.2);
}

.rux-modal__titlebar {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 2rem;
  background-color: var(--modalBorderColor);
  user-select: none;
  cursor: move;
}

.rux-modal__titlebar h1 {
  font-size: 1rem;
  font-weight: 600;
  padding: 0;
  margin: 0;
  line-height: 1.2;
  color: var(--modalTitleColor);
}

.rux-modal__content {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 1rem;
  color: var(--defaultText);
}

.rux-modal__message {
  margin: 0.5rem 1.875rem 2.5rem 1.875rem;
}

.rux-modal .rux-button {
  box-shadow: none !important;
}

/*
**
** 	ASTRO NOTIFICATION
** 	==========================================================================
**	2.0 Notes
**
*/
.rux-notification {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  flex-grow: 1;
  align-items: center;
  align-content: center;
  top: -4.25rem;
  left: 0;
  height: 4.375rem;
  width: 100%;
  padding: 0.7rem 1.25rem;
  background-color: rgb(87, 214, 255);
  background-color: var(--colorStandbyLighten1);
  transition: all 0.5s ease;
  box-sizing: border-box;
  font-size: 1.125rem;
  font-size: var(--fontSizeXL);
  color: var(--notificationTextColor);
}

.rux-notification::after {
  position: relative;
  display: block;
  content: '';
  height: 60px;
}

.visible {
  margin-top: 0;
}

.notification-buffer.show {
  margin-top: 0;
}

.show .rux-notification-container {
  top: 0;
}

.show .rux-notification-buffer {
  height: 60px;
}

.rux-notification_close-button {
  border: 3px solid rgb(36, 163, 204);
  border: 3px solid var(--colorStandbyDarken1);
  color: rgb(36, 163, 204);
  color: var(--colorStandbyDarken1);
  background-color: transparent;
  height: 2.2rem;
  width: 2.2rem;
  border-radius: 50%;
  position: relative;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rux-notification_close-button::after,
.rux-notification_close-button::before {
  display: block;
  position: absolute;
  height: 2px;
  width: 66%;
  margin-left: -32%;
  margin-top: -1px;
  content: '';
  background-color: rgb(36, 163, 204);
  background-color: var(--colorStandbyDarken1);
}

@supports (--css: variables) {

  .rux-notification_close-button::after,
  .rux-notification_close-button::before {
    margin: 0;
  }
}

.rux-notification_close-button::after {
  transform: rotate(-45deg);
}

.rux-notification_close-button::before {
  transform: rotate(45deg);
}

/* Critical Variant */
.rux-notification--critical {
  background-color: rgb(255, 96, 96);
  background-color: var(--colorCriticalLighten1);
}

.rux-notification--critical .rux-notification_close-button {
  border-color: rgb(204, 45, 45);
  border-color: var(--colorCriticalDarken1);
}

.rux-notification--critical .rux-notification_close-button::after,
.rux-notification--critical .rux-notification_close-button::before {
  background-color: rgb(204, 45, 45);
  background-color: var(--colorCriticalDarken1);
}

/* Caution Variant */
.rux-notification--caution {
  background-color: rgb(253, 237, 97);
  background-color: var(--colorCautionLighten1);
}

.rux-notification--caution .rux-notification_close-button {
  border-color: rgb(202, 186, 46);
  border-color: var(--colorCautionDarken1);
}

.rux-notification--caution .rux-notification_close-button::after,
.rux-notification--caution .rux-notification_close-button::before {
  background-color: rgb(202, 186, 46);
  background-color: var(--colorCautionDarken1);
}

/* Normal Variant */
.rux-notification--normal {
  background-color: rgb(154, 246, 102);
  background-color: var(--colorNormalLighten2);
}

.rux-notification--normal .rux-notification_close-button {
  border-color: rgb(69, 192, 0);
  border-color: var(--colorNormalDarken1);
}

.rux-notification--normal .rux-notification_close-button::after,
.rux-notification--normal .rux-notification_close-button::before {
  background-color: rgb(69, 192, 0);
  background-color: var(--colorNormalDarken1);
}

/* Info Variant */
.rux-notification--info {
  background-color: rgb(87, 214, 255);
  background-color: var(--colorStandbyLighten1);
}

.rux-notification--info .rux-notification_close-button {
  border-color: rgb(36, 163, 204);
  border-color: var(--colorStandbyDarken1);
}

.rux-notification--info .rux-notification_close-button::after,
.rux-notification--info .rux-notification_close-button::before {
  background-color: rgb(36, 163, 204);
  background-color: var(--colorStandbyDarken1);
}

/*
**
** 	ASTRO POP-UPS
** 	==========================================================================
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed transform
**  - Updated colors to WCAG
*/
/* 	REQUIRED CLASSES */
.rux-pop-up {
  font-size: 1rem;
  display: inline-block;
  margin: 1em;
  min-width: 15em;
  position: relative;
  border: 1px solid rgb(77, 172, 255);
  border: 1px solid var(--colorSecondary);
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
  border-radius: 3px;
}

.rux-pop-up ul {
  position: relative;
  list-style: none;
  padding: 0;
  margin: 0;
  background: none;
  background-color: rgb(255, 255, 255);
  background-color: var(--colorWhite);
  border-radius: 2px;
  z-index: 2;
}

.rux-pop-up a {
  display: block;
  padding: 0.5em;
  color: var(--popupMenuTextColor);
  text-decoration: none;
  min-width: 15em;
  max-width: 20em;
}

.rux-pop-up a:hover,
.rux-pop-up li:hover {
  background-color: rgb(184, 222, 255);
  background-color: var(--colorSecondaryLighten3);
  color: var(--popupMenuItemHoverTextColor);
}

.rux-pop-up li:first-child a {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

.rux-pop-up li:last-child a {
  border: none;
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
}

.rux-pop-up--top {
  border-top: 3px solid rgb(77, 172, 255);
  border-top: 3px solid var(--colorSecondary);
}

.rux-pop-up--top::before {
  content: '';
  display: block;
  position: absolute;
  width: 1.1875rem;
  height: 1.1875rem;
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
  z-index: 1;
  margin: -12px 0 0 16px;
  transform: rotate(45deg);
}

.rux-pop-up--bottom {
  border-bottom: 3px solid rgb(77, 172, 255);
  border-bottom: 3px solid var(--colorSecondary);
}

.rux-pop-up--bottom::after {
  content: '';
  display: block;
  position: absolute;
  border-bottom: 1px solid rgb(77, 172, 255);
  border-bottom: 1px solid var(--colorSecondary);
  border-right: 1px solid rgb(77, 172, 255);
  border-right: 1px solid var(--colorSecondary);
  width: 1.1875rem;
  height: 1.1875rem;
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
  margin: -7px 0 0 16px;
  transform: rotate(45deg);
}

.rux-pop-up--left {
  border-left: 3px solid rgb(77, 172, 255);
  border-left: 3px solid var(--colorSecondary);
}

.rux-pop-up--left::before {
  content: '';
  display: block;
  position: absolute;
  border-bottom: 1px solid rgb(77, 172, 255);
  border-bottom: 1px solid var(--colorSecondary);
  border-left: 1px solid rgb(77, 172, 255);
  border-left: 1px solid var(--colorSecondary);
  width: 1.1875rem;
  height: 1.1875rem;
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
  margin: 16px 0 0 -12px;
  transform: rotate(45deg);
}

.rux-pop-up--right {
  border-right: 3px solid rgb(77, 172, 255);
  border-right: 3px solid var(--colorSecondary);
}

.rux-pop-up--right::before {
  content: '';
  display: block;
  position: absolute;
  border-top: 1px solid rgb(77, 172, 255);
  border-top: 1px solid var(--colorSecondary);
  border-right: 1px solid rgb(77, 172, 255);
  border-right: 1px solid var(--colorSecondary);
  width: 1.1875rem;
  height: 1.1875rem;
  background-color: rgb(77, 172, 255);
  background-color: var(--colorSecondary);
  right: 0;
  margin: 16px -12px 0 0;
  transform: rotate(45deg);
}

/*
**
** 	ASTRO PROGRESS
** 	==========================================================================
**	2.0 Notes
**  - Updated indeterminate progress to use animated SVG and the :indeterminate pseudo class
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**  - In addition to rux_ added the correct spelling of indeterminate as an additional selector
**  - Combined indeterminate and determinate progress styles
**  - DETERMINATE
**  - Made container a flex element
**  - Made percentage readout have an appropriate margin (NOTE: without a text rep the progress bar will scale to full width. Flexbox is neat.
**  - Fixed alignment issue in Safari/Chrome where the progress bar was 2-3 pixels too low
**  - Fixed width (on Chrome/Safari) of 100% width progress bar expanding past the border of the track
**  - INDETERMINATE
**  - Removed prefixed animation. Safari 8 was the last browser that required it
**  - [REMOVED] Embeded SVG graphics embeded SVG graphic stopped working
**  -
**  - !! NOTE !!
**  - The whole progress bar needs a rewrite. Better native elements and CSS properties should be used
**  -
*/
.rux-progress {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  height: 2rem;
}

.rux-progress progress[value] {
  appearance: none;
  background-color: rgba(0, 0, 0, 0.3);
  background-color: var(--progressDeterminateTrackBackgroundColor, rgba(0, 0, 0, 0.3));
  border: 1px solid #14202c;
  border: 1px solid var(--progressDeterminateTrackBorderColor, #14202c);
  border-radius: 10px 10px 10px 10px;
  border-radius: var(--progressRadius);
  height: 20px;
  width: 100%;
}

.rux-progress__value {
  margin: 0 0 0 0.5rem;
  text-align: right;
  font-size: 24px;
  width: 11%;
  color: white;
  color: var(--controlLabelColor, white);
}

.rux-progress progress[value]::-webkit-progress-bar {
  background-color: transparent;
}

.rux-progress progress[value]::-webkit-progress-value {
  border-radius: 10px 10px 10px 10px;
  border-radius: var(--progressRadius);
  height: 14px;
  height: var(--progressHeight);
  margin: 2px 0 0 2px;
  margin: var(--progressPadding);
  max-width: calc(100% - 4px);
  max-width: var(--progressWidth);
  background-color: #4dacff;
  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);
}

.rux-progress progress[value]::-ms-fill {
  border-radius: 10px;
  border: none;
  height: 14px;
  margin: 2px;
  max-width: calc(100% - 6px);
  background-color: #4dacff;
  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);
}

.rux-progress progress[value]::-moz-progress-bar {
  border-radius: 10px 10px 10px 10px;
  border-radius: var(--progressRadius);
  margin: 2px 2px 0 2px;
  height: 14px;
  height: var(--progressHeight);
  max-width: calc(100% - 4px);
  max-width: var(--progressWidth);
  background-color: #4dacff;
  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);
}

/* Indeterminate */
.rux-progress progress:indeterminate {
  -webkit-appearance: none;
  -moz-appearance: none;
  box-sizing: border-box;
  position: relative;
  height: 5rem;
  width: 5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-image: var(--progressIndeterminate,
      url(${___CSS_LOADER_URL_REPLACEMENT_13___}));
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  animation-name: spin;
  animation-duration: 1.367s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background-color: transparent;
  border: none;
}

/* Removes the default animation from IE */
.rux-progress progress:indeterminate::-ms-fill {
  animation-name: none;
}

.rux-progress progress:indeterminate::-moz-progress-bar {
  background-color: transparent;
}

.rux-progress progress:indeterminate::-webkit-progress-value,
.rux-progress progress:indeterminate::-webkit-progress-bar {
  background-color: transparent;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/*
**
** 	ASTRO PUSHBUTTONS
** 	==========================================================================
**  3.0 Notes
**	- Updated with css custom properties for light/dark theme
**  2.1 Notes
**	- Moved Pushbuttons to its own style
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**	- Removed prefixed transition
**  - Fixed added colon to checked pseudo class (e.g., checked became :checked)
**  - Alignment issue fixed on toggle button label
**  - Updated to WCAG colors
**  - Updated transition speed
*/
.rux-pushbutton {
  display: inline-block;
  height: 1.3125rem;
  -webkit-font-smoothing: subpixel-antialiased;
}

.rux-pushbutton__input {
  display: none;
}

.rux-pushbutton__button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.375rem;
  font-size: 0.75rem !important;
  font-weight: 600;
  margin: 0;
  padding: 0 0.625rem;
  color: var(--pushbuttonTextColor);
  background-color: var(--pushbuttonBackgroundColor);
  border-radius: 3px;
  border-radius: var(--defaultBorderRadius, 3px);
  border: 1px solid var(--pushbuttonBorderColor);
}

.rux-pushbutton__button label {
  color: var(--pushbuttonTextColor);
}

.rux-pushbutton__input:checked+.rux-pushbutton__button {
  display: flex;
  color: var(--pushbuttonSelectedTextColor);
  background-color: var(--pushbuttonSelectedBackgroundColor);
  border-color: var(--pushbuttonSelectedBorderColor);
}

.rux-pushbutton__input:not(:checked)+.rux-pushbutton__button .on {
  display: none;
}

.rux-pushbutton__input:disabled+.rux-pushbutton__button {
  opacity: 0.4;
  opacity: var(--disabledOpacity);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

/*
**
** 	ASTRO SEGMENTED BUTTON
** 	==========================================================================
**  3.0 Notes
**  Don‘t forget to update Sketch with outline border color

*/
.rux-segmented-button {
  display: inline-flex;
  height: 1.6875rem;
  overflow: hidden;
  padding: 0;
  margin: 0;
  list-style: none;
  border-radius: 3px;
  border-radius: var(--controlBorderRadius);
  border: 1px solid var(--segmentedButtonBorderColor);
}

.rux-segmented-button:hover {
  border-color: var(--segmentedButtonHoverBorderColor);
}

.rux-segmented-button__segment {
  height: 1.6875rem;
  width: auto;
  margin: 0;
  padding: 0;
}

.rux-segmented-button__segment label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 1.5625rem;
  margin: 0;
  padding: 0 0.75rem;
  border: none;
  border-right: 1px solid var(--segmentedButtonBorderColor);
  color: var(--segmentedButtonTextColor);
  background-color: var(--segmentedButtonBackgroundColor);
  font-size: 1rem;
  user-select: none;
}

.rux-segmented-button__segment:nth-child(2):not(:last-child) label {
  border-right: none !important;
}

.rux-segmented-button__segment input {
  display: none !important;
}

.rux-segmented-button__segment label:hover {
  background-color: var(--segmentedButtonHoverBackgroundColor);
  border-color: var(--segmentedButtonHoverBorderColor);
  color: var(--segmentedButtonHoverTextColor);
  outline: none;
}

.rux-segmented-button__segment input:checked+label {
  background-color: var(--segmentedButtonSelectedBackgroundColor);
  color: var(--segmentedButtonSelectedTextColor);
}

.rux-segmented-button:nth-child(2):not(:last-child) label {
  border-right: none;
  border-left: none;
}

.rux-segmented-button:first-child label {
  border-radius: 3px 0 0 3px;
  border-radius: var(--controlBorderRadius) 0 0 var(--controlBorderRadius);
}

.rux-segmented-button:last-child label {
  border-radius: 0 3px 3px 0;
  border-radius: 0 var(--controlBorderRadius) var(--controlBorderRadius) 0;
}

/*
**
** 	ASTRO SLIDER
** 	==========================================================================
**  3.0 Notes
**  Removed SVG dependancy for the thumb element
**  Updated to 3.0 look/feel
**  Added CSS Custom Property support for light/dark theming
**  2.1 Notes
**  - Added support for bifurcated range slider
**	1.4 Notes
**	- Added rux_ compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**  - Removed focus ring from Chrome (probably need an actual focus solution)
**  - Updated SVG
*/
/*
    Internal Variables
    Because Chrome, Firefox and IE all require explicit declarations to style
    the slider/range component these minimize the need to add repeat values
    between the three
  */
.rux-slider {
  display: flex;
  flex-direction: column;
}

.rux-slider__label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.25rem;
  margin-bottom: 9px;
}

.rux-slider__control {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  position: relative;
}

.rux-slider label input {
  margin-left: auto;
  margin-right: 0;
}

.rux-range {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  background: none;
  width: 100%;
  margin: 0px;
  color: transparent;
}

input[type='range']:focus {
  outline: none;
}

/****** Track ******/
/* Track -> WebKit */
.rux-range::-webkit-slider-runnable-track {
  display: flex;
  align-items: center;
  max-width: 100%;
  height: 3px;
  height: var(--trackHeight, 2px);
  cursor: pointer;
  cursor: var(--trackCursor, pointer);
  background-color: var(--sliderTrackBackgroundColor);
  outline: var(--sliderTrackBorderSize) solid transparent;
  outline: var(--sliderTrackBorderSize) solid var(--sliderTrackBorderColor, transparent);
  background-image: linear-gradient(to right,
      var(--sliderSelectedTrackBackgroundColor) 0%,
      var(--sliderSelectedTrackBackgroundColor) calc(0.99% * var(--value)),
      var(--sliderTrackBackgroundColor) calc(0.99% * var(--value)),
      var(--sliderTrackBackgroundColor) 100%);
}

.rux-range:disabled::-webkit-slider-runnable-track {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

/* Track -> Moz */
.rux-range::-moz-range-track {
  display: flex;
  align-items: center;
  height: 3px;
  height: var(--trackHeight);
  cursor: pointer;
  cursor: var(--trackCursor, pointer);
  background-color: var(--sliderTrackBackgroundColor);
  outline: var(--sliderTrackBorderSize) solid var(--sliderTrackBorderColor);
}

.rux-range:disabled::-moz-range-track,
.rux-range:disabled::-moz-range-progress {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-range::-moz-range-progress {
  background-color: var(--sliderSelectedTrackBackgroundColor);
}

.rux-input:disabled {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

/* Track -> Ms */
.rux-range::-ms-track {
  display: flex;
  align-items: center;
  height: 1.25rem;
  padding: 2px 0;
  cursor: pointer;
  color: transparent;
  background-color: transparent;
  border: none;
  outline: var(--sliderTrackBorderSize) solid transparent;
}

.rux-range::-ms-fill-lower {
  height: 2px;
  background-color: #4dacff;
}

.rux-range::-ms-fill-upper {
  height: 2px;
  background-color: var(--sliderTrackBackgroundColor);
}

/*****  Thumb ******/
/* Thumb -> Webkit */
.rux-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  position: relative;
  margin-top: calc(1.125rem / -2);
  margin-top: calc(var(--thumbSize) / -2);
  transform: translateX(-35%);
  height: 1.125rem;
  height: var(--thumbSize);
  width: 1.125rem;
  width: var(--thumbSize);
  border-radius: 100%;
  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);
  background-color: var(--sliderThumbBackgroundColor);
  cursor: pointer;
  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), var(--thumbShadow);
  z-index: 6;
}

.rux-range::-webkit-slider-thumb:hover {
  border-color: var(--sliderHoverThumbBorderColor);
}

.rux-range:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-range:not(:disabled)::-webkit-slider-thumb:active {
  border-color: var(--sliderSelectedThumbBorderColor);
  background: radial-gradient(circle, white 40%, var(--primaryDark) 40%);
  background-color: var(--inputBackground);
  -webkit-radial-gradient: radial-gradient(circle, white 40%, var(--primaryDark) 40%);
  box-shadow: inset 0 0 0 4px var(--primary), 0 1px 3px rgba(0, 0, 0, 0.14), 0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.2);
  box-shadow: var(--thumbShadowActive);
}

.rux-range:not(:disabled)::-webkit-slider-thumb:focus,
.rux-range:not(:disabled)::-webkit-slider-thumb:hover:not(:active) {
  background-color: var(--sliderHoverThumbBackgroundColor);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.14), 0 1px 18px rgba(0, 0, 0, 0.12), 0 3px 5px rgba(0, 0, 0, 0.2);
  box-shadow: var(--thumbShadowHover);
}

/* Thumb -> Moz */
.rux-range::-moz-range-thumb {
  -moz-appearance: none;
  position: relative;
  top: calc(1.125rem / -2);
  top: calc(var(--thumbSize) / -2);
  transform: translateX(-35%);
  height: 1.125rem;
  height: var(--thumbSize);
  width: 1.125rem;
  width: var(--thumbSize);
  border-radius: 100%;
  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);
  background-color: var(--sliderThumbBackgroundColor);
  cursor: pointer;
  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), var(--thumbShadow);
}

.rux-range:not(:disabled)::-moz-range-thumb:active {
  background: radial-gradient(circle, white 40%, var(--primaryDark) 40%);
}

.rux-range::-moz-range-thumb:hover {
  border-color: var(--sliderHoverThumbBorderColor);
}

input:-moz-focusring {
  outline: none;
}

.rux-range:disabled::-moz-range-thumb {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

/* Thumb -> Ms */
.rux-range::-ms-thumb {
  position: relative;
  top: -10px;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 100%;
  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);
  background-color: var(--sliderThumbBackgroundColor);
  cursor: pointer;
  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);
}

.rux-range:disabled::-ms-thumb {
  opacity: 0.4;
  cursor: not-allowed;
}

/* Labels */
.rux-slider__control__labels {
  position: relative;
  display: flex;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin: 10px 0 0 0;
  color: var(--fontColor);
  font-size: 0.875rem;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  font-family: var(--fontFamily);
}

.rux-range:disabled+.rux-slider__control__labels {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
}

.rux-slider__control__labels li {
  padding: 0px;
  text-align: left;
}

.rux-slider__control__labels li:first-child,
.rux-slider__control__labels li:last-child {
  margin: 0px;
}

.rux-slider__control-ticks {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 3px;
  height: var(--ticksHeight);
  background: linear-gradient(to right, var(--primaryDark) 1px, transparent 1px) repeat-x;
  background: linear-gradient(to right, var(--ticksColor) var(--ticksThickness), transparent 1px) repeat-x;
  background-size: calc(100% / ((100 - 0) / 1) - 0.18%) 3px;
  background-size: calc(100% / ((var(--max) - var(--min)) / var(--step)) - 0.18%) var(--ticksHeight);
  background-position: 0;
  z-index: 5;
}

.disabled {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.rux-slider__input {
  margin-right: 0;
  margin-bottom: 0.75rem;
  width: 4rem !important;
}

input[type='range']::-moz-focus-outer {
  border: 0;
}

/*
**
** 	ASTRO STATUS INDICATOR
** 	==========================================================================
**  4.1 Notes
**  Removed satcom prefix
**  Replaced SVGs with a single PNG and used sprite pattern to improve performance
**  Removed ::before psuedo element in favor of simpler background on the div
**  Removed undocumented and unused small status variant
**  General clean up
**  3.0 Notes
**  Removed margin on status symbols
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**  - Embeded SVG graphics
*/
.rux-status-indicator,
.rux-status {
  display: block;
  height: 1rem;
  width: 1rem;
  margin: 0.125rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: 1rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-image: var(--statusSymbols,
      url(${___CSS_LOADER_URL_REPLACEMENT_10___}));
}

/* Specific Status Iconography */
.rux-status--off,
.rux-status-indicator.rux-status--off,
.rux-status--off .rux-advanced-status__icon {
  background-position-x: -5rem;
}

.rux-status--standby,
.rux-status-indicator.rux-status--standby,
.rux-status--standby .rux-advanced-status__icon {
  background-position-x: -4rem;
}

.rux-status--normal,
.rux-status-indicator.rux-status--normal,
.rux-status-indicator.rux-status--ok,
.rux-status--normal .rux-advanced-status__icon,
.rux-status--ok .rux-advanced-status__icon {
  background-position-x: -3rem;
}

.rux-status--caution,
.rux-status-indicator.rux-status--caution,
.rux-status--caution .rux-advanced-status__icon {
  background-position-x: -2rem;
}

.rux-status--serious,
.rux-status-indicator.rux-status--serious,
.rux-status-indicator.rux-status--error,
.rux-status--serious .rux-advanced-status__icon,
.rux-status--error .rux-advanced-status__icon {
  background-position-x: -1rem;
}

.rux-status--critical,
.rux-status-indicator.rux-status--critical,
.rux-status-indicator.rux-status--alert,
.rux-status--critical .rux-advanced-status__icon,
.rux-status--alert .rux-advanced-status__icon,
.rux-status--emergency .rux-advanced-status__icon {
  background-position-x: 0;
}

/* Specific Color */
.rux-status--off svg,
.rux-icon.rux-status--off {
  fill: #c6ccd1;
  fill: var(--colorOff, #c6ccd1);
  color: #c6ccd1;
  color: var(--colorOff, #c6ccd1);
}

.rux-status--standby svg,
.rux-icon.rux-status--standby {
  fill: #4dacff;
  fill: var(--colorStandby, #4dacff);
  color: #4dacff;
  color: var(--colorStandby, #4dacff);
}

.rux-icon.rux-status--normal,
.rux-icon.rux-status--ok,
.rux-status--normal svg,
.rux-status--ok svg {
  fill: #5bff00;
  fill: var(--colorNormal, #5bff00);
  color: #5bff00;
  color: var(--colorNormal, #5bff00);
}

.rux-status--caution svg,
.rux-icon.rux-status--caution {
  fill: #f8e71d;
  fill: var(--colorCaution, #f8e71d);
  color: #f8e71d;
  color: var(--colorCaution, #f8e71d);
}

.rux-status--serious svg,
.rux-status--error svg,
.rux-icon.rux-status--serious,
.rux-icon.rux-status--error {
  fill: #ffb000;
  fill: var(--colorSerious, #ffb000);
  color: #ffb000;
  color: var(--colorSerious, #ffb000);
}

.rux-status--critical svg,
.rux-status--emergency svg,
.rux-icon.rux-status--critical,
.rux-icon.rux-status--emergency {
  fill: #ff3030;
  fill: var(--colorCritical, #ff3030);
  color: #ff3030;
  color: var(--colorCritical, #ff3030);
}

/*
**
** 	ASTRO TABS
** 	==========================================================================
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**  - Removed prefixed transitions
**  - Removed prefixed gradients
**  - Updated colors for WCAG compliance
**  - Swapped condensed font for standard
**  2.0 Ideas
**  - Replace use a radio-button based structure for tabs? (http://alistapart.com/article/radio-controlled-web-design)
*/
/* 	REQUIRED CLASSES */
.rux-tabs {
  font-size: 1.5rem;
  width: 100%;
  margin: 0;
  padding: 0;
  height: 5.625rem;
  user-select: none;
  border-bottom: 5px solid var(--tabBorderColor);
}

.rux-tabs--small {
  height: 3.125rem;
  font-size: 1.125rem;
  font-size: var(--fontSizeXL);
  border-bottom: 3px solid var(--tabBorderColor);
}

.rux-tabs ul {
  padding: 0;
  margin: 0;
  height: 100%;
  display: flex;
  list-style: none;
}

.rux-tabs li {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.rux-tabs li::before {
  display: none !important;
}

.rux-tabs a {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 3px 2rem 0;
  text-decoration: none;
  color: var(--tabTextColor);
}

.rux-tabs a[disabled] {
  opacity: 0.4;
  opacity: var(--disabledOpacity);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-tabs .selected a {
  color: var(--tabSelectedTextColor);
}

.rux-tabs--small .selected a,
.rux-tabs--small .selected a:hover {
  color: var(--tabSelectedTextColor);
}

.rux-tabs .selected a:hover {
  color: var(--tabSelectedTextColor);
}

.rux-tabs a:hover:not([disabled]) {
  color: var(--tabHoverTextColor);
}

.rux-tabs .rux-tab {
  border-bottom: 5px solid var(--tabBorderColor);
}

/*
**
** 	ASTRO TOGGLE BUTTONS
** 	==========================================================================
**  3.0 Notes
**  - Breaking change to markup of toggle button
**  2.1 Notes
**	- Moved Pushbuttons to its own style sheet
**	1.4 Notes
**	- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version
**	- Removed prefixed linear gradients
**	- Removed prefixed transition
**  - Fixed added colon to checked pseudo class (e.g., checked became :checked)
**  - Alignment issue fixed on toggle button label
**  - Updated to WCAG colors
**  - Updated transition speed
*/
.rux-toggle--legacy,
.satcom-toggle--legacy {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  -webkit-font-smoothing: subpixel-antialiased;
  height: 1.3125rem;
  width: 4.375rem;
  border-radius: 3px;
  border-radius: var(--defaultBorderRadius, 0.1875rem);
  border: 1px solid black;
  border: 1px solid var(--toggleBaseBorderColor, black);
  user-select: none;
  overflow: hidden;
}

.rux-toggle--legacy__input,
.satcom-toggle--legacy input {
  display: none !important;
}

.rux-toggle--legacy__button {
  position: absolute;
  display: flex;
  justify-content: space-around;
  align-content: center;
  align-items: center;
  top: 0;
  left: 0;
  font-size: 0.75rem !important;
  height: 100%;
  width: 100%;
}

.rux-toggle--legacy__button span {
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  z-index: 1;
  text-transform: uppercase;
}

.rux-toggle--legacy__button::before {
  position: absolute;
  content: '';
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 0.1875rem;
  background: black;
  background: var(--toggleBaseBackgroundColor, black);
}

.rux-toggle--legacy__button::after {
  content: '';
  display: block;
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  z-index: 10;
  transition: left 0.1s ease-out;
  width: 50%;
  height: 100%;
  border-radius: 0.125rem;
  background: #005a8f url(${___CSS_LOADER_URL_REPLACEMENT_14___}) center center no-repeat;
  background: var(--toggleButtonBackgroundColor, #005a8f) url(${___CSS_LOADER_URL_REPLACEMENT_14___}) center center no-repeat;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5), 1px 0 2px rgba(0, 0, 0, 0.6);
  box-shadow: var(--toggleButtonBoxShadow, 0 0 3px rgba(0, 0, 0, 0.5), 1px 0 2px rgba(0, 0, 0, 0.6));
}

.rux-toggle--legacy .on {
  font-weight: 600;
  color: #5bff00;
  color: var(--toggleBaseSelectedTextColor, #5bff00);
}

.rux-toggle--legacy .off {
  color: white;
  color: var(--toggleBaseTextColor, white);
}

.rux-toggle--legacy__input:disabled+.rux-toggle--legacy__button {
  opacity: 0.4;
  opacity: var(--disabledOpacity, 0.4);
  cursor: not-allowed;
}

.rux-toggle--legacy__input:checked+.rux-toggle--legacy__button::after {
  left: 50%;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5), -1px 0 2px rgba(0, 0, 0, 0.6);
  box-shadow: var(--toggleButtonSelectedBoxShadow, 0 0 3px rgba(0, 0, 0, 0.5), -1px 0 2px rgba(0, 0, 0, 0.6));
}

.rux-switch {
  position: relative;
  display: flex;
  height: 22px;
  width: 42px;
  overflow: hidden;
}

.rux-switch__input {
  display: none;
}

.rux-switch__button {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* Track */
.rux-switch__button::before {
  position: relative;
  display: flex;
  content: '';
  border-radius: 5.5px;
  border: 1px solid;
  border-color: var(--switchOffColor);
  background-color: var(--switchOffColor);
  height: 11px;
  width: 38px;
  z-index: 2;
  transition: 0.1s background-color linear;
}

/* Track Active */
.rux-switch__input:checked+.rux-switch__button::before {
  border-color: var(--switchOnColor);
  background-color: var(--switchOnColor);
}

/* Track Hover Unchecked */
.rux-switch:hover .rux-switch__input:not(:disabled)+.rux-switch__button:before {
  border-color: var(--switchHoverOffColor);
  background-color: var(--switchHoverOffColor);
}

/* Track Hover Checked */
.rux-switch:hover .rux-switch__input:checked:not(:disabled)+.rux-switch__button:before {
  border-color: var(--switchHoverOnColor);
  background-color: var(--switchHoverOnColor);
}

/* Button */
.rux-switch__button::after {
  position: absolute;
  content: '';
  top: 1px;
  left: 0;
  z-index: 3;
  height: 19px;
  width: 19px;
  border-radius: 50%;
  border: 1px solid var(--switchOffColor);
  background-color: var(--inputBackground);
  transition: 0.1s left linear, 0.1s border-color linear;
}

/* Button Active */
.rux-switch__input:checked+.rux-switch__button::after {
  left: 50%;
  border-color: var(--switchOnColor);
  background-color: var(--inputBackground);
}

/* Button Hover Unchecked */
.rux-switch:hover .rux-switch__input:not(:disabled)+.rux-switch__button:after {
  border-color: var(--switchHoverOffColor);
}

/* Button Hover Checked */
.rux-switch:hover .rux-switch__input:checked:not(:disabled)+.rux-switch__button:after {
  border-color: var(--switchHoverOnColor);
}

/* Disabled */
.rux-switch__input:disabled+.rux-switch__button::after {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-switch__input:checked:disabled+.rux-switch__button::after {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-switch__input:disabled+.rux-switch__button::before {
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-switch__input:disabled+.rux-switch__button {
  opacity: 0.4;
  opacity: var(--disabledOpacity);
  cursor: not-allowed;
  cursor: var(--disabledCursor);
}

.rux-tree {
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
  font-size: 1rem;
  color: var(--treeTextColor);
  border: solid 1px var(--treeBorderColor);
  background-color: var(--treeBackgroundColor);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.rux-tree--compact {
  font-size: 0.875rem;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.rux-tree ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.rux-tree li {
  font-weight: bold;
}

/* Parent Elements */
.rux-tree__parent {
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
  height: 2rem;
}

.rux-tree__parent:hover,
:not([aria-selected='true'])>.rux-tree__parent:hover::after {
  background: var(--treeHoverBackgroundColor);
  color: var(--treeHoverTextColor);
}

:not([aria-selected='true'])>.rux-tree__parent:hover .rux-tree__arrow::after {
  border-color: transparent transparent transparent var(--treeHoverTextColor);
}

.rux-tree__label {
  flex-grow: 1;
  padding: 0.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: calc(100% - 7px);
}

.rux-tree--compact .rux-tree__label {
  padding: 0.35rem;
}

.rux-tree__arrow {
  position: relative;
  cursor: pointer;
  width: 7px;
  visibility: hidden;
}

.rux-tree__arrow::after {
  content: '';
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 0 7px 7px;
  border-color: transparent transparent transparent var(--treeAccentColor);
  display: inline-block;
}

.has-children .rux-tree__arrow {
  visibility: visible;
}

/* Child Elements */
.rux-tree__children {
  width: 100%;
  display: none;
  padding: 0;
  margin: 0;
  height: 0;
}

.rux-tree__child {
  padding-left: 3rem;
}

/* Expanded */
.expanded .rux-tree__arrow::after {
  transform: rotate(90deg);
}

.expanded .rux-tree__children {
  display: block;
  height: auto;
}

[aria-expanded='true'][aria-level='1']:not([aria-selected='true'])>.rux-tree__parent:after {
  border-bottom: solid 1px var(--treeExpandedBorderColor);
}

.rux-tree .selected,
[aria-selected='true']>.rux-tree__parent::after,
[aria-selected='true']>.rux-tree__parent:hover::after {
  background-color: var(--treeSelectedBackgroundColor);
  box-shadow: inset 0.25rem 0 0 var(--treeSelectedAccentColor);
  color: var(--treeSelectedTextColor);
}

.rux-tree .selected .rux-tree__arrow::after {
  border-color: transparent transparent transparent var(--treeSelectedAccentColor);
}

[aria-selected='true']>.rux-tree__parent::after {
  border-top: 1px solid var(--treeSelectedBorderColor);
  border-bottom: 1px solid var(--treeSelectedBorderColor);
}

li[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover:after {
  box-shadow: inset 0.25rem 0 0 var(--treeSelectedAccentColor) !important;
  background-color: var(--treeHoverBackgroundColor) !important;
}

li[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover {
  color: var(--treeHoverTextColor);
}

li[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover .rux-tree__arrow:after {
  border-color: transparent transparent transparent var(--treeHoverTextColor);
}`, "",{"version":3,"sources":["webpack://./public/css/astroux/css/astro.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,qCAAqC;EACrC,yGAAyG;EACzG,gHAAgH;EAChH,+IAA+I;EAC/I,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;;EAEhC,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,iCAAiC;;EAEjC,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;;EAExB,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,SAAS;EACT,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,mIAAmI;EACnI,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,wIAAwI;EACxI,0CAA0C;EAC1C,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;EACtC,mCAAmC;EACnC,sCAAsC;EACtC,mCAAmC;EACnC,sCAAsC;EACtC,uCAAuC;EACvC,sCAAsC;EACtC,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,+DAA+D;EAC/D,2DAA2D;EAC3D,wDAAwD;EACxD,6DAA6D;EAC7D,4DAA4D;EAC5D,6DAA6D;EAC7D,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,4CAA4C;EAC5C,0CAA0C;EAC1C,0CAA0C;EAC1C,yCAAyC;EACzC,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;EACpC,sCAAsC;EACtC,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,4CAA4C;EAC5C,4CAA4C;EAC5C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,qCAAqC;EACrC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,sCAAsC;EACtC,qCAAqC;EACrC,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,uCAAuC;EACvC,sCAAsC;EACtC,sCAAsC;EACtC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,oHAA2G;EAC3G,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;;;EAIA;EACA,qCAAqC;EACrC,0DAA0D;EAC1D,qDAAqD;EACrD,uDAAuD;EACvD,wDAAwD;EACxD,6CAA6C;EAC7C,uCAAuC;EACvC,oDAAoD;EACpD,kDAAkD;EAClD,6BAA6B;EAC7B,sGAAsG;EACtG,gDAAgD;EAChD,6CAA6C;EAC7C,oBAAoB;EACpB,WAAW;EACX,+BAA+B;EAC/B,4CAA4C;EAC5C,mCAAmC;EACnC,qDAAqD;EACrD,+BAA+B;EAC/B,wCAAwC;EACxC,oCAAoC;EACpC,yBAAyB;EACzB,4DAA4D;EAC5D,4DAA4D;EAC5D,2DAA2D;EAC3D,uDAAuD;EACvD,6DAA6D;EAC7D,qDAAqD;EACrD;;;;;;GAMC;EACD,WAAW;EACX,4CAA4C;EAC5C,uCAAuC;EACvC,mCAAmC;EACnC,uBAAuB;EACvB,iDAAiD;EACjD,gDAAgD;EAChD,4CAA4C;EAC5C,wBAAwB;EACxB,kDAAkD;EAClD,6CAA6C;EAC7C,yCAAyC;EACzC,2BAA2B;EAC3B,8DAA8D;EAC9D,2CAA2C;EAC3C,gEAAgE;EAChE,uCAAuC;EACvC,iDAAiD;EACjD,gDAAgD;EAChD,mDAAmD;EACnD;;;;;;GAMC;EACD,6CAA6C;EAC7C,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,0CAA0C;EAC1C,6CAA6C;EAC7C,mDAAmD;EACnD,6CAA6C;EAC7C;;;;;GAKC;EACD,uDAAuD;EACvD,iEAAiE;EACjE,yDAAyD;EACzD,gEAAmnC;EACnnC;;;;;GAKC;EACD,kDAAkD;EAClD,sCAAsC;EACtC,wCAAwC;EACxC,2CAA2C;EAC3C,sDAAsD;EACtD,uDAAuD;EACvD,wDAAwD;EACxD,uDAAuD;EACvD;;;;;GAKC;EACD,gDAAgD;EAChD,gDAAgD;EAChD,qDAAqD;EACrD,qDAAqD;EACrD,8CAA8C;EAC9C,oDAAoD;EACpD,qDAAqD;EACrD,oDAAoD;EACpD,4BAA4B;EAC5B,+BAA+B;EAC/B;;;;;GAKC;EACD,4CAA4C;EAC5C,sCAAsC;EACtC,0CAA0C;EAC1C,oBAAoB;EACpB,yDAAyD;EACzD,0DAA0D;EAC1D,qDAAqD;EACrD,qBAAqB;EACrB,wDAAwD;EACxD,6DAA6D;EAC7D;;;;;GAKC;EACD,mDAAmD;EACnD,sDAAwP;EACxP;;;;;GAKC;EACD,sCAAsC;EACtC,+BAA+B;EAC/B,wCAAwC;EACxC,yCAAyC;EACzC,uCAAuC;EACvC,8CAA8C;EAC9C;;;;;GAKC;EACD,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,uDAAuD;EACvD,mDAAmD;EACnD,iDAAiD;EACjD;;;;;GAKC;EACD,2CAA2C;EAC3C,+BAA+B;EAC/B,2BAA2B;EAC3B,4CAA4C;EAC5C;;;;;GAKC;EACD,4CAA4C;EAC5C,oCAAoC;EACpC,8CAA8C;EAC9C,kCAAkC;EAClC;;;;;GAKC;EACD,kCAAkC;EAClC,4CAA4C;EAC5C,sCAAsC;EACtC,wCAAwC;EACxC,kDAAkD;EAClD,+CAA+C;EAC/C,+CAA+C;EAC/C;;;;;GAKC;EACD,mCAAmC;EACnC,6CAA6C;EAC7C,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;EACjC,UAAU;EACV,8CAA8C;EAC9C,+CAA+C;EAC/C,sCAAsC;EACtC,aAAa;EACb,qDAAqD;EACrD,6CAA6C;EAC7C,2CAA2C;EAC3C,yCAAyC;EACzC,qDAAqD;EACrD,iDAAiD;EACjD;;;;;GAKC;EACD,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,0CAA0C;EAC1C,wCAAwC;EACxC;;;;;EAKA;EACA,2CAA2C;EAC3C;;;;;EAKA;EACA,yDAAyD;EACzD,iDAAiD;EACjD;;;;;GAKC;EACD,qDAAqD;EACrD,2DAA2D;EAC3D,8CAA8C;EAC9C;;;;;GAKC;EACD,8CAA8C;EAC9C,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,oCAAoC;EACpC,uCAAuC;EACvC,yCAAyC;EACzC,+CAA+C;EAC/C,0DAA2lB;EAC3lB,4DAA+U;EAC/U;;;;;EAKA;EACA,kCAAkC;EAClC;;;;;GAKC;EACD,wDAA85C;EAC95C;;;;;;GAMC;EACD,uEAAuE;EACvE,4EAA4E;EAC5E,4CAA4C;EAC5C,8EAA8E;EAC9E;;;;;GAKC;EACD,uDAAuD;EACvD,6CAA6C;EAC7C,sDAAsD;EACtD,4CAA4C;EAC5C,2DAA2D;EAC3D,sDAAsD;EACtD,uDAAuD;EACvD,6CAA6C;EAC7C,2CAA2C;EAC3C,uDAAuD;EACvD,2DAA2D;EAC3D,4DAA4D;EAC5D,qDAAqD;EACrD,yDAAyD;EACzD,uDAAuD;EACvD,uDAAuD;EACvD,uDAAuD;EACvD,+CAA+C;EAC/C;;;;;GAKC;EACD,0CAA0C;EAC1C,gDAAgD;EAChD,oDAAoD;EACpD,kDAAkD;EAClD,mDAAmD;EACnD,8BAA8B;EAC9B;;;;;GAKC;EACD,0CAA0C;EAC1C,oDAAoD;EACpD,gDAAgD;EAChD,iDAAiD;EACjD,2DAA2D;EAC3D,wCAAwC;EACxC,iDAAiD;EACjD,6CAA6C;EAC7C,uCAAuC;EACvC,uDAAuD;EACvD,4CAA4C;EAC5C,yDAAyD;EACzD,6CAA6C;EAC7C,8CAA8C;EAC9C,wCAAwC;EACxC,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;;;EAIA;EACA,8BAA8B;EAC9B,oDAAoD;EACpD,yCAAyC;EACzC,sDAAsD;EACtD,wDAAwD;EACxD,0BAA0B;EAC1B,qEAAqE;EACrE,yCAAyC;EACzC,sDAAsD;EACtD,8BAA8B;EAC9B,sGAAsG;EACtG,oDAAoD;EACpD,2BAA2B;EAC3B,0DAA0D;EAC1D,6CAA6C;EAC7C,iDAAiD;EACjD,WAAW;EACX,+BAA+B;EAC/B,4CAA4C;EAC5C,mCAAmC;EACnC,qDAAqD;EACrD,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,wCAAwC;EACxC,wDAAwD;EACxD,2DAA2D;EAC3D,2DAA2D;EAC3D,0DAA0D;EAC1D,sDAAsD;EACtD,2DAA2D;EAC3D,oDAAoD;EACpD;;;;;;GAMC;EACD,WAAW;EACX,4CAA4C;EAC5C,uCAAuC;EACvC,gCAAgC;EAChC,uBAAuB;EACvB,iDAAiD;EACjD,iDAAiD;EACjD,qCAAqC;EACrC,wBAAwB;EACxB,kDAAkD;EAClD,6CAA6C;EAC7C,yCAAyC;EACzC,2BAA2B;EAC3B,wCAAwC;EACxC,2CAA2C;EAC3C,gEAAgE;EAChE,uCAAuC;EACvC,kDAAkD;EAClD,gDAAgD;EAChD,oDAAoD;EACpD;;;;;;GAMC;EACD,6CAA6C;EAC7C,uCAAuC;EACvC,wCAAwC;EACxC,oCAAoC;EACpC,oCAAoC;EACpC,8CAA8C;EAC9C,oDAAoD;EACpD,4CAA4C;EAC5C,8CAA8C;EAC9C,mDAAmD;EACnD;;;;;GAKC;EACD,iFAAiF;EACjF,6DAA6D;EAC7D,yDAAyD;EACzD,gEAAujC;EACvjC;;;;;GAKC;EACD,gDAAgD;EAChD,gDAAgD;EAChD,qDAAqD;EACrD,qDAAqD;EACrD,qCAAqC;EACrC,kDAAkD;EAClD,qDAAqD;EACrD,oDAAoD;EACpD,4BAA4B;EAC5B,4BAA4B;EAC5B;;;;;GAKC;EACD,4CAA4C;EAC5C,sCAAsC;EACtC,0CAA0C;EAC1C,oBAAoB;EACpB,0DAA0D;EAC1D,0DAA0D;EAC1D,sDAAsD;EACtD,qBAAqB;EACrB,wDAAwD;EACxD,6DAA6D;EAC7D;;;;;GAKC;EACD,oDAAoD;EACpD;;;;;GAKC;EACD,sCAAsC;EACtC,+BAA+B;EAC/B,yCAAyC;EACzC,0CAA0C;EAC1C,uCAAuC;EACvC,8CAA8C;EAC9C;;;;;GAKC;EACD,kDAAkD;EAClD,sCAAsC;EACtC,+CAA+C;EAC/C,2CAA2C;EAC3C,8CAA8C;EAC9C,wDAAwD;EACxD,wDAAwD;EACxD,8DAA8D;EAC9D;;;;;GAKC;EACD,iCAAiC;EACjC,uCAAuC;EACvC,qCAAqC;EACrC,uDAAuD;EACvD,mDAAmD;EACnD,wDAAwD;EACxD;;;;;GAKC;EACD,oCAAoC;EACpC,8CAA8C;EAC9C,0CAA0C;EAC1C,qCAAqC;EACrC;;;;;GAKC;EACD,4CAA4C;EAC5C,oCAAoC;EACpC,8CAA8C;EAC9C,kCAAkC;EAClC;;;;;;;GAOC;EACD,kCAAkC;EAClC,4CAA4C;EAC5C,wCAAwC;EACxC,wCAAwC;EACxC,kDAAkD;EAClD,8CAA8C;EAC9C,+CAA+C;EAC/C;;;;;GAKC;EACD,mCAAmC;EACnC,6CAA6C;EAC7C,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;EACjC,SAAS;EACT,+CAA+C;EAC/C,+CAA+C;EAC/C,sCAAsC;EACtC,aAAa;EACb,qDAAqD;EACrD,6CAA6C;EAC7C,2CAA2C;EAC3C,yCAAyC;EACzC,qDAAqD;EACrD,iDAAiD;EACjD;;;;;GAKC;EACD,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,0CAA0C;EAC1C,wCAAwC;EACxC;;;;;EAKA;EACA,kDAAkD;EAClD;;;;;EAKA;EACA,kDAAkD;EAClD,wDAAwD;EACxD;;;;;GAKC;EACD,kDAAkD;EAClD,qDAAqD;EACrD,8CAA8C;EAC9C;;;;;GAKC;EACD,8CAA8C;EAC9C,0CAA0C;EAC1C,uCAAuC;EACvC,mCAAmC;EACnC,2CAA2C;EAC3C,gBAAgB;EAChB,uCAAuC;EACvC,gDAAgD;EAChD,+CAA+C;EAC/C,0DAA2lB;EAC3lB,4DAA+U;EAC/U;;;;;EAKA;EACA,kCAAkC;EAClC;;;;;GAKC;EACD,yDAAshC;EACthC;;;;;GAKC;EACD,gFAAgF;EAChF,qFAAqF;EACrF,6EAA6E;EAC7E,mFAAmF;EACnF;;;;;GAKC;EACD,uDAAuD;EACvD,6CAA6C;EAC7C,sDAAsD;EACtD,4CAA4C;EAC5C,2DAA2D;EAC3D,sDAAsD;EACtD,uDAAuD;EACvD,6CAA6C;EAC7C,2CAA2C;EAC3C,2DAA2D;EAC3D,2DAA2D;EAC3D,qDAAqD;EACrD,qDAAqD;EACrD,yDAAyD;EACzD,uDAAuD;EACvD,uDAAuD;EACvD,uDAAuD;EACvD,+CAA+C;EAC/C;;;;;GAKC;EACD,uCAAuC;EACvC,6CAA6C;EAC7C,iDAAiD;EACjD,+CAA+C;EAC/C,kDAAkD;EAClD,oCAAoC;EACpC;;;;;GAKC;EACD,0CAA0C;EAC1C,oDAAoD;EACpD,gDAAgD;EAChD,0CAA0C;EAC1C,4DAA4D;EAC5D,wCAAwC;EACxC,iDAAiD;EACjD,uCAAuC;EACvC,6CAA6C;EAC7C,wDAAwD;EACxD,4CAA4C;EAC5C,yDAAyD;EACzD,6CAA6C;EAC7C,8CAA8C;EAC9C,wCAAwC;EACxC,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,kIAAkI;EAClI,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,oDAAoD;EACpD,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;;;CAGC;AACD;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;CAIC;AACD;EACE,SAAS;EACT,UAAU;EACV,kIAAkI;EAClI,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,wCAAwC;EACxC,gGAAgG;AAClG;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;CAIC;AACD;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;EAC/D,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,6FAA6F;AAC7F;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,oEAAoE;AACtE;;AAEA;;EAEE,yBAAyB;EACzB,qEAAqE;AACvE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;;;;;;;CAkBC;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,6BAA6B;EAC7B,kIAAkI;EAClI,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;CAIC;AACD,mBAAmB;AACnB;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,qDAAqD;EACrD,iDAAiD;AACnD;;AAEA;;;;CAIC;AACD;EACE,uDAAuD;EACvD,+DAA+D;AACjE;;AAEA;EACE,wDAAwD;EACxD,gEAAgE;AAClE;;AAEA;;;;CAIC;AACD;EACE,2CAA2C;EAC3C,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;;;;CAIC;AACD;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;EAEE,6CAA6C;EAC7C,wDAAwD;EACxD,yCAAyC;EACzC,oDAAoD;AACtD;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,qDAAqD;EACrD,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,2DAA2D;EAC3D,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,WAAW;EACX,WAAW;EACX,SAAS;EACT,+CAA+C;EAC/C,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,kIAAkI;EAClI,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,0DAA+vB;EAC/vB,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,kIAAkI;EAClI,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,kIAAkI;EAClI,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,0DAA+vB;EAC/vB,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;;;;;;;CAQC;AACD;;;;CAIC;AACD,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kIAAkI;EAClI,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,yCAAyC;EACzC,kBAAkB;EAClB,kIAAkI;EAClI,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,UAAU;AACV;;;;;;EAME,eAAe;EACf,mBAAmB;EACnB,kIAAkI;EAClI,8BAA8B;AAChC;;AAEA;;;EAGE,wBAAwB;EACxB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,gDAAgD;AAClD;;AAEA,gBAAgB;AAChB;;EAEE,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;;;EAIE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;;;EAIE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;;;EAGE,0CAA0C;EAC1C,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kCAAkC;EAClC,sFAAsF;AACxF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gDAAgD;AAClD;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;EACtB,2CAA2C;EAC3C,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,8DAA8D;EAC9D,sDAAsD;AACxD;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,SAAS;EACT,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;;;;CAKC;AACD;EACE,8DAAgQ;EAChQ,6DAA0T;EAC1T,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,4CAA4C;EAC5C,kBAAkB;EAClB,wCAAwC;EACxC,uBAAuB;EACvB,kIAAkI;EAClI,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,wCAAwC;EACxC,4CAA4C;EAC5C,0CAA0C;EAC1C,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;;CAIC;AACD;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,6CAA6C;EAC7C,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,+CAA+C;EAC/C,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,gBAAgB;EAChB,yCAAyC;EACzC,6CAA6C;EAC7C,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kIAAkI;EAClI,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,gCAAgC;EAChC,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;EAC7C,YAAY;EACZ,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kHAAkH;AACpH;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;CAMC;AACD;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,6CAA6C;EAC7C,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,4CAA4C;EAC5C,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;;EAEE;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qBAAqB;AACrB;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;;EAEE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;;EAEE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;;EAEE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;;EAEE,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;;;;;;;;CAQC;AACD,sBAAsB;AACtB;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,UAAU;EACV,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;EAC9C,yCAAyC;EACzC,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,8CAA8C;EAC9C,wCAAwC;EACxC,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,yCAAyC;EACzC,6CAA6C;EAC7C,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,QAAQ;EACR,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;;;;;;;;;;;CAsBC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,oFAAoF;EACpF,yBAAyB;EACzB,qEAAqE;EACrE,kCAAkC;EAClC,oCAAoC;EACpC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,uEAAuE;AACzE;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qBAAqB;EACrB,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,uEAAuE;AACzE;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0DAA+yD;EAC/yD;+CACkyD;EAClyD,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,kDAAkD;EAClD,kBAAkB;EAClB,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,0DAA0D;EAC1D,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;;;;;;CAOC;AACD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,yDAAyD;EACzD,sCAAsC;EACtC,uDAAuD;EACvD,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4DAA4D;EAC5D,oDAAoD;EACpD,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;;;;;;;;;;;;;;;CAeC;AACD;;;;;GAKG;AACH;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,mCAAmC;EACnC,mDAAmD;EACnD,uDAAuD;EACvD,sFAAsF;EACtF;;;;6CAI2C;AAC7C;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,mCAAmC;EACnC,mDAAmD;EACnD,yEAAyE;AAC3E;;AAEA;;EAEE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mDAAmD;AACrD;;AAEA,oBAAoB;AACpB,oBAAoB;AACpB;EACE,wBAAwB;EACxB,kBAAkB;EAClB,+BAA+B;EAC/B,uCAAuC;EACvC,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,wEAAwE;EACxE,mDAAmD;EACnD,eAAe;EACf,gJAAgJ;EAChJ,wEAAwE;EACxE,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;EACnD,sEAAsE;EACtE,wCAAwC;EACxC,mFAAmF;EACnF,sIAAsI;EACtI,oCAAoC;AACtC;;AAEA;;EAEE,wDAAwD;EACxD,wGAAwG;EACxG,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,gCAAgC;EAChC,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,wEAAwE;EACxE,mDAAmD;EACnD,eAAe;EACf,gJAAgJ;EAChJ,wEAAwE;AAC1E;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,wEAAwE;EACxE,mDAAmD;EACnD,eAAe;EACf,gJAAgJ;AAClJ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kIAAkI;EAClI,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,uFAAuF;EACvF,wGAAwG;EACxG,yDAAyD;EACzD,kGAAkG;EAClG,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;;;;;;;;;CAeC;AACD;;EAEE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,0DAAuhC;EACvhC;+CAC0gC;AAC5gC;;AAEA,gCAAgC;AAChC;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;;EAEE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;;EAIE,aAAa;EACb,iCAAiC;EACjC,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;;EAIE,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,mCAAmC;AACrC;;AAEA;;;;EAIE,aAAa;EACb,mCAAmC;EACnC,cAAc;EACd,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;CAYC;AACD,sBAAsB;AACtB;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;;;;;CAgBC;AACD;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4CAA4C;EAC5C,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,oDAAoD;EACpD,uBAAuB;EACvB,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,6BAA6B;EAC7B,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,8BAA8B;EAC9B,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,oFAAgc;EAChc,wHAAoe;EACpe,oEAAoE;EACpE,kGAAkG;AACpG;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qEAAqE;EACrE,2GAA2G;AAC7G;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,mCAAmC;EACnC,uCAAuC;EACvC,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA,wBAAwB;AACxB;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,wCAAwC;EACxC,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,SAAS;EACT,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,uCAAuC;AACzC;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,wCAAwC;EACxC,4CAA4C;EAC5C,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,wEAAwE;EACxE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;;EAGE,oDAAoD;EACpD,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,oDAAoD;EACpD,uDAAuD;AACzD;;AAEA;EACE,uEAAuE;EACvE,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;AAC7E","sourcesContent":["@charset \"UTF-8\";\n\n:root {\n  --thumbSize: var(--controlOptionSize);\n  --thumbShadow: 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);\n  --thumbShadowHover: 0 6px 10px rgba(0, 0, 0, 0.14), 0 1px 18px rgba(0, 0, 0, 0.12), 0 3px 5px rgba(0, 0, 0, 0.2);\n  --thumbShadowActive: inset 0 0 0 4px var(--primary), 0 1px 3px rgba(0, 0, 0, 0.14), 0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.2);\n  --trackHeight: 3px;\n  --trackCursor: pointer;\n  --step: 1;\n  --min: 0;\n  --max: 100;\n  --ticksThickness: 1px;\n  --ticksHeight: 3px;\n  --ticksColor: var(--primaryDark);\n\n  --progressPadding: 2px 0 0 2px;\n  --progressRadius: 10px 10px 10px 10px;\n  --progressHeight: 14px;\n  --progressWidth: calc(100% - 4px);\n\n  --padding: 0.5rem;\n  --paddingLeft: 0.5rem;\n  --paddingRight: 0.5rem;\n  --paddingTop: 0.25rem;\n  --paddingBottom: 0.25rem;\n\n  --disabledControlOpacity: 0.4;\n  --disabledControlCursor: not-allowed;\n  --disabledOpacity: 0.4;\n  --disabledCursor: not-allowed;\n  --buttonBorderRadius: 3px;\n  --defaultBorderRadius: 3px;\n  --controlOptionSize: 1.125rem;\n  /* 18px */\n  --controlBorderRadius: 3px;\n  --labelFontSize: 1rem;\n  --smallLabelFontSize: 0.875rem;\n  --largeLabelFontSize: 1.125rem;\n  /* Typography */\n  --fontFamily: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  --fontSize: 1rem;\n  /* 16px */\n  --fontSizeXL: 1.125rem;\n  --fontSizeLG: 1rem;\n  --fontSizeMD: 0.875rem;\n  --fontSizeSM: 0.75rem;\n  --fontSizeXS: 0.65rem;\n  --fontFamilyLight: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  --fontFamilyMono: 'Roboto Mono', monospace;\n  --colorBlack: rgb(0, 0, 0);\n  --colorWhite: rgb(255, 255, 255);\n  --colorGray: rgb(204, 204, 204);\n  --colorPrimary: rgb(0, 90, 143);\n  --colorSecondary: rgb(77, 172, 255);\n  --colorTertiary: rgb(40, 63, 88);\n  --colorQuaternary: rgb(206, 214, 228);\n  --statusDarkCritical: rgb(255, 56, 56);\n  --statusDarkSerious: rgb(255, 179, 0);\n  --statusDarkCaution: rgb(252, 232, 58);\n  --statusDarkNormal: rgb(86, 240, 0);\n  --statusDarkStandby: rgb(45, 204, 255);\n  --statusDarkOff: rgb(158, 167, 173);\n  --statusLightCritical: rgb(255, 42, 4);\n  --statusLightSerious: rgb(255, 175, 61);\n  --statusLightCaution: rgb(250, 216, 0);\n  --statusLightNormal: rgb(0, 226, 0);\n  --statusLightStandby: rgb(100, 217, 255);\n  --statusLightOff: rgb(142, 154, 163);\n  --classificationTopSecretSCIBackgroundColor: rgba(252, 232, 58);\n  --classificationTopSecretBackgroundColor: rgba(255, 140, 0);\n  --classificationSecretBackgroundColor: rgba(200, 16, 46);\n  --classificationConfidentialBackgroundColor: rgba(0, 51, 160);\n  --classificationControlledBackgroundColor: rgba(80, 43, 133);\n  --classificationUnclassifiedBackgroundColor: rgba(0, 122, 51);\n  --colorTag1: rgb(25, 199, 202);\n  --colorTag2: rgb(120, 112, 208);\n  --colorTag3: rgb(160, 13, 190);\n  --colorTag4: rgb(216, 83, 30);\n  --colorPrimaryLighten5: rgb(51, 123, 165);\n  --colorPrimaryLighten1: rgb(51, 123, 165);\n  --colorPrimaryLighten2: rgb(102, 156, 188);\n  --colorPrimaryLighten3: rgb(153, 189, 210);\n  --colorPrimaryLighten4: rgb(204, 222, 233);\n  --colorPrimaryDarken1: rgb(0, 72, 114);\n  --colorPrimaryDarken2: rgb(0, 54, 86);\n  --colorPrimaryDarken3: rgb(0, 36, 57);\n  --colorPrimaryDarken4: rgb(0, 18, 29);\n  --colorSecondaryLighten1: rgb(113, 189, 255);\n  --colorSecondaryLighten2: rgb(146, 203, 255);\n  --colorSecondaryLighten3: rgb(184, 222, 255);\n  --colorSecondaryLighten4: rgb(219, 238, 255);\n  --colorSecondaryDarken1: rgb(62, 138, 204);\n  --colorSecondaryDarken2: rgb(46, 103, 153);\n  --colorSecondaryDarken3: rgb(31, 69, 102);\n  --colorSecondaryDarken4: rgb(15, 34, 51);\n  --colorTertiaryLighten1: rgb(82, 102, 122);\n  --colorTertiaryLighten2: rgb(126, 140, 155);\n  --colorTertiaryLighten3: rgb(169, 178, 188);\n  --colorTertiaryLighten4: rgb(212, 217, 222);\n  --colorTertiaryDarken1: rgb(31, 51, 71);\n  --color-dark-background: rgb(24, 38, 53);\n  --color-dark-border: rgb(16, 25, 35);\n  --colorTertiaryDarken4: rgb(8, 13, 18);\n  --colorQuaternaryLighten1: rgb(217, 222, 233);\n  --colorQuaternaryLighten2: rgb(225, 230, 239);\n  --colorQuaternaryLighten3: rgb(236, 239, 244);\n  --colorQuaternaryLighten4: rgb(245, 246, 249);\n  --colorQuaternaryDarken1: rgb(166, 171, 182);\n  --colorQuaternaryDarken2: rgb(124, 128, 136);\n  --colorQuaternaryDarken3: rgb(83, 86, 91);\n  --colorQuaternaryDarken4: rgb(41, 43, 45);\n  --colorCriticalLighten1: rgb(255, 96, 96);\n  --colorCriticalLighten2: rgb(255, 136, 136);\n  --colorCriticalLighten3: rgb(255, 175, 175);\n  --colorCriticalLighten4: rgb(255, 215, 215);\n  --colorCriticalDarken1: rgb(204, 45, 45);\n  --colorCriticalDarken2: rgb(153, 34, 34);\n  --colorCriticalDarken3: rgb(102, 22, 22);\n  --colorCriticalDarken4: rgb(51, 11, 11);\n  --colorSeriousLighten1: rgb(255, 194, 51);\n  --colorSeriousLighten2: rgb(255, 209, 102);\n  --colorSeriousLighten3: rgb(255, 225, 153);\n  --colorSeriousLighten4: rgb(255, 240, 204);\n  --colorSeriousDarken1: rgb(204, 143, 0);\n  --colorSeriousDarken2: rgb(153, 107, 0);\n  --colorSeriousDarken3: rgb(102, 72, 0);\n  --colorSeriousDarken4: rgb(51, 36, 0);\n  --colorCautionLighten1: rgb(253, 237, 97);\n  --colorCautionLighten2: rgb(253, 241, 137);\n  --colorCautionLighten3: rgb(254, 246, 176);\n  --colorCautionLighten4: rgb(254, 250, 216);\n  --colorCautionDarken1: rgb(202, 186, 46);\n  --colorCautionDarken2: rgb(151, 139, 35);\n  --colorCautionDarken3: rgb(101, 93, 23);\n  --colorCautionDarken4: rgb(50, 46, 12);\n  --colorNormalLighten1: rgb(120, 243, 51);\n  --colorNormalLighten2: rgb(154, 246, 102);\n  --colorNormalLighten3: rgb(187, 249, 153);\n  --colorNormalLighten4: rgb(221, 252, 204);\n  --colorNormalDarken1: rgb(69, 192, 0);\n  --colorNormalDarken2: rgb(52, 144, 0);\n  --colorNormalDarken3: rgb(34, 96, 0);\n  --colorNormalDarken4: rgb(17, 48, 0);\n  --colorStandbyLighten1: rgb(87, 214, 255);\n  --colorStandbyLighten2: rgb(129, 224, 255);\n  --colorStandbyLighten3: rgb(171, 235, 255);\n  --colorStandbyLighten4: rgb(213, 245, 255);\n  --colorStandbyDarken1: rgb(36, 163, 204);\n  --colorStandbyDarken2: rgb(27, 122, 153);\n  --colorStandbyDarken3: rgb(18, 82, 102);\n  --colorStandbyDarken4: rgb(9, 41, 51);\n  --colorOffLighten1: rgb(177, 185, 189);\n  --colorOffLighten2: rgb(197, 202, 206);\n  --colorOffLighten3: rgb(216, 220, 222);\n  --colorOffLighten4: rgb(236, 237, 239);\n  --colorOffDarken1: rgb(126, 134, 138);\n  --colorOffDarken2: rgb(95, 100, 104);\n  --colorOffDarken3: rgb(63, 67, 69);\n  --colorOffDarken4: rgb(32, 33, 35);\n  --colorTag1Lighten1: rgb(71, 210, 213);\n  --colorTag1Lighten2: rgb(117, 221, 223);\n  --colorTag1Lighten3: rgb(163, 233, 234);\n  --colorTag1Lighten4: rgb(209, 244, 244);\n  --colorTag1Darken1: rgb(20, 159, 162);\n  --colorTag1Darken2: rgb(15, 119, 121);\n  --colorTag1Darken3: rgb(10, 80, 81);\n  --colorTag1Darken4: rgb(5, 40, 40);\n  --colorTag2Lighten1: rgb(147, 141, 217);\n  --colorTag2Lighten2: rgb(174, 169, 227);\n  --colorTag2Lighten3: rgb(201, 198, 236);\n  --colorTag2Lighten4: rgb(228, 226, 246);\n  --colorTag2Darken1: rgb(96, 90, 166);\n  --colorTag2Darken2: rgb(72, 67, 125);\n  --colorTag2Darken3: rgb(48, 45, 83);\n  --colorTag2Darken4: rgb(24, 22, 42);\n  --colorTag3Lighten1: rgb(179, 61, 203);\n  --colorTag3Lighten2: rgb(198, 110, 216);\n  --colorTag3Lighten3: rgb(217, 158, 229);\n  --colorTag3Lighten4: rgb(236, 207, 242);\n  --colorTag3Darken1: rgb(128, 10, 152);\n  --colorTag3Darken2: rgb(96, 8, 114);\n  --colorTag3Darken3: rgb(64, 5, 76);\n  --colorTag3Darken4: rgb(32, 3, 38);\n  --colorTag4Lighten1: rgb(224, 117, 75);\n  --colorTag4Lighten2: rgb(232, 152, 120);\n  --colorTag4Lighten3: rgb(239, 186, 165);\n  --colorTag4Lighten4: rgb(247, 221, 210);\n  --colorTag4Darken1: rgb(173, 66, 24);\n  --colorTag4Darken2: rgb(130, 50, 18);\n  --colorTag4Darken3: rgb(86, 33, 12);\n  --colorTag4Darken4: rgb(43, 17, 6);\n  --colorWhiteLighten1: rgb(255, 255, 255);\n  --colorWhiteLighten2: rgb(255, 255, 255);\n  --colorWhiteLighten3: rgb(255, 255, 255);\n  --colorWhiteLighten4: rgb(255, 255, 255);\n  --colorWhiteDarken1: rgb(204, 204, 204);\n  --colorWhiteDarken2: rgb(153, 153, 153);\n  --colorWhiteDarken3: rgb(102, 102, 102);\n  --colorWhiteDarken4: rgb(51, 51, 51);\n  --colorBlackLighten1: rgb(51, 51, 51);\n  --colorBlackLighten2: rgb(102, 102, 102);\n  --colorBlackLighten3: rgb(153, 153, 153);\n  --colorBlackLighten4: rgb(204, 204, 204);\n  --colorBlackDarken1: rgb(0, 0, 0);\n  --colorBlackDarken2: rgb(0, 0, 0);\n  --colorBlackDarken3: rgb(0, 0, 0);\n  --colorBlackDarken4: rgb(0, 0, 0);\n  --colorGrayLighten1: rgb(214, 214, 214);\n  --colorGrayLighten2: rgb(224, 224, 224);\n  --colorGrayLighten3: rgb(235, 235, 235);\n  --colorGrayLighten4: rgb(245, 245, 245);\n  --colorGrayDarken1: rgb(163, 163, 163);\n  --colorGrayDarken2: rgb(122, 122, 122);\n  --colorGrayDarken3: rgb(82, 82, 82);\n  --colorGrayDarken4: rgb(41, 41, 41);\n}\n\n/* Regular */\n@font-face {\n  font-family: 'Roboto';\n  src: url('../fonts/RobotoRegular.woff2') format('woff2'), url('../fonts/RobotoRegular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n}\n\n.light-theme {\n  /*\n\n    Global Colors\n    ==========================================================================\n\t*/\n  /* Astro 5 Simplified Color Palette */\n  --backgroundColor: var(--colorQuaternaryLighten3, #eaeef4);\n  --defaultText: var(--colorQuaternaryDarken4, #292a2d);\n  --secondaryText: var(--colorQuaternaryDarken3, #51555b);\n  --globalAppHeader: var(--color-dark-background, #172635);\n  --surfaceElements: var(--colorWhite, #ffffff);\n  --primary: var(--colorPrimary, #005a8f);\n  --primaryLight: var(--colorPrimaryLighten1, #2f7aa7);\n  --primaryDark: var(--colorPrimaryDarken1, #004872);\n  --primaryDarkHover: #0048724d;\n  /* TODO: this is a temporary fix, the use of opacity from Sketch is new and not accounted for in CSS */\n  --primaryElementText: var(--colorWhite, #ffffff);\n  --inputBackground: var(--colorWhite, #ffffff);\n  --inputDark: #080c11;\n  /* styles */\n  --fontColor: var(--defaultText);\n  --fontLowContrastColor: var(--secondaryText);\n  --fontInvertedColor: var(--primary);\n  --fontInvertedBackgroundColor: var(--backgroundColor);\n  --fontLinkColor: var(--primary);\n  --fontLinkHoverColor: var(--primaryDark);\n  --wcagCompliance: rgba(0, 0, 0, 0.5);\n  --criticalBorder: #7f1c1c;\n  --colorCritical: var(--statusLightCritical, rgb(255, 42, 4));\n  --colorSerious: var(--statusLightSerious, rgb(255, 175, 61));\n  --colorCaution: var(--statusLightCaution, rgb(250, 216, 0));\n  --colorNormal: var(--statusLightNormal, rgb(0, 226, 0));\n  --colorStandby: var(--statusLightStandby, rgb(100, 217, 255));\n  --colorOff: var(--statusLightOff, rgb(142, 154, 163));\n  /*\n\n    Button Colors\n    ==========================================================================\n    For standard and outline buttons\n\n  */\n  /* Button */\n  --buttonTextColor: var(--primaryElementText);\n  --buttonBackgroundColor: var(--primary);\n  --buttonBorderColor: var(--primary);\n  /* Button Hover State */\n  --buttonHoverTextColor: var(--primaryElementText);\n  --buttonHoverBackgroundColor: var(--primaryDark);\n  --buttonHoverBorderColor: var(--primaryDark);\n  /* Button Active State */\n  --buttonActiveControlTextColor: var(--defaultText);\n  --buttonActiveBackgroundColor: var(--primary);\n  --buttonActiveBorderColor: var(--primary);\n  /* Outline Button Variant */\n  --buttonOutlineTextColor: var(--colorPrimary, rgb(0, 90, 143));\n  --buttonOutlineBackgroundColor: transparent;\n  --buttonOutlineBorderColor: var(--colorPrimary, rgb(0, 90, 143));\n  /* Outline Button Variant Hover State */\n  --buttonOutlineHoverTextColor: var(--primaryDark);\n  --buttonOutlineHoverBackgroundColor: transparent;\n  --buttonOutlineHoverBorderColor: var(--primaryDark);\n  /*\n\n    Control Colors\n    ==========================================================================\n    For checkboxes, radio buttons etc …\n\n  */\n  --controlTextColor: var(--primaryElementText);\n  --controlLabelColor: var(--defaultText);\n  --controlBackgroundColor: var(--primary);\n  --controlBorderColor: var(--primary);\n  --controlAccentColor: var(--primary);\n  --controlSelectedTextColor: var(--defaultText);\n  --controlSelectedBackgroundColor: transparent;\n  --controlSelectedBorderColor: var(--primary);\n  --controlHoverOutlineBackgroundColor: none;\n  --controlHoverBorderColor: var(--primaryDark);\n  --controlSelectedOutlineBorderColor: var(--primary);\n  --controlSelectedOutlineBackgroundColor: none;\n  /*\n\n    Progress Bar Colors\n    ==========================================================================\n\n  */\n  --progressDeterminateBarBackgroundColor: var(--primary);\n  --progressDeterminateTrackBackgroundColor: var(--inputBackground);\n  --progressDeterminateTrackBorderColor: var(--primaryDark);\n  --progressIndeterminate: url(\"data:image/svg+xml,%3Csvg width='66' height='66' xmlns='http://www.w3.org/2000/svg'%3E %3Cdefs%3E %3ClinearGradient x1='70.883%25' y1='4.637%25' x2='50%25' y2='100%25' id='a'%3E %3Cstop stop-color='%235CB3FF' offset='0%25'/%3E %3Cstop stop-color='%23F6F7F8' stop-opacity='0' offset='100%25'/%3E %3C/linearGradient%3E %3C/defs%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath d='M33 65.5C15.05 65.5.5 50.95.5 33S15.05.5 33 .5 65.5 15.05 65.5 33 50.95 65.5 33 65.5zm0-7c14.083 0 25.5-11.417 25.5-25.5S47.083 7.5 33 7.5 7.5 18.917 7.5 33 18.917 58.5 33 58.5z' stroke='%23D7DDE2' fill='%23FFF'/%3E %3Cpath d='M51.908 8.236l-2.358 3.245A26.894 26.894 0 0 0 32 5C17.088 5 5 17.088 5 32s12.088 27 27 27c1.129 0 2.242-.07 3.334-.204l4.435 3.222C37.286 62.66 34.683 63 32 63 14.88 63 1 49.12 1 32 1 14.88 14.88 1 32 1c7.579 0 14.522 2.72 19.908 7.236z' fill='url(%23a)' transform='translate(1 1)'/%3E %3Cpath d='M48.564 13c1.92 0 3.557-.64 4.075-2.367.112-.375.361-.67.361-1.08C53 7.248 51.572 5 49.234 5S45 6.867 45 9.17c0 2.304 1.225 3.83 3.564 3.83z' stroke='%234DACFF' fill='%2352AEFF'/%3E %3C/g%3E %3C/svg%3E \");\n  /*\n\n    Popup Menu Colors\n    ==========================================================================\n\n  */\n  --popupMenuBackgroundColor: var(--inputBackground);\n  --popupMenuBorderColor: var(--primary);\n  --popupMenuTextColor: var(--defaultText);\n  --popupCaretBackgroundColor: var(--primary);\n  --popupMenuItemBackgroundColor: var(--inputBackground);\n  --popupMenuItemHoverBackgroundColor: var(--primaryDark);\n  --popupMenuItemHoverTextColor: var(--primaryElementText);\n  --popupMenuItemSeperatorBorderColor: var(--defaultText);\n  /*\n\n    Slider Colors\n    ==========================================================================\n\n  */\n  --sliderThumbBackgroundColor: var(--primaryDark);\n  --sliderThumbBorderColor: var(--inputBackground);\n  --sliderHoverThumbBackgroundColor: var(--primaryDark);\n  --sliderHoverThumbBorderColor: var(--inputBackground);\n  --sliderTrackBorderColor: var(--secondaryText);\n  --sliderTrackBackgroundColor: var(--inputBackground);\n  --sliderSelectedThumbBorderColor: var(--primaryLight);\n  --sliderSelectedTrackBackgroundColor: var(--primary);\n  --sliderThumbBorderSize: 1px;\n  --sliderTrackBorderSize: 0.25px;\n  /*\n\n    Segmented Button Colors\n    ==========================================================================\n\n  */\n  --segmentedButtonBorderColor: var(--primary);\n  --segmentedButtonBackgroundColor: none;\n  --segmentedButtonTextColor: var(--primary);\n  /* Segmented Hover */\n  --segmentedButtonHoverBackgroundColor: var(--primaryDark);\n  --segmentedButtonHoverTextColor: var(--primaryElementText);\n  --segmentedButtonHoverBorderColor: var(--primaryDark);\n  /* Segmented Select */\n  --segmentedButtonSelectedBackgroundColor: var(--primary);\n  --segmentedButtonSelectedTextColor: var(--primaryElementText);\n  /*\n\n    Drop Down/Select Colors\n    ==========================================================================\n\n  */\n  --selectHoverOptBackgroundColor: var(--primaryDark);\n  --selectCaret: url('data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23080c11%22%20d%3D%22M0%200h10L5%205z%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E');\n  /*\n\n    Switch Colors\n    ==========================================================================\n\n  */\n  --switchOffColor: var(--secondaryText);\n  --switchOnColor: var(--primary);\n  --switchHoverOnColor: var(--primaryDark);\n  --switchHoverOffColor: var(--primaryDark);\n  --switchDisabledOnColor: var(--primary);\n  --switchDisabledOffColor: var(--secondaryText);\n  /*\n\n    Push Button Colors\n    ==========================================================================\n\n  */\n  --pushbuttonBackgroundColor: none;\n  --pushbuttonBorderColor: var(--primary);\n  --pushbuttonTextColor: var(--primary);\n  --pushbuttonSelectedBackgroundColor: var(--colorNormal);\n  --pushbuttonSelectedBorderColor: var(--colorNormal);\n  --pushbuttonSelectedTextColor: var(--defaultText);\n  /*\n\n    Clock Colors\n    ==========================================================================\n\n  */\n  --clockTextColor: var(--primaryElementText);\n  --clockBackgroundColor: #101923;\n  --clockBorderColor: #1b2d3e;\n  --clockLabelColor: var(--primaryElementText);\n  /*\n\n    Modal Colors\n    ==========================================================================\n\n  */\n  --modalTitleColor: var(--primaryElementText);\n  --modalTextColor: var(--defaultText);\n  --modalBackgroundColor: var(--surfaceElements);\n  --modalBorderColor: var(--primary);\n  /*\n\n    Log Colors\n    ==========================================================================\n\n  */\n  --logTextColor: var(--defaultText);\n  --logBackgroundColor: var(--surfaceElements);\n  --logBorderColor: var(--secondaryText);\n  --logHeaderTextColor: var(--defaultText);\n  --logHeaderBackgroundColor: var(--backgroundColor);\n  --logFilterBackgroundColor: var(--primaryLight);\n  --logFilterTextColor: var(--primaryElementText);\n  /*\n\n    Tree Colors\n    ==========================================================================\n\n  */\n  --treeTextColor: var(--defaultText);\n  --treeBackgroundColor: var(--surfaceElements);\n  --treeBorderColor: var(--primaryDark);\n  --treeItemBorderColor: var(--primaryDark);\n  --treeAccentColor: var(--primary);\n  /* Hover */\n  --treeHoverBackgroundColor: var(--primaryDark);\n  --treeHoverTextColor: var(--primaryElementText);\n  --treeHoverAccentColor: var(--primary);\n  /* Selected */\n  --treeSelectedBackgroundColor: var(--surfaceElements);\n  --treeSelectedBorderColor: var(--primaryDark);\n  --treeSelectedTextColor: var(--defaultText);\n  --treeSelectedAccentColor: var(--primary);\n  --treeChildrenBackgroundColor: var(--surfaceElements);\n  --treeExpandedBorderColor: var(--backgroundColor);\n  /*\n\n    Tab Colors\n    ==========================================================================\n\n  */\n  --tabTextColor: var(--primary);\n  --tabBackgroundColor: transparent;\n  --tabBorderColor: transparent;\n  --tabHoverTextColor: var(--defaultText);\n  --tabSelectedTextColor: var(--defaultText);\n  --tabSelectedBorderColor: var(--primary);\n  /*\n\n    Notification Colors\n    ==========================================================================\n\n\t*/\n  --notificationTextColor: var(--defaultText);\n  /*\n\n    Classification Colors\n    ==========================================================================\n\n\t*/\n  --classificationTextColorLight: var(--primaryElementText);\n  --classificationTextColorDark: var(--defaultText);\n  /*\n\n    Card Colors\n    ==========================================================================\n\n  */\n  --cardBackgroundColor: var(--colorQuaternaryLighten2);\n  --cardHeaderBackgroundColor: var(--colorQuaternaryLighten1);\n  --cardHeaderTextColor: var(--colorWhite, #fff);\n  /*\n\n    Input/Text Field Colors\n    ==========================================================================\n\n  */\n  --inputBackgroundColor: var(--inputBackground);\n  --inputBorderColor: var(--primaryLight);\n  --inputBorderColorAlt: var(--inputDark);\n  --inputBorderColorDisabled: #292a2d;\n  --inputTextColor: var(--defaultText);\n  --inputFocusBorderColor: var(--primary);\n  --inputFocusTextColor: var(--defaultText);\n  --inputInvalidBorderColor: var(--colorCritical);\n  --inputSearchIcon: url(\"data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M35.37 26.457a15.282 15.282 0 000-21.918c-6.176-6.052-16.187-6.052-22.361 0a15.274 15.274 0 00-1.541 20.166c-.367.147-.713.37-1.014.665L.926 34.709a3.056 3.056 0 000 4.383 3.208 3.208 0 004.472 0l9.528-9.339c.352-.345.604-.753.756-1.186 6.137 3.831 14.347 3.124 19.687-2.11zM24.193 4.043c6.454 0 11.686 5.129 11.686 11.455 0 6.326-5.232 11.455-11.686 11.455-6.455 0-11.687-5.129-11.687-11.455 0-6.326 5.232-11.455 11.687-11.455z' fill='%233a87cf' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  --inputSearchCancel: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Cpath fill='%23004872' fill-rule='evenodd' d='M69.028 64l22.628 22.627-5.029 5.029L64 69.028 41.373 91.656l-5.029-5.029L58.972 64 36.344 41.373l5.029-5.029L64 58.972l22.627-22.628 5.029 5.029L69.028 64z'/%3E%3C/svg%3E\");\n  /*\n\n    Icon Default Colors\n    ==========================================================================\n\n\t*/\n  --iconDefaultColor: var(--primary);\n  /*\n\n    Status Symbols\n    ==========================================================================\n\n  */\n  --statusSymbols: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAA81BMVEUAAABaPhVcDwE7CQA6gJIAAAAATQAkTlsATgBcPxYrHAciGgkAAABcPxU0coUARgAxNTgnU2IoV2YzNjoAUgAtYXEzODovZngAUQAAUAAwNDg0dIk2d4sAOgAjKCgAGAAADQA+hJVZPBRcPxb62AAA4gD/rz1VSQBk2f//KgQiSldXDgEATQCOmqNXOxQwNDdoRhiGWx+tHAJiEAFZw+b1KAMAywDlnTb5qjv7rDzpnzdMpcNJn7xFlrGMmKGEj5g4eY82d4xxe4IyboIwaHskT15GTFEA2gAArAAAnAAAfgAAfABg0vddyu5cZGpg0fbOjTE6oyFAAAAAJHRSTlMA7cc4Kgj9+vbBJB4GypVn9vPu5t/Y18O8n4B/ckY6FRMdmtlkVn4PAAACq0lEQVRYw+2YaVPaUBSGqWbTWsK+b9pC6ek1lypGW1T2RUDb//9rmpsm3Nyc1DQfOhMc3k/cyUzmfeY5BxISh+xXzi7eJ/Y5ZyfGu30msPobQQSf/5KEmKZeymlarqQ3g28vJfMZVc3kk1LUYkdfA3OE+/duv3GCaACtskKcKOVWQP0i7FKMiHAcDHAc0L9zxwgQwKeAiAB1jZD1ylwuzdWaEK3u71BTAUaD/nbbH4wA1FpUBVdffLliAnD/DieIBKArZGO2nZgboujiLZIA437XSX8MkIyo4PpG7H9zzQTg/pwgEkBdIU9tT56IIjioATx0PXkAqEVWgAXg/pwgEkBLY/1FAq3lmX+V9RcJVLwHcqWQShUqcpgCLgD35wRRAMpk0/ZlQ8r8BkUY27XvZ/P57N7+OIaiv2QjS+1kG2EKuADcHxOEAzQVYvoBTKI0dwIA2Pw/T8HO9JntAYDk60/pYjIcThaUNkIUcAG4PyYIB9DJuo2yJjrf4FHXyhTSVUmqpmHKTiPfHstZ+vJ4aeXxhWblYAVYAO6PCcIBSmSFAVak5F7Pw4DND6TP2ek8DWyKBpAXClbogvVnBAtaCVaABeD+mCAcIMcmCM9Qzr2esSdoBtU/xyrM7BnKCAULdHLpZEILr2wBEnBhGL86OHc94+M/AmhkiQGWRHOvq7C1Gs/doZdgbh23oAr9UnToAgxp6pUvIrQB8gej9wP1/24ZOP2fAD+jAHAFXAAmwP1jNUK2Ai4AE+D+sVpiRwEXgAhQ/3h9jboKuABMIPaP1w8ZV8AFIAKhf8weJXYKBAGIgPeP2cMcVyAIwARu/7g9TnMFggBM4PSP2wuNR4EgABPc2v1j90rpUSAIwAQG6x+7l3qvAkEAJmD94/e3ileBIAATnJwmDjnkTeU3PTFjExFNx+YAAAAASUVORK5CYII=');\n  /*\n\n\n    Scrollbar Colors -- Light\n    ==========================================================================\n\n  */\n  --scrollBarThumbBackgroundColor: var(--colorQuaternaryDarken1, #9ba0aa);\n  --scrollBarThumbBackgroundHoverColor: var(--colorQuaternaryDarken2, #676a71);\n  --scrollBarTrackBackgroundColor: transparent;\n  --scrollBarTrackCornerBackgroundColor: var(--colorQuaternaryLighten4, #f2f4f7);\n  /*\n\n    Timeline Colors -- Dark\n    ==========================================================================\n\n  */\n  --timelineHeaderBackgroundColor: var(--surfaceElements);\n  --timelineHeaderTextColor: var(--defaultText);\n  --timelineRulerBackgroundColor: var(--surfaceElements);\n  --timelineRulerTextColor: var(--defaultText);\n  --timelineTrackLabelBackgroundColor: var(--surfaceElements);\n  --timelineTrackBackgroundColor: var(--surfaceElements);\n  --timelineRegionBackgroundColor: var(--backgroundColor);\n  --timelineRegionTextColor: var(--defaultText);\n  --timelineRegionBorderColor: var(--primary);\n  --timelineRegionSelectedBorderColor: var(--defaultText);\n  --timelineRegionSelectedBackgroundColor: var(--primaryDark);\n  --timelineRegionSelectedTextColor: var(--primaryElementText);\n  --timelineRegionStatusColorNormal: var(--colorNormal);\n  --timelineRegionStatusColorCritical: var(--colorCritical);\n  --timelineRegionStatusColorSerious: var(--colorSerious);\n  --timelineRegionStatusColorCaution: var(--colorCautiom);\n  --timelineRegionStatusColorStandby: var(--colorStandby);\n  --timelineRegionStatusColorOff: var(--colorOff);\n  /*\n\n    ACCORDION COLORS\n    ==========================================================================\n\n  */\n  --accordionBorderColor: rgb(207, 214, 227);\n  --accordionContentBackground: rgb(226, 230, 238);\n  --accordionClosedLabelBackground: rgb(255, 255, 255);\n  --accordionOpenLabelBackground: rgb(245, 247, 249);\n  --accordionHoverLabelBackground: rgb(236, 239, 244);\n  --accordionColor: rgb(0, 0, 0);\n  /*\n\n    TABLE COLORS\n    ==========================================================================\n\n  */\n  --tableBorderColor: var(--backgroundColor);\n  --tableHeaderBackgroundColor: var(--globalAppHeader);\n  --tableHeaderBorderColor: var(--surfaceElements);\n  --tableHeaderTextColor: var(--primaryElementText);\n  --tableHeaderBoxShadow: 0 0.1rem 0.45rem rgba(0, 0, 0, 0.2);\n  --tableHeaderAccentColor: var(--primary);\n  --tableRowBackgroundColor: var(--surfaceElements);\n  --tableRowBorderColor: var(--backgroundColor);\n  --tableRowTextColor: var(--defaultText);\n  --tableRowHoverBackgroundColor: var(--primaryDarkHover);\n  --tableRowHoverTextColor: var(--defaultText);\n  --tableRowSelectedBackgroundColor: var(--backgroundColor);\n  --tableRowSelectedBorderColor: var(--primary);\n  --tableControlsBackgroundColor: var(--primary);\n  --tableFilterBorderColor: var(--primary);\n  --tableFilterDisabledBorderColor: var(--backgroundColor);\n  --tableFilterDisabledBackgroundColor: var(--surfaceElements);\n}\n\nli.light-theme {\n  display: none;\n}\n\n.dark-theme {\n  /*\n\n    Global Colors\n    =========================================================================\n\t*/\n  /* Astro 5 Simplified Colors */\n  --backgroundColor: var(--color-dark-border, #101923);\n  --defaultText: var(--colorWhite, #ffffff);\n  --secondaryText: var(--colorTertiaryLighten4, #d4d8dd);\n  --globalAppHeader: var(--color-dark-background, #172635);\n  --surfaceElements: #1b2d3e;\n  /* TODO: this is an unofficial Astro color, but a required KM color */\n  --primary: var(--colorSecondary, #4dacff);\n  --primaryLight: var(--colorSecondaryLighten2, #92cbff);\n  --primaryLightHover: #92cbff4d;\n  /* TODO: this is a temporary fix, the use of opacity from Sketch is new and not accounted for in CSS */\n  --primaryDark: var(--colorSecondaryDarken1, #3a87cf);\n  --primaryDarkHover: #6b8ca5;\n  --primaryElementText: var(--colorTertiaryDarken4, #080c11);\n  --inputBackground: var(--colorWhite, #ffffff);\n  --inputDark: var(--colorTertiaryDarken4, #080c11);\n  /* styles */\n  --fontColor: var(--defaultText);\n  --fontLowContrastColor: var(--secondaryText);\n  --fontInvertedColor: var(--primary);\n  --fontInvertedBackgroundColor: var(--backgroundColor);\n  --fontLinkColor: var(--primary);\n  --fontLinkHoverColor: var(--primaryLight);\n  /* Status Custom */\n  --wcagCompliance: rgba(255, 255, 255, 0);\n  --criticalBorder: var(--colorCritical, rgb(255, 56, 56));\n  --colorCritical: var(--statusDarkCritical, rgb(255, 42, 4));\n  --colorSerious: var(--statusDarkSerious, rgb(255, 175, 61));\n  --colorCaution: var(--statusDarkCaution, rgb(250, 216, 0));\n  --colorNormal: var(--statusDarkNormal, rgb(0, 226, 0));\n  --colorStandby: var(--statusDarkStandby, rgb(45, 204, 255));\n  --colorOff: var(--statusDarkOff, rgb(142, 154, 163));\n  /*\n\n    Button Colors\n    ==========================================================================\n    For standard and outline buttons\n\n  */\n  /* Button */\n  --buttonTextColor: var(--primaryElementText);\n  --buttonBackgroundColor: var(--primary);\n  --buttonBorderColor: transparent;\n  /* Button Hover State */\n  --buttonHoverTextColor: var(--primaryElementText);\n  --buttonHoverBackgroundColor: var(--primaryLight);\n  --buttonHoverBorderColor: transparent;\n  /* Button Active State */\n  --buttonActiveControlTextColor: var(--defaultText);\n  --buttonActiveBackgroundColor: var(--primary);\n  --buttonActiveBorderColor: var(--primary);\n  /* Outline Button Variant */\n  --buttonOutlineTextColor: var(--primary);\n  --buttonOutlineBackgroundColor: transparent;\n  --buttonOutlineBorderColor: var(--colorPrimary, rgb(0, 90, 143));\n  /* Outline Button Variant Hover State */\n  --buttonOutlineHoverTextColor: var(--primaryLight);\n  --buttonOutlineHoverBackgroundColor: transparent;\n  --buttonOutlineHoverBorderColor: var(--primaryLight);\n  /*\n\n    Control Colors\n    ==========================================================================\n    For checkboxes, radio buttons etc …\n\n  */\n  --controlTextColor: var(--primaryElementText);\n  --controlLabelColor: var(--defaultText);\n  --controlBackgroundColor: var(--primary);\n  --controlBorderColor: var(--primary);\n  --controlAccentColor: var(--primary);\n  --controlSelectedTextColor: var(--defaultText);\n  --controlSelectedBackgroundColor: var(--primaryDark);\n  --controlSelectedBorderColor: var(--primary);\n  --controlHoverBorderColor: var(--primaryLight);\n  --controlSelectedOutlineBorderColor: var(--primary);\n  /*\n\n    Progress Colors\n    ==========================================================================\n\n  */\n  --progressDeterminateBarBackgroundColor: var(--colorSecondary, rgb(77, 172, 255));\n  --progressDeterminateTrackBackgroundColor: rgba(0, 0, 0, 0.3);\n  --progressDeterminateTrackBorderColor: var(--primaryDark);\n  --progressIndeterminate: url(\"data:image/svg+xml,%3Csvg width='64' height='64' xmlns='http://www.w3.org/2000/svg'%3E %3Cdefs%3E %3ClinearGradient x1='65.479%25' y1='-8.436%25' x2='50%25' y2='100%25' id='a'%3E %3Cstop stop-color='%234dacff' offset='0%25'/%3E %3Cstop stop-color='%234dacff' stop-opacity='0' offset='100%25'/%3E %3C/linearGradient%3E %3C/defs%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cpath d='M32 64C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32zm0-6c14.36 0 26-11.64 26-26S46.36 6 32 6 6 17.64 6 32s11.64 26 26 26z' fill='rgba(0,0,0,.3)'/%3E %3Cpath d='M51.908 8.236l-2.358 3.245A26.894 26.894 0 0 0 32 5C17.088 5 5 17.088 5 32s12.088 27 27 27c1.129 0 2.242-.07 3.334-.204l4.435 3.222C37.286 62.66 34.683 63 32 63 14.88 63 1 49.12 1 32 1 14.88 14.88 1 32 1c7.579 0 14.522 2.72 19.908 7.236z' fill='url(%23a)'/%3E %3Cpath d='M47.564 12c1.92 0 3.557-.64 4.075-2.367.112-.375.361-.67.361-1.08C52 6.248 50.572 4 48.234 4S44 5.867 44 8.17c0 2.304 1.225 3.83 3.564 3.83z' fill='%234dacff'/%3E %3C/g%3E %3C/svg%3E \");\n  /*\n\n    Slider Colors\n    ==========================================================================\n\n  */\n  --sliderThumbBackgroundColor: var(--primaryDark);\n  --sliderThumbBorderColor: var(--inputBackground);\n  --sliderHoverThumbBackgroundColor: var(--primaryDark);\n  --sliderHoverThumbBorderColor: var(--inputBackground);\n  --sliderTrackBorderColor: transparent;\n  --sliderTrackBackgroundColor: var(--secondaryText);\n  --sliderSelectedThumbBorderColor: var(--primaryLight);\n  --sliderSelectedTrackBackgroundColor: var(--primary);\n  --sliderThumbBorderSize: 1px;\n  --sliderTrackBorderSize: 1px;\n  /*\n\n    Segmented Button Colors\n    ==========================================================================\n\n  */\n  --segmentedButtonBorderColor: var(--primary);\n  --segmentedButtonBackgroundColor: none;\n  --segmentedButtonTextColor: var(--primary);\n  /* Segmented Hover */\n  --segmentedButtonHoverBackgroundColor: var(--primaryLight);\n  --segmentedButtonHoverTextColor: var(--primaryElementText);\n  --segmentedButtonHoverBorderColor: var(--primaryLight);\n  /* Segmented Select */\n  --segmentedButtonSelectedBackgroundColor: var(--primary);\n  --segmentedButtonSelectedTextColor: var(--primaryElementText);\n  /*\n\n    Drop Down/Select Colors\n    ==========================================================================\n\n  */\n  --selectHoverOptBackgroundColor: var(--primaryLight);\n  /*\n\n    Switch Colors\n    ==========================================================================\n\n  */\n  --switchOffColor: var(--secondaryText);\n  --switchOnColor: var(--primary);\n  --switchHoverOnColor: var(--primaryLight);\n  --switchHoverOffColor: var(--primaryLight);\n  --switchDisabledOnColor: var(--primary);\n  --switchDisabledOffColor: var(--secondaryText);\n  /*\n\n    Popup Menu Colors\n    ==========================================================================\n\n  */\n  --popupMenuBackgroundColor: var(--inputBackground);\n  --popupMenuBorderColor: var(--primary);\n  --popupMenuTextColor: var(--primaryElementText);\n  --popupCaretBackgroundColor: var(--primary);\n  --popupMenuItemBackgroundColor: var(--primary);\n  --popupMenuItemHoverBackgroundColor: var(--primaryLight);\n  --popupMenuItemHoverTextColor: var(--primaryElementText);\n  --popupMenuItemSeperatorBorderColor: var(--primaryElementText);\n  /*\n\n    Pushbutton Colors\n    ==========================================================================\n\n  */\n  --pushbuttonBackgroundColor: none;\n  --pushbuttonBorderColor: var(--primary);\n  --pushbuttonTextColor: var(--primary);\n  --pushbuttonSelectedBackgroundColor: var(--colorNormal);\n  --pushbuttonSelectedBorderColor: var(--colorNormal);\n  --pushbuttonSelectedTextColor: var(--primaryElementText);\n  /*\n\n    Clock Colors\n    ==========================================================================\n\n  */\n  --clockTextColor: var(--defaultText);\n  --clockBackgroundColor: var(--backgroundColor);\n  --clockBorderColor: var(--surfaceElements);\n  --clockLabelColor: var(--defaultText);\n  /*\n\n    Modal Colors\n    ==========================================================================\n\n  */\n  --modalTitleColor: var(--primaryElementText);\n  --modalTextColor: var(--defaultText);\n  --modalBackgroundColor: var(--surfaceElements);\n  --modalBorderColor: var(--primary);\n  /*\n\n  /*\n\n    Log Colors\n    ==========================================================================\n\n  */\n  --logTextColor: var(--defaultText);\n  --logBackgroundColor: var(--surfaceElements);\n  --logBorderColor: var(--backgroundColor);\n  --logHeaderTextColor: var(--defaultText);\n  --logHeaderBackgroundColor: var(--globalAppHeader);\n  --logFilterBackgroundColor: var(--primaryDark);\n  --logFilterTextColor: var(--primaryElementText);\n  /*\n\n    Tree Colors\n    ==========================================================================\n\n  */\n  --treeTextColor: var(--defaultText);\n  --treeBackgroundColor: var(--surfaceElements);\n  --treeBorderColor: var(--primaryDark);\n  --treeItemBorderColor: var(--primaryDark);\n  --treeAccentColor: var(--primary);\n  /* Hover*/\n  --treeHoverBackgroundColor: var(--primaryLight);\n  --treeHoverTextColor: var(--primaryElementText);\n  --treeHoverAccentColor: var(--primary);\n  /* Selected */\n  --treeSelectedBackgroundColor: var(--surfaceElements);\n  --treeSelectedBorderColor: var(--primaryDark);\n  --treeSelectedTextColor: var(--defaultText);\n  --treeSelectedAccentColor: var(--primary);\n  --treeChildrenBackgroundColor: var(--surfaceElements);\n  --treeExpandedBorderColor: var(--backgroundColor);\n  /*\n\n    Tab Colors\n    ==========================================================================\n\n  */\n  --tabTextColor: var(--primary);\n  --tabBackgroundColor: transparent;\n  --tabBorderColor: transparent;\n  --tabHoverTextColor: var(--defaultText);\n  --tabSelectedTextColor: var(--defaultText);\n  --tabSelectedBorderColor: var(--primary);\n  /*\n\n    Notification Colors\n    ==========================================================================\n\n\t*/\n  --notificationTextColor: var(--primaryElementText);\n  /*\n\n    Classification Colors\n    ==========================================================================\n\n\t*/\n  --classificationTextColorLight: var(--defaultText);\n  --classificationTextColorDark: var(--primaryElementText);\n  /*\n\n    Card Colors\n    ==========================================================================\n\n  */\n  --cardBackgroundColor: var(--colorTertiaryDarken1);\n  --cardHeaderBackgroundColor: var(--color-dark-border);\n  --cardHeaderTextColor: var(--colorWhite, #fff);\n  /*\n\n    Input/Text Field Colors\n    ==========================================================================\n\n  */\n  --inputBackgroundColor: var(--inputBackground);\n  --inputBorderColor: var(--surfaceElements);\n  --inputBorderColorAlt: var(--inputDark);\n  --inputBorderColorDisabled: #292a2d;\n  --inputTextColor: var(--primaryElementText);\n  /* Input Focus */\n  --inputFocusBorderColor: var(--primary);\n  --inputFocusTextColor: var(--primaryElementText);\n  --inputInvalidBorderColor: var(--colorCritical);\n  --inputSearchIcon: url(\"data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M35.37 26.457a15.282 15.282 0 000-21.918c-6.176-6.052-16.187-6.052-22.361 0a15.274 15.274 0 00-1.541 20.166c-.367.147-.713.37-1.014.665L.926 34.709a3.056 3.056 0 000 4.383 3.208 3.208 0 004.472 0l9.528-9.339c.352-.345.604-.753.756-1.186 6.137 3.831 14.347 3.124 19.687-2.11zM24.193 4.043c6.454 0 11.686 5.129 11.686 11.455 0 6.326-5.232 11.455-11.686 11.455-6.455 0-11.687-5.129-11.687-11.455 0-6.326 5.232-11.455 11.687-11.455z' fill='%23005a92' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  --inputSearchCancel: url(\"data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 128 128'%3E%3Cpath fill='%233a87cf' fill-rule='evenodd' d='M69.028 64l22.628 22.627-5.029 5.029L64 69.028 41.373 91.656l-5.029-5.029L58.972 64 36.344 41.373l5.029-5.029L64 58.972l22.627-22.628 5.029 5.029L69.028 64z'/%3E%3C/svg%3E\");\n  /*\n\n    Icon Default Colors\n    ==========================================================================\n\n\t*/\n  --iconDefaultColor: var(--primary);\n  /*\n\n    Status Symbols\n    ==========================================================================\n\n  */\n  --statusSymbols: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAAgVBMVEUAAAD/tQv/swL/OTn/PDzftl9W8QBW8AAtzP8v0P9Z9gD/tAP/uQb/tAItzf8tzf+eqK2ep60uzP9X8QCfqK4uzf8uzf9X8QAuzP9X8ACeqK4vzP9Y8QAuzv9Y8gCeqq4wz/8xzv9A1f9Y8QD/tAP86DpW8AD/swL/ODgtzP+ep63tgXPUAAAAJXRSTlMAGNfAQAv98/IdG8Io52zz8+DZ2dC9trabm4F+a05OQjAaDG6dAJcYcwAAAfdJREFUWMPtmNlygkAQRScyrBp3QTZFNBj8/w9MCGI3dBOHMg9jyvOmVFnn1HUSULx4LibjN/HMTN7Po2cu+PY/cwUfPYg2XhKsbHsVJJ5gcaf+cjZb+lN3qJjxyWIw/lAwNMALreKKFTIJh215Y3sYFiD5AEn9oWBowM4uEPau65A6JcJJ/2ACg/pDwdCAo1W0sI6ixbTsMH18Akn9oWBgwK7xh4LWBmlJSB+dwCD+pEA5wLMLgo3OwcGpvzhxludZfH1Bz4EZrefzdWSqTSCJPylQDggLhhA+oD6/G7d+5W7qk9yV3C8uPyz2KhMYxJ8UKAd4Fhdg3SZwa3/4wLrA7fhfbuwVJpDEnxQoByQFS9I6wQ7ydR16js0FBCzMuxMY1J8WqAYEfEDQXPcr3RjbxNU7vsBEF0R0dwJJ/LkCxYAVH7Bqri8r3QzbZNU7S4FZ44B1/ymgA4zPfZwUA2w+wG6uzyrdHMvk1TszgZnjgLmgyL4T8Dbq8R+bWgUIgw4ABby/Vl8hIckAUMD7a3WIYQIYgC0Af73+jOIJpKAF1F+vf2QwAQxAC7C/ZrcSeAIpegvAX7ObOZgABiAF2F+322mYAAagBeCv2wMNTEAGIAWVv3aPlDABDMAW1P7aPdQjDBiALaj89ftZBSGl+LXgZIoXL/4VXyptNwzuHR/QAAAAAElFTkSuQmCC');\n  /*\n\n    Scrollbar Colors -- Dark\n    ==========================================================================\n\n  */\n  --scrollBarThumbBackgroundColor: var(--colorSecondaryDarken2, rgb(46, 103, 153));\n  --scrollBarThumbBackgroundHoverColor: var(--colorSecondaryDarken1, rgb(58, 129, 191));\n  --scrollBarTrackBackgroundColor: var(--colorTertiaryDarken1, rgb(32, 50, 70));\n  --scrollBarTrackCornerBackgroundColor: var(--colorTertiaryDarken1, rgb(32, 50, 70));\n  /*\n\n    Timeline Colors -- Dark\n    ==========================================================================\n\n  */\n  --timelineHeaderBackgroundColor: var(--surfaceElements);\n  --timelineHeaderTextColor: var(--defaultText);\n  --timelineRulerBackgroundColor: var(--surfaceElements);\n  --timelineRulerTextColor: var(--defaultText);\n  --timelineTrackLabelBackgroundColor: var(--surfaceElements);\n  --timelineTrackBackgroundColor: var(--surfaceElements);\n  --timelineRegionBackgroundColor: var(--backgroundColor);\n  --timelineRegionTextColor: var(--defaultText);\n  --timelineRegionBorderColor: var(--primary);\n  --timelineRegionSelectedBorderColor: var(--inputBackground);\n  --timelineRegionSelectedBackgroundColor: var(--primaryDark);\n  --timelineRegionSelectedTextColor: var(--defaultText);\n  --timelineRegionStatusColorNormal: var(--colorNormal);\n  --timelineRegionStatusColorCritical: var(--colorCritical);\n  --timelineRegionStatusColorSerious: var(--colorSerious);\n  --timelineRegionStatusColorCaution: var(--colorCautiom);\n  --timelineRegionStatusColorStandby: var(--colorStandby);\n  --timelineRegionStatusColorOff: var(--colorOff);\n  /*\n\n    ACCORDION COLORS\n    ==========================================================================\n\n  */\n  --accordionBorderColor: rgb(40, 63, 88);\n  --accordionContentBackground: rgb(20, 32, 44);\n  --accordionClosedLabelBackground: rgb(32, 50, 70);\n  --accordionOpenLabelBackground: rgb(40, 63, 88);\n  --accordionHoverLabelBackground: rgb(46, 103, 153);\n  --accordionColor: rgb(255, 255, 255);\n  /*\n\n    TABLE COLORS\n    ==========================================================================\n\n  */\n  --tableBorderColor: var(--backgroundColor);\n  --tableHeaderBackgroundColor: var(--globalAppHeader);\n  --tableHeaderBorderColor: var(--surfaceElements);\n  --tableHeaderTextColor: var(--defaultText);\n  --tableHeaderBoxShadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.45);\n  --tableHeaderAccentColor: var(--primary);\n  --tableRowBackgroundColor: var(--surfaceElements);\n  --tableRowTextColor: var(--defaultText);\n  --tableRowBorderColor: var(--backgroundColor);\n  --tableRowHoverBackgroundColor: var(--primaryLightHover);\n  --tableRowHoverTextColor: var(--defaultText);\n  --tableRowSelectedBackgroundColor: var(--backgroundColor);\n  --tableRowSelectedBorderColor: var(--primary);\n  --tableControlsBackgroundColor: var(--primary);\n  --tableFilterBorderColor: var(--primary);\n  --tableFilterDisabledBorderColor: var(--backgroundColor);\n  --tableFilterDisabledBackgroundColor: var(--surfaceElements);\n}\n\nli.dark-theme {\n  display: none;\n}\n\nh1,\nh2,\nh3 {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-weight: 400;\n  color: var(--defaultText);\n  margin: 0 0 0.5rem 0;\n}\n\nh1,\n.h1 {\n  font-size: 2.125rem;\n}\n\nh2,\n.h2 {\n  font-size: 1.5rem;\n}\n\nh3,\n.h3 {\n  font-size: 1.25rem;\n  font-weight: 500;\n}\n\np {\n  margin: 0 0 1rem 0;\n  color: var(--defaultText);\n}\n\na {\n  color: var(--fontLinkColor);\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--fontLinkHoverColor);\n}\n\ndt {\n  font-weight: 600;\n  margin: 0;\n}\n\ndd {\n  margin: 0 0 0.5rem 0;\n}\n\n.light {\n  font-weight: 300;\n}\n\n.regular {\n  font-weight: 500;\n}\n\n.semi-bold {\n  font-weight: 600;\n}\n\n.bold {\n  font-weight: 700;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.condensed {\n  font-stretch: condensed;\n}\n\n.monospace {\n  font-family: 'Roboto Mono', sans-serif;\n}\n\n.invert,\n.inverted {\n  background-color: var(--fontInvertedBackgroundColor);\n  color: var(--fontInvertedColor);\n  padding: 0 0.25rem;\n}\n\n.low-contrast {\n  opacity: 0.2;\n}\n\n/* Size Options */\n.xl {\n  font-size: 1.125rem;\n  font-size: var(--fontSizeXL);\n}\n\n.lg {\n  font-size: 1rem;\n  font-size: var(--fontSize);\n}\n\n.md {\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n}\n\n.sm {\n  font-size: 0.75rem;\n  font-size: var(--fontSizeSM);\n}\n\n.xs {\n  font-size: 0.65rem;\n  font-size: var(--fontSizeXS);\n}\n\n/*\n**\tThis is as close as we get to a CSS reset in Astro, moving everything to\n**\tthe old IE border-box model of including padding in the overall size.\n*/\nhtml {\n  box-sizing: border-box;\n  -webkit-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\n/*\n**\n**\n**\n*/\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-size: 1rem;\n  color: white;\n  color: var(--fontColor, white);\n  background-color: var(--backgroundColor);\n  scrollbar-color: var(--scrollBarThumbBackgroundColor) var(--scrollBarTrackCornerBackgroundColor);\n}\n\nlabel {\n  user-select: none;\n}\n\n/*\n** CSS-styled Scrollbars for IE & Webkit browsers\n** Dark theme by default.\n**\n*/\n::-webkit-scrollbar {\n  width: 18px;\n  height: 18px;\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #2e6799;\n  background-color: var(--scrollBarThumbBackgroundColor, #2e6799);\n  border-radius: 10px;\n  border: 3px solid transparent;\n  background-clip: padding-box;\n}\n\n/* visually \"centers\" because the dark edge of the shadow gives the illusion this is offset */\n::-webkit-scrollbar-thumb:vertical {\n  border-left-width: 4px;\n}\n\n::-webkit-scrollbar-thumb:horizontal {\n  border-top-width: 4px;\n}\n\n::-webkit-scrollbar-thumb:active,\n::-webkit-scrollbar-thumb:hover {\n  background-color: #3a81bf;\n  background-color: var(--scrollBarThumbBackgroundHoverColor, #3a81bf);\n}\n\n::-webkit-scrollbar-track,\n::-webkit-scrollbar-corner {\n  background-color: #203246;\n  background-color: var(--scrollBarTrackCornerBackgroundColor, #203246);\n}\n\n::-webkit-scrollbar-track:vertical {\n  box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.15);\n}\n\n::-webkit-scrollbar-track:horizontal {\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n/*\n**\n** \tASTRO BUTTON\n** \t==========================================================================\n**  3.0 Notes\n**  - Removed Master Off Button Style\n**  - Replaced various properties with css custom properties to support\n**  - Removed .satcom class definition\n**  - Removed narrow/short definitions\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Disabled user selection of text on all buttons\n**\t- Removed redundant background hover from 'disabled' state by using :not() on the :hover state\n** \t- Removed redundant background hover from 'master off' by using :not() on the :hover state // deprecate after 1.4\n**  - Fixed Firefox alignment issue where text was misaligned vertically\n**  - Renamed half-height to short and half-width to narrow (Note: rux_ only, satcom_ retains old syntax)\n**  - Removed user-select and placed it in astro.css to apply to all input types\n**  - Embedded master off icon and removed the additional states required to handle icons and gradient backgrounds\n*/\n.rux-button-group {\n  display: flex;\n  margin-left: auto;\n  align-self: flex-end;\n}\n\n.rux-button-group .rux-button:not(:last-child) {\n  margin-right: 0.625rem;\n}\n\n/* Global Button Styles */\n.rux-button {\n  display: flex;\n  position: relative;\n  margin: 0;\n  padding: 0 1rem;\n  height: 2.125rem;\n  min-width: 2.25rem;\n  border-radius: 3px;\n  border-radius: var(--buttonBorderRadius);\n  color: var(--buttonTextColor);\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-size: 1rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  justify-content: center;\n  align-items: center;\n  user-select: none;\n}\n\n/*\n\n  Disabled States\n\n*/\n/* disabled state */\n.rux-button:disabled {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-button:focus {\n  outline: none;\n}\n\n.rux-button:not(.rux-button--outline) {\n  border: 1px solid var(--buttonBorderColor);\n  background-color: var(--buttonBackgroundColor);\n}\n\n/* Outline Button Specific Styles */\n.rux-button--outline {\n  color: var(--buttonOutlineTextColor);\n  background-color: var(--buttonOutlineBackgroundColor);\n  border: 1px solid var(--buttonOutlineBorderColor);\n}\n\n/*\n\n  Press/Active States\n\n*/\n.rux-button:active:not([hover]):not([disabled]) {\n  border-color: var(--buttonActiveBorderColor) !important;\n  background-color: var(--buttonActiveBackgroundColor) !important;\n}\n\n.rux-button--outline:active:not([hover]):not([disabled]) {\n  border-color: var(--buttonOutlineBorderColor) !important;\n  background-color: var(--buttonOutlineBackgroundColor) !important;\n}\n\n/*\n\n  Hover States\n\n*/\n.rux-button:hover:not([active]):not([disabled]):not(.rux-button--outline) {\n  border-color: var(--buttonHoverBorderColor);\n  background-color: var(--buttonHoverBackgroundColor);\n}\n\n.rux-button--outline:hover:not([disabled]) {\n  color: var(--buttonOutlineTextColor);\n  background-color: var(--buttonOutlineHoverBackgroundColor);\n  border-color: var(--buttonOutlineHoverBorderColor);\n}\n\n/*\n\n  Icons\n\n*/\n.rux-button--small {\n  font-size: 0.875rem;\n  font-size: var(--smallLabelFontSize);\n  height: 1.625rem;\n  padding: 0 1rem;\n  line-height: 1;\n}\n\n.rux-button--large {\n  font-size: 1.125rem;\n  font-size: var(--largeLabelFontSize);\n  height: 2.875rem;\n  min-width: 3rem;\n  padding: 0 1rem;\n}\n\n.rux-button__icon {\n  height: 1.5rem;\n  width: 1.5rem;\n  margin-right: 0.625rem;\n  margin-left: -0.625rem;\n}\n\n.rux-button--icon-only .rux-button__icon {\n  margin-left: -0.625rem;\n  margin-right: -0.625rem;\n}\n\n.rux-button--large.rux-button--icon-only .rux-button__icon {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n\n.rux-button--small .rux-button__icon {\n  height: 0.875rem;\n  width: 0.875rem;\n}\n\n.rux-button--large .rux-button__icon {\n  height: 1.75rem;\n  width: 1.75rem;\n  margin-left: -0.8rem;\n}\n\n.rux-button__icon .rux-icon {\n  height: auto;\n  width: 100%;\n  fill: var(--buttonTextColor);\n  color: var(--buttonTextColor);\n}\n\n.rux-button.rux-button--critical,\n.rux-button.rux-button--critical:active:not([hover]):not([disabled]):not(.rux-button--outline) {\n  background-color: rgb(204, 45, 45) !important;\n  background-color: var(--colorCriticalDarken1) !important;\n  border-color: rgb(204, 45, 45) !important;\n  border-color: var(--colorCriticalDarken1) !important;\n}\n\n.rux-button.rux-button--critical:hover:not([active]):not([disabled]) {\n  background-color: var(--colorCritical);\n  border-color: var(--colorCritical);\n}\n\n.rux-card {\n  background-color: #1e2f42;\n  background-color: var(--cardBackgroundColor, #1e2f42);\n  padding: 1px;\n  overflow: hidden;\n}\n\n.rux-card__header {\n  color: white;\n  color: var(--cardHeaderTextColor, white);\n  background-color: #14202c;\n  background-color: var(--cardHeaderBackgroundColor, #14202c);\n  margin: 0;\n  padding: 0.325rem 0.625rem;\n  display: flex;\n  align-items: center;\n}\n\n.rux-card__header h1 {\n  padding: 0;\n  margin: 0;\n  font-size: 1.75rem;\n}\n\n.rux-card__content {\n  padding: 0.625rem;\n}\n\n/*\n**\n** \tASTRO CHECKBOX BUTTON\n** \t==========================================================================\n**  3.0 Notes\n**  - Added Custom CSS Properties to support light/dark theming\n**  - Added fallback properties for IE11\n**  2.0 Notes\n**  - Removed hand cursor on checkbox\n**  - Updated styles to Astro 2.0\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**  - Added line-height to label to fix minor alignment issue\n**  - Moved user-select to parent element\n**  - Removed user-select and placed it in astro.css to apply to all input types\n*/\n.rux-checkbox {\n  display: flex;\n  position: relative;\n  margin: 0 0 1rem 0;\n  line-height: 1.2;\n}\n\n.rux-checkbox input[type='checkbox'] {\n  -webkit-appearance: none;\n  display: none;\n}\n\n.rux-checkbox input[type='checkbox']+label {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--controlLabelColor);\n  letter-spacing: 0.5px;\n  cursor: pointer;\n}\n\n/* Box */\n.rux-checkbox input[type='checkbox']+label::before {\n  display: flex;\n  flex-shrink: 0;\n  flex-grow: 0;\n  content: '';\n  align-self: start;\n  height: 1.125rem;\n  height: var(--controlOptionSize);\n  width: 1.125rem;\n  width: var(--controlOptionSize);\n  margin: 0 0.625rem 0 0;\n  border: 1px solid var(--controlBorderColor);\n  border-radius: 2px;\n}\n\n.rux-checkbox input[type='checkbox']:checked+label::before {\n  background-color: var(--primary);\n  border-color: var(--controlSelectedOutlineBorderColor);\n}\n\n.rux-checkbox input[type='checkbox']:not(:disabled):hover+label:before,\n.rux-checkbox input[type='checkbox']:not(:disabled):checked:hover+label:before {\n  border-color: var(--controlHoverBorderColor);\n}\n\n.rux-checkbox input[type='checkbox']:not(:disabled):checked:hover+label:before {\n  background-color: var(--controlHoverBorderColor);\n}\n\n/* Checkmark */\n.rux-checkbox input[type='checkbox']:checked+label::after {\n  position: absolute;\n  top: 5px;\n  display: flex;\n  content: '';\n  height: 6px;\n  width: 12px;\n  left: 3px;\n  border-right: 2px solid var(--controlTextColor);\n  border-top: 2px solid var(--controlTextColor);\n  transform: rotate(125deg);\n}\n\n.rux-checkbox--indeterminate input[type='checkbox']:checked+label::after {\n  width: 10px;\n  height: 5px;\n  transform: rotate(0deg);\n  border-right: 0px;\n  border-top: 0px;\n  border-bottom: 2px solid var(--controlTextColor);\n  left: 4px;\n}\n\n.rux-checkbox input[type='checkbox']:disabled+label {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n}\n\n.rux-form-element {\n  display: flex;\n  align-items: baseline;\n}\n\n.rux-form-element label {\n  color: white;\n}\n\n.rux-form__invalid {\n  border: 1px solid var(--colorCritical);\n  border-left-width: 20px;\n  color: var(--colorCritical);\n  padding: 20px 10px;\n  background-color: var(--inputBackground);\n}\n\n.rux-form__invalid p {\n  line-height: 100%;\n  text-align: left;\n  vertical-align: middle;\n  color: var(--colorCritical);\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-weight: bold;\n  margin: 0;\n  padding-left: 1.625rem;\n  width: fit-content;\n  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20128%20128%22%3E%0A%20%20%3Cpath%20fill%3D%22%23FF3030%22%20fill-rule%3D%22evenodd%22%20d%3D%22M64.031%205c8.461%200%2068.88%20107.243%2063.648%20114.184-5.232%206.942-120.805%205.477-127.212%200C-5.941%20113.708%2055.57%205%2064.03%205zm3.45%2075.894l1.822-34.893H56.946l1.82%2034.893h8.715zM56.803%2093.108c0%201.929.547%203.423%201.643%204.483%201.095%201.06%202.642%201.589%204.642%201.589%201.953%200%203.477-.542%204.572-1.625%201.095-1.084%201.643-2.566%201.643-4.447%200-1.952-.542-3.452-1.625-4.5-1.084-1.047-2.613-1.571-4.59-1.571-2.047%200-3.607.512-4.678%201.536-1.072%201.023-1.607%202.535-1.607%204.535z%22%2F%3E%0A%3C%2Fsvg%3E');\n  background-repeat: no-repeat;\n  background-size: 1rem;\n  background-position: center left 0rem;\n}\n\n.rux-help-text {\n  color: var(--secondaryText);\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-weight: normal;\n  letter-spacing: 0.5px;\n}\n\n.rux-form-field .rux-help-text {\n  -webkit-order: 3;\n  order: 3;\n  margin-top: 0.625rem;\n}\n\n.rux-error-text {\n  color: var(--colorCritical);\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-weight: bold;\n}\n\n.rux-form-field .rux-error-text,\n.rux-select+.rux-error-text {\n  padding-left: 1.625rem;\n  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20128%20128%22%3E%0A%20%20%3Cpath%20fill%3D%22%23FF3030%22%20fill-rule%3D%22evenodd%22%20d%3D%22M64.031%205c8.461%200%2068.88%20107.243%2063.648%20114.184-5.232%206.942-120.805%205.477-127.212%200C-5.941%20113.708%2055.57%205%2064.03%205zm3.45%2075.894l1.822-34.893H56.946l1.82%2034.893h8.715zM56.803%2093.108c0%201.929.547%203.423%201.643%204.483%201.095%201.06%202.642%201.589%204.642%201.589%201.953%200%203.477-.542%204.572-1.625%201.095-1.084%201.643-2.566%201.643-4.447%200-1.952-.542-3.452-1.625-4.5-1.084-1.047-2.613-1.571-4.59-1.571-2.047%200-3.607.512-4.678%201.536-1.072%201.023-1.607%202.535-1.607%204.535z%22%2F%3E%0A%3C%2Fsvg%3E');\n  background-repeat: no-repeat;\n  background-size: 1rem;\n  background-position: center left 0rem;\n  text-align: left;\n  width: fit-content;\n  -webkit-order: 3;\n  order: 3;\n  margin-top: 0.625rem;\n}\n\n/*\n**\n** \tASTRO INPUT TEXT FIELDS\n** \t==========================================================================\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**  - Updated text entry field to WCAG\n*/\n/*\n**\n** \tINPUT TEXT\n** \t==========================================================================\n*/\n/* \tREQUIRED CLASSES */\n.rux-form-field {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-size: 1rem;\n  font-size: var(--fontSize);\n  color: var(--fontColor);\n}\n\n.rux-form-field input:required+label::after {\n  content: '*';\n  margin-left: 0.25rem;\n  color: var(--inputTextColor);\n}\n\n.rux-form-field__label {\n  display: flex;\n  order: 1;\n  margin: 0 0 0.15rem 0;\n  width: 100%;\n  align-content: center;\n  align-items: center;\n  color: var(--defaultText);\n  user-select: none;\n}\n\n.rux-form-field input {\n  box-sizing: border-box;\n  order: 2;\n  height: 2.125rem;\n  width: 100%;\n  padding: 0 0.625rem;\n  border: 1px solid var(--inputBorderColor);\n  border-radius: 4px;\n  font-size: 1rem;\n  font-size: var(--fontSize, 1rem);\n  color: var(--inputTextColor);\n}\n\n.rux-form-field textarea {\n  box-sizing: border-box;\n  -webkit-order: 2;\n  order: 2;\n  min-height: 4.25rem;\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid transparent;\n  border: 1px solid var(--inputBorderColor);\n  border-radius: 3px;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-size: 1rem;\n  font-size: var(--fontSize, 1rem);\n  color: black;\n  color: var(--inputTextColor);\n}\n\n/* input */\n.rux-form-field input::-webkit-input-placeholder,\n.rux-form-field input::-moz-placeholder,\n.rux-form-field input:-ms-input-placeholder,\n.rux-form-field textarea::-webkit-input-placeholder,\n.rux-form-field textarea::-moz-placeholder,\n.rux-form-field textarea:-ms-input-placeholder {\n  font-size: 1rem;\n  font-weight: normal;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n}\n\n.rux-form-field input[type='date']::-webkit-inner-spin-button,\n.rux-form-field input[type='date']::-webkit-outer-spin-button,\n.rux-form-field input[type='date']::-webkit-calendar-picker-indicator {\n  -webkit-appearance: none;\n  display: none;\n}\n\n/* VALIDATION */\n.rux-form-field input:invalid {\n  border: 1px solid var(--inputInvalidBorderColor);\n}\n\n/* FOCUS RULES */\n.rux-form-field input:not([type='search']):focus,\n.rux-form-field input:not([type='search']):invalid:focus {\n  border: 1px solid var(--inputFocusBorderColor) !important;\n}\n\n.rux-form-field input::selection {\n  background-color: rgb(184, 222, 255);\n  background-color: var(--colorSecondaryLighten3);\n}\n\n.rux-form-field__validation-message {\n  display: none;\n  position: absolute;\n  max-width: 16rem;\n  background-color: var(--colorCritical);\n  width: 100%;\n  padding: 0.25rem;\n  right: 0;\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n}\n\n.rux-form-field input:invalid .rux-form-field__validation-message {\n  display: block;\n}\n\n.rux-form-field input:disabled {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-form-field--large,\n.rux-form-field--large label,\n.rux-form-field--large input,\n.rux-form-field--large textarea {\n  font-size: 1.125rem;\n  font-size: var(--fontSizeXL);\n}\n\n.rux-form-field--small,\n.rux-form-field--small label,\n.rux-form-field--small input,\n.rux-form-field--small textarea {\n  font-size: 0.875rem;\n  font-size: var(--fontSizeMD);\n}\n\n.rux-form-field--large input,\n.rux-form-field--large textarea {\n  padding: 0.5rem;\n}\n\n.rux-form-field--large input {\n  height: 2.5rem;\n}\n\n.rux-form-field--small input,\n.rux-form-field--small textarea {\n  padding: 0.3rem;\n}\n\n.rux-form-field--small input {\n  height: 1.625rem;\n}\n\n.rux-form-field--large input:invalid {\n  background-size: 1.375rem;\n  background-position: center right 0.5rem;\n  padding: 0.5rem 1.875rem 0.5rem 0.5rem;\n}\n\n.rux-form-field input:focus,\n.rux-form-field input:invalid:focus,\n.rux-form-field textarea:focus {\n  border-color: var(--inputFocusBorderColor);\n  outline: none;\n  color: var(--inputFocusTextColor);\n}\n\n.rux-form-field input[type='search']::-webkit-search-decoration {\n  -webkit-appearance: textfield;\n}\n\n/* SEARCH VARIANT */\n.rux-form-field input[type='search'] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding: 0.5rem 0.5rem 0.5rem 2rem;\n  background: var(--inputBackgroundColor) var(--inputSearchIcon) 10px/0.975rem no-repeat;\n}\n\n.rux-form-field--large input[type='search'] {\n  padding: 0.5rem 0 0.5rem 2rem;\n}\n\n.rux-form-field--small input[type='search'] {\n  padding: 0.3rem 0 0.3rem 2rem;\n}\n\n.rux-form-field input[type='search']::-webkit-search-cancel-button {\n  position: relative;\n  -webkit-appearance: none;\n  width: 20px;\n  height: 20px;\n  background-image: var(--inputSearchCancel);\n  background-repeat: no-repeat;\n}\n\n.rux-form-field input[type='search']::-ms-clear {\n  position: relative;\n  right: 0.25rem;\n  width: 20px;\n  height: 20px;\n  background-color: var(--inputInvalidBorderColor);\n}\n\n/*\n**\n** \tASTRO RADIO BUTTONS\n** \t==========================================================================\n**  3.0 Notes\n**  - Added Custom CSS Properties to support light/dark theming\n**  - Added fallback properties for IE11\n**  2.0 Notes\n**  - Removed hand cursor on checkbox\n**  - Updated styles to Astro 2.0\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**  - Added line-height to label to fix minor alignment issue\n**  - Moved user-select to parent element\n**  - Removed user-select and placed it in astro.css to apply to all input types\n*/\n.rux-radio-button {\n  display: flex;\n  position: relative;\n  margin: 0 0 1rem 0;\n  line-height: 1.2;\n}\n\n.rux-radio-button input[type='radio'] {\n  -webkit-appearance: none;\n  display: none;\n}\n\n.rux-radio-button input[type='radio']+label {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--controlLabelColor);\n  letter-spacing: 0.5px;\n  cursor: pointer;\n}\n\n.rux-radio-button input[type='radio']+label::before {\n  display: flex;\n  flex-shrink: 0;\n  flex-grow: 0;\n  content: '';\n  align-self: start;\n  height: 1.125rem;\n  height: var(--controlOptionSize);\n  width: 1.125rem;\n  width: var(--controlOptionSize);\n  margin: 0 0.625rem 0 0;\n  border: 1px solid var(--controlBorderColor);\n  border-radius: 100%;\n  background-color: transparent;\n}\n\n.rux-radio-button input[type='radio']:checked+label::before {\n  background-color: var(--controlSelectedOutlineBackgroundColor);\n  border-color: var(--controlSelectedOutlineBorderColor);\n}\n\n.rux-radio-button input[type='radio']:not(:disabled):hover+label:before,\n.rux-radio-button input[type='radio']:not(:disabled):checked:hover+label:before {\n  border-color: var(--controlHoverBorderColor);\n}\n\n.rux-radio-button input[type='radio']:not(:disabled):checked:hover+label:after {\n  background-color: var(--controlHoverBorderColor);\n}\n\n.rux-radio-button input[type='radio']:checked+label::after {\n  position: absolute;\n  top: 5px;\n  display: flex;\n  content: '';\n  left: 5px;\n  height: 8px;\n  width: 8px;\n  border-radius: 100%;\n  background-color: var(--primary);\n}\n\n.rux-radio-button input[type='radio']:disabled+label {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n}\n\n/*\n**\n** \tASTRO SELECT\n** \t==========================================================================\n**\t2.0.1 Notes\n*/\n.rux-select {\n  --selectInactiveCaret: url('data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23080c11%22%20d%3D%22M0%200h10L5%205z%22%20fill-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E');\n  --selectActiveCaret: url('data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%225%22%20style%3D%22transform%3A%20rotate%28180deg%29%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22%23080c11%22%20d%3D%22M0%200h10L5%205z%22%20fill-rule%3D%22evenodd%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E');\n  position: relative;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 1px solid var(--inputBorderColorAlt);\n  border-radius: 3px;\n  border-radius: var(--buttonBorderRadius);\n  color: var(--inputDark);\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n  font-weight: normal;\n  font-size: 1rem;\n  padding: 0.438rem 3.125rem 0.438rem 0.5rem;\n  background-color: var(--inputBackground);\n  background-image: var(--selectInactiveCaret);\n  background-position: center right 0.625rem;\n  background-repeat: no-repeat;\n  user-select: none;\n}\n\n.rux-select .rux-select optgroup,\n.rux-select option {\n  color: var(--inputDark);\n  background-color: var(--inputBackground);\n}\n\n.rux-select .rux-select optgroup:hover,\n.rux-select option:hover {\n  background-color: var(--selectHoverOptBackgroundColor);\n}\n\n.rux-select:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  border-color: var(--inputBorderColorDisabled);\n}\n\n.rux-select:disabled:hover {\n  cursor: not-allowed;\n}\n\n.rux-select:focus {\n  outline: none;\n  border: 1px solid var(--primary);\n  border-radius: 3px;\n  border-radius: var(--buttonBorderRadius);\n}\n\n.rux-select:active:not(:disabled) {\n  background-image: var(--selectActiveCaret);\n}\n\n.rux-select:hover {\n  cursor: pointer;\n}\n\n.rux-select::-ms-expand {\n  display: none;\n}\n\n.rux-select:focus::-ms-value {\n  background: transparent;\n}\n\n.rux-select:invalid {\n  border: 1px solid var(--inputInvalidBorderColor);\n}\n\n/*\n**\n** \tTABLE\n** \t==========================================================================\n*/\n.rux-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0px;\n  color: var(--tableRowTextColor);\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--tableBorderColor);\n  background: var(--tableRowBackgroundColor);\n  text-align: left;\n  overflow: scroll;\n}\n\n.rux-table__column-head th,\n.rux-table th {\n  border-top-width: 1px;\n  border-top-style: solid;\n  border-top-color: var(--tableHeaderBorderColor);\n  background: var(--tableHeaderBackgroundColor);\n  color: var(--tableHeaderTextColor);\n  font-size: 1.125rem;\n  font-size: var(--fontSizeXL);\n  font-weight: 400;\n  height: 2.625rem;\n  padding: 0.625rem 1rem;\n  white-space: nowrap;\n}\n\n.rux-table__column-head {\n  box-shadow: var(--tableHeaderBoxShadow);\n  border-top-width: 1px;\n  border-top-style: solid;\n  border-top-color: var(--tableHeaderBorderColor);\n}\n\n.rux-table tr[data-selected],\n.rux-table tr.selected {\n  background: var(--tableRowSelectedBackgroundColor);\n}\n\n.rux-table tr[data-selected] td,\n.rux-table tr.selected td {\n  border-color: var(--tableRowSelectedBorderColor);\n}\n\n.rux-table tr:hover:not([data-selected]),\n.rux-table tr.selected:hover:not([data-selected]) {\n  background: var(--tableRowHoverBackgroundColor);\n  color: var(--tableRowHoverTextColor);\n}\n\n.rux-table td {\n  border-width: 1px 0;\n  border-style: solid;\n  border-color: var(--tableRowBorderColor);\n  padding: 0.625rem 1rem;\n  white-space: nowrap;\n}\n\n.rux-table__column-head th:first-child,\n.rux-table th:first-child,\n.rux-table td:first-child {\n  padding-left: 1.875rem;\n}\n\n.rux-table__column-head th:last-child,\n.rux-table th:last-child,\n.rux-table td:last-child {\n  padding-right: 1.875rem;\n}\n\n.rux-table .rux-checkbox {\n  margin: 0;\n}\n\n.rux-table .rux-checkbox input[type='checkbox']:checked+label::before,\n.rux-table .rux-radio-button input[type='radio']:checked+label::before {\n  background-color: var(--controlBackgroundColor);\n  border-color: var(--controlBorderColor);\n}\n\n.rux-table .rux-checkbox input[type='checkbox']:checked+label::after,\n.rux-table .rux-radio-button input[type='radio']:checked+label::after {\n  border-color: var(--inputBackground);\n}\n\n.rux-table tr:hover .rux-checkbox input[type='checkbox']:not(:checked)+label::before,\n.rux-table tr:hover .rux-checkbox input[type='radio']+label::before {\n  border-color: var(--controlSelectedBorderColor);\n}\n\n.rux-advanced-status {\n  position: relative;\n  margin: 0 0.75rem;\n  line-height: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.rux-advanced-status__icon-group {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  max-width: 6.25rem;\n  min-width: 4rem;\n  /* fauxicon grid. Usefull for gross alignment */\n}\n\n.rux-advanced-status__status-icon {\n  margin: 0 2px 0 auto;\n  order: 1;\n}\n\n.rux-advanced-status__icon {\n  order: 2;\n  margin: 0 auto;\n}\n\n.rux-advanced-status__icon::before {\n  content: '';\n  display: block;\n  position: relative;\n  margin-bottom: -12px;\n  margin-left: -18px !important;\n  height: 16px;\n  width: 16px;\n}\n\n.rux-advanced-status__badge:empty {\n  display: none;\n}\n\n.rux-advanced-status__badge {\n  display: block;\n  z-index: 2;\n  order: 3;\n  position: absolute;\n  bottom: -0.75rem;\n  right: -0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  border-radius: 3px;\n  padding: 0.65rem 0.25rem;\n  font-size: 0.775rem;\n  text-align: center;\n  color: #fff;\n  background-color: #000;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rux-advanced-status__label {\n  text-align: center;\n  color: white;\n  color: var(--fontColor, white);\n  font-size: 0.875rem;\n  line-height: 1.2;\n  margin-top: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  max-width: 6.25rem;\n  white-space: nowrap;\n}\n\n.rux-advanced-status__label__sub-label {\n  font-size: 0.65em;\n  color: rgba(255, 255, 255, 0.6);\n  display: block;\n}\n\n.rux-clock {\n  display: flex;\n  color: var(--clockTextColor);\n  font-size: 1.15rem;\n}\n\n.rux-clock__segment {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.rux-clock__segment__value {\n  display: flex;\n  align-items: center;\n  font-family: 'Roboto Mono', monospace;\n  font-family: var(--fontFamilyMono);\n  font-weight: 700;\n  border: 1px solid var(--clockBorderColor);\n  background-color: var(--clockBackgroundColor);\n  margin-bottom: 0.25rem;\n  white-space: nowrap;\n  overflow-y: hidden;\n  text-overflow: ellipsis;\n}\n\n.rux-clock--small .rux-clock__segment__value {\n  height: 2.75rem;\n  padding: 0 0.75rem;\n  font-size: 1.15rem;\n  font-weight: 500;\n}\n\n.rux-clock__day-of-the-year .rux-clock__segment__value {\n  border-right: none;\n}\n\n.rux-clock:not(.rux-clock--small) .rux-clock__segment__value {\n  font-size: 1.75rem;\n  height: 2.75rem;\n  padding: 0 0.75rem;\n}\n\n.rux-clock__segment__label {\n  font-size: 0.875rem;\n  color: var(--clockLabelColor);\n}\n\n.rux-clock__aos {\n  margin-left: 1em;\n}\n\n.rux-clock__los {\n  margin-left: 0.5em;\n}\n\n.rux-icon {\n  margin: 0 auto;\n  width: 2.8rem;\n  height: 2.8rem;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  fill: var(--iconDefaultColor);\n  -webkit-mask-size: cover;\n  mask-size: cover;\n}\n\n.rux-icon svg {\n  fill: var(--iconDefaultColor);\n}\n\ni.rux-icon {\n  display: block;\n  width: 2.8rem;\n  height: 2.8rem;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n}\n\n.rux-log {\n  display: block;\n  font-size: 1rem;\n  background-color: var(--logBackgroundColor);\n}\n\n.rux-log-header {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n  justify-content: space-between;\n  padding: 0.5rem;\n  background-color: var(--logHeaderBackgroundColor);\n}\n\n.rux-log-header-title {\n  margin: 0 0 1rem 0;\n  display: none;\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.rux-log__header-labels {\n  display: flex;\n  width: 100%;\n  color: var(--logHeaderTextColor);\n}\n\n.rux-log__header-labels,\n.rux-log__events {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.rux-log__header-labels,\n.rux-log__log-event {\n  display: flex;\n  align-content: flex-start;\n}\n\n.rux-log__events {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.log-event__timestamp {\n  flex-shrink: 0;\n  text-align: left;\n  width: 5rem;\n}\n\n.rux-log__log-event {\n  display: flex;\n  flex-shrink: 0;\n  align-items: flex-start;\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--logBorderColor);\n}\n\n.rux-log__log-event:last-child {\n  border-bottom: none;\n}\n\n.rux-log__header-labels li:not(:first-child),\n.rux-log__log-event>* {\n  margin: 0 0.5rem;\n}\n\n.rux-log__header-labels li:first-child {\n  margin: 0 0.5rem 0 0;\n}\n\n.rux-log__log-event .log-event__timestamp {\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n}\n\n.log-event__status {\n  flex-grow: 0;\n  flex-shrink: 0;\n  text-align: center;\n  width: 1rem;\n  overflow: hidden;\n}\n\n.log-event__message {\n  flex-grow: 1;\n  text-align: left;\n}\n\n.log-header__message {\n  display: flex;\n  justify-content: space-between;\n}\n\n.rux-log__filter-enabled {\n  position: sticky;\n  top: 0;\n  left: 0;\n  align-content: center;\n  color: var(--logFilterTextColor);\n  background-color: var(--logFilterBackgroundColor);\n  padding: 0.5rem;\n}\n\n.rux-log__filter-enabled .rux-icon {\n  margin-right: 0.5rem;\n}\n\n.rux-modal {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  background-color: var(--modalBackgroundColor);\n  width: 28rem;\n  height: 13.5rem;\n  border: 2px solid var(--modalBorderColor);\n  border-radius: 4px;\n  margin: auto;\n  padding: 0;\n  user-select: none;\n  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.2);\n}\n\n.rux-modal__titlebar {\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 2rem;\n  background-color: var(--modalBorderColor);\n  user-select: none;\n  cursor: move;\n}\n\n.rux-modal__titlebar h1 {\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 0;\n  margin: 0;\n  line-height: 1.2;\n  color: var(--modalTitleColor);\n}\n\n.rux-modal__content {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: 1rem;\n  color: var(--defaultText);\n}\n\n.rux-modal__message {\n  margin: 0.5rem 1.875rem 2.5rem 1.875rem;\n}\n\n.rux-modal .rux-button {\n  box-shadow: none !important;\n}\n\n/*\n**\n** \tASTRO NOTIFICATION\n** \t==========================================================================\n**\t2.0 Notes\n**\n*/\n.rux-notification {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  flex-grow: 1;\n  align-items: center;\n  align-content: center;\n  top: -4.25rem;\n  left: 0;\n  height: 4.375rem;\n  width: 100%;\n  padding: 0.7rem 1.25rem;\n  background-color: rgb(87, 214, 255);\n  background-color: var(--colorStandbyLighten1);\n  transition: all 0.5s ease;\n  box-sizing: border-box;\n  font-size: 1.125rem;\n  font-size: var(--fontSizeXL);\n  color: var(--notificationTextColor);\n}\n\n.rux-notification::after {\n  position: relative;\n  display: block;\n  content: '';\n  height: 60px;\n}\n\n.visible {\n  margin-top: 0;\n}\n\n.notification-buffer.show {\n  margin-top: 0;\n}\n\n.show .rux-notification-container {\n  top: 0;\n}\n\n.show .rux-notification-buffer {\n  height: 60px;\n}\n\n.rux-notification_close-button {\n  border: 3px solid rgb(36, 163, 204);\n  border: 3px solid var(--colorStandbyDarken1);\n  color: rgb(36, 163, 204);\n  color: var(--colorStandbyDarken1);\n  background-color: transparent;\n  height: 2.2rem;\n  width: 2.2rem;\n  border-radius: 50%;\n  position: relative;\n  margin-left: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rux-notification_close-button::after,\n.rux-notification_close-button::before {\n  display: block;\n  position: absolute;\n  height: 2px;\n  width: 66%;\n  margin-left: -32%;\n  margin-top: -1px;\n  content: '';\n  background-color: rgb(36, 163, 204);\n  background-color: var(--colorStandbyDarken1);\n}\n\n@supports (--css: variables) {\n\n  .rux-notification_close-button::after,\n  .rux-notification_close-button::before {\n    margin: 0;\n  }\n}\n\n.rux-notification_close-button::after {\n  transform: rotate(-45deg);\n}\n\n.rux-notification_close-button::before {\n  transform: rotate(45deg);\n}\n\n/* Critical Variant */\n.rux-notification--critical {\n  background-color: rgb(255, 96, 96);\n  background-color: var(--colorCriticalLighten1);\n}\n\n.rux-notification--critical .rux-notification_close-button {\n  border-color: rgb(204, 45, 45);\n  border-color: var(--colorCriticalDarken1);\n}\n\n.rux-notification--critical .rux-notification_close-button::after,\n.rux-notification--critical .rux-notification_close-button::before {\n  background-color: rgb(204, 45, 45);\n  background-color: var(--colorCriticalDarken1);\n}\n\n/* Caution Variant */\n.rux-notification--caution {\n  background-color: rgb(253, 237, 97);\n  background-color: var(--colorCautionLighten1);\n}\n\n.rux-notification--caution .rux-notification_close-button {\n  border-color: rgb(202, 186, 46);\n  border-color: var(--colorCautionDarken1);\n}\n\n.rux-notification--caution .rux-notification_close-button::after,\n.rux-notification--caution .rux-notification_close-button::before {\n  background-color: rgb(202, 186, 46);\n  background-color: var(--colorCautionDarken1);\n}\n\n/* Normal Variant */\n.rux-notification--normal {\n  background-color: rgb(154, 246, 102);\n  background-color: var(--colorNormalLighten2);\n}\n\n.rux-notification--normal .rux-notification_close-button {\n  border-color: rgb(69, 192, 0);\n  border-color: var(--colorNormalDarken1);\n}\n\n.rux-notification--normal .rux-notification_close-button::after,\n.rux-notification--normal .rux-notification_close-button::before {\n  background-color: rgb(69, 192, 0);\n  background-color: var(--colorNormalDarken1);\n}\n\n/* Info Variant */\n.rux-notification--info {\n  background-color: rgb(87, 214, 255);\n  background-color: var(--colorStandbyLighten1);\n}\n\n.rux-notification--info .rux-notification_close-button {\n  border-color: rgb(36, 163, 204);\n  border-color: var(--colorStandbyDarken1);\n}\n\n.rux-notification--info .rux-notification_close-button::after,\n.rux-notification--info .rux-notification_close-button::before {\n  background-color: rgb(36, 163, 204);\n  background-color: var(--colorStandbyDarken1);\n}\n\n/*\n**\n** \tASTRO POP-UPS\n** \t==========================================================================\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed transform\n**  - Updated colors to WCAG\n*/\n/* \tREQUIRED CLASSES */\n.rux-pop-up {\n  font-size: 1rem;\n  display: inline-block;\n  margin: 1em;\n  min-width: 15em;\n  position: relative;\n  border: 1px solid rgb(77, 172, 255);\n  border: 1px solid var(--colorSecondary);\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n  border-radius: 3px;\n}\n\n.rux-pop-up ul {\n  position: relative;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background: none;\n  background-color: rgb(255, 255, 255);\n  background-color: var(--colorWhite);\n  border-radius: 2px;\n  z-index: 2;\n}\n\n.rux-pop-up a {\n  display: block;\n  padding: 0.5em;\n  color: var(--popupMenuTextColor);\n  text-decoration: none;\n  min-width: 15em;\n  max-width: 20em;\n}\n\n.rux-pop-up a:hover,\n.rux-pop-up li:hover {\n  background-color: rgb(184, 222, 255);\n  background-color: var(--colorSecondaryLighten3);\n  color: var(--popupMenuItemHoverTextColor);\n}\n\n.rux-pop-up li:first-child a {\n  border-top-right-radius: 2px;\n  border-top-left-radius: 2px;\n}\n\n.rux-pop-up li:last-child a {\n  border: none;\n  border-bottom-right-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.rux-pop-up--top {\n  border-top: 3px solid rgb(77, 172, 255);\n  border-top: 3px solid var(--colorSecondary);\n}\n\n.rux-pop-up--top::before {\n  content: '';\n  display: block;\n  position: absolute;\n  width: 1.1875rem;\n  height: 1.1875rem;\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n  z-index: 1;\n  margin: -12px 0 0 16px;\n  transform: rotate(45deg);\n}\n\n.rux-pop-up--bottom {\n  border-bottom: 3px solid rgb(77, 172, 255);\n  border-bottom: 3px solid var(--colorSecondary);\n}\n\n.rux-pop-up--bottom::after {\n  content: '';\n  display: block;\n  position: absolute;\n  border-bottom: 1px solid rgb(77, 172, 255);\n  border-bottom: 1px solid var(--colorSecondary);\n  border-right: 1px solid rgb(77, 172, 255);\n  border-right: 1px solid var(--colorSecondary);\n  width: 1.1875rem;\n  height: 1.1875rem;\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n  margin: -7px 0 0 16px;\n  transform: rotate(45deg);\n}\n\n.rux-pop-up--left {\n  border-left: 3px solid rgb(77, 172, 255);\n  border-left: 3px solid var(--colorSecondary);\n}\n\n.rux-pop-up--left::before {\n  content: '';\n  display: block;\n  position: absolute;\n  border-bottom: 1px solid rgb(77, 172, 255);\n  border-bottom: 1px solid var(--colorSecondary);\n  border-left: 1px solid rgb(77, 172, 255);\n  border-left: 1px solid var(--colorSecondary);\n  width: 1.1875rem;\n  height: 1.1875rem;\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n  margin: 16px 0 0 -12px;\n  transform: rotate(45deg);\n}\n\n.rux-pop-up--right {\n  border-right: 3px solid rgb(77, 172, 255);\n  border-right: 3px solid var(--colorSecondary);\n}\n\n.rux-pop-up--right::before {\n  content: '';\n  display: block;\n  position: absolute;\n  border-top: 1px solid rgb(77, 172, 255);\n  border-top: 1px solid var(--colorSecondary);\n  border-right: 1px solid rgb(77, 172, 255);\n  border-right: 1px solid var(--colorSecondary);\n  width: 1.1875rem;\n  height: 1.1875rem;\n  background-color: rgb(77, 172, 255);\n  background-color: var(--colorSecondary);\n  right: 0;\n  margin: 16px -12px 0 0;\n  transform: rotate(45deg);\n}\n\n/*\n**\n** \tASTRO PROGRESS\n** \t==========================================================================\n**\t2.0 Notes\n**  - Updated indeterminate progress to use animated SVG and the :indeterminate pseudo class\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**  - In addition to rux_ added the correct spelling of indeterminate as an additional selector\n**  - Combined indeterminate and determinate progress styles\n**  - DETERMINATE\n**  - Made container a flex element\n**  - Made percentage readout have an appropriate margin (NOTE: without a text rep the progress bar will scale to full width. Flexbox is neat.\n**  - Fixed alignment issue in Safari/Chrome where the progress bar was 2-3 pixels too low\n**  - Fixed width (on Chrome/Safari) of 100% width progress bar expanding past the border of the track\n**  - INDETERMINATE\n**  - Removed prefixed animation. Safari 8 was the last browser that required it\n**  - [REMOVED] Embeded SVG graphics embeded SVG graphic stopped working\n**  -\n**  - !! NOTE !!\n**  - The whole progress bar needs a rewrite. Better native elements and CSS properties should be used\n**  -\n*/\n.rux-progress {\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  align-items: center;\n  height: 2rem;\n}\n\n.rux-progress progress[value] {\n  appearance: none;\n  background-color: rgba(0, 0, 0, 0.3);\n  background-color: var(--progressDeterminateTrackBackgroundColor, rgba(0, 0, 0, 0.3));\n  border: 1px solid #14202c;\n  border: 1px solid var(--progressDeterminateTrackBorderColor, #14202c);\n  border-radius: 10px 10px 10px 10px;\n  border-radius: var(--progressRadius);\n  height: 20px;\n  width: 100%;\n}\n\n.rux-progress__value {\n  margin: 0 0 0 0.5rem;\n  text-align: right;\n  font-size: 24px;\n  width: 11%;\n  color: white;\n  color: var(--controlLabelColor, white);\n}\n\n.rux-progress progress[value]::-webkit-progress-bar {\n  background-color: transparent;\n}\n\n.rux-progress progress[value]::-webkit-progress-value {\n  border-radius: 10px 10px 10px 10px;\n  border-radius: var(--progressRadius);\n  height: 14px;\n  height: var(--progressHeight);\n  margin: 2px 0 0 2px;\n  margin: var(--progressPadding);\n  max-width: calc(100% - 4px);\n  max-width: var(--progressWidth);\n  background-color: #4dacff;\n  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);\n}\n\n.rux-progress progress[value]::-ms-fill {\n  border-radius: 10px;\n  border: none;\n  height: 14px;\n  margin: 2px;\n  max-width: calc(100% - 6px);\n  background-color: #4dacff;\n  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);\n}\n\n.rux-progress progress[value]::-moz-progress-bar {\n  border-radius: 10px 10px 10px 10px;\n  border-radius: var(--progressRadius);\n  margin: 2px 2px 0 2px;\n  height: 14px;\n  height: var(--progressHeight);\n  max-width: calc(100% - 4px);\n  max-width: var(--progressWidth);\n  background-color: #4dacff;\n  background-color: var(--progressDeterminateBarBackgroundColor, #4dacff);\n}\n\n/* Indeterminate */\n.rux-progress progress:indeterminate {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  box-sizing: border-box;\n  position: relative;\n  height: 5rem;\n  width: 5rem;\n  background-image: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000000%22%20fill-opacity%3D%22.3%22%20stroke%3D%22%2314202c%22%20d%3D%22M32%2C63.5%20C49.3969696%2C63.5%2063.5%2C49.3969696%2063.5%2C32%20C63.5%2C14.6030304%2049.3969696%2C0.5%2032%2C0.5%20C14.6030304%2C0.5%200.5%2C14.6030304%200.5%2C32%20C0.5%2C49.3969696%2014.6030304%2C63.5%2032%2C63.5%20Z%20M32%2C56.5%20C18.4690236%2C56.5%207.5%2C45.5309764%207.5%2C32%20C7.5%2C18.4690236%2018.4690236%2C7.5%2032%2C7.5%20C45.5309764%2C7.5%2056.5%2C18.4690236%2056.5%2C32%20C56.5%2C45.5309764%2045.5309764%2C56.5%2032%2C56.5%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%234dacff%22%20fill-rule%3D%22nonzero%22%20d%3D%22M32%2C61.9354839%20C30.9333606%2C61.9354839%2030.0686785%2C61.0708018%2030.0686785%2C60.0041623%20C30.0686785%2C58.9375229%2030.9333606%2C58.0728408%2032%2C58.0728408%20C40.1954904%2C58.0728408%2047.7578267%2C54.2689176%2052.6662672%2C47.8987622%20C56.1526582%2C43.3741373%2058.0728408%2C37.8356396%2058.0728408%2C32%20C58.0728408%2C17.6003676%2046.3996324%2C5.92715921%2032%2C5.92715921%20C17.6003676%2C5.92715921%205.92715921%2C17.6003676%205.92715921%2C32%20C5.92715921%2C33.0666394%205.0624771%2C33.9313215%203.99583767%2C33.9313215%20C2.92919824%2C33.9313215%202.06451613%2C33.0666394%202.06451613%2C32%20C2.06451613%2C15.4670888%2015.4670888%2C2.06451613%2032%2C2.06451613%20C48.5329112%2C2.06451613%2061.9354839%2C15.4670888%2061.9354839%2C32%20C61.9354839%2C38.6961574%2059.7285058%2C45.0618765%2055.7259583%2C50.2563674%20C50.0938506%2C57.5656952%2041.4065535%2C61.9354839%2032%2C61.9354839%20Z%22%20%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E');\n  background-image: var(--progressIndeterminate,\n      url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2264%22%20height%3D%2264%22%20viewBox%3D%220%200%2064%2064%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000000%22%20fill-opacity%3D%22.3%22%20stroke%3D%22%2314202c%22%20d%3D%22M32%2C63.5%20C49.3969696%2C63.5%2063.5%2C49.3969696%2063.5%2C32%20C63.5%2C14.6030304%2049.3969696%2C0.5%2032%2C0.5%20C14.6030304%2C0.5%200.5%2C14.6030304%200.5%2C32%20C0.5%2C49.3969696%2014.6030304%2C63.5%2032%2C63.5%20Z%20M32%2C56.5%20C18.4690236%2C56.5%207.5%2C45.5309764%207.5%2C32%20C7.5%2C18.4690236%2018.4690236%2C7.5%2032%2C7.5%20C45.5309764%2C7.5%2056.5%2C18.4690236%2056.5%2C32%20C56.5%2C45.5309764%2045.5309764%2C56.5%2032%2C56.5%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%234dacff%22%20fill-rule%3D%22nonzero%22%20d%3D%22M32%2C61.9354839%20C30.9333606%2C61.9354839%2030.0686785%2C61.0708018%2030.0686785%2C60.0041623%20C30.0686785%2C58.9375229%2030.9333606%2C58.0728408%2032%2C58.0728408%20C40.1954904%2C58.0728408%2047.7578267%2C54.2689176%2052.6662672%2C47.8987622%20C56.1526582%2C43.3741373%2058.0728408%2C37.8356396%2058.0728408%2C32%20C58.0728408%2C17.6003676%2046.3996324%2C5.92715921%2032%2C5.92715921%20C17.6003676%2C5.92715921%205.92715921%2C17.6003676%205.92715921%2C32%20C5.92715921%2C33.0666394%205.0624771%2C33.9313215%203.99583767%2C33.9313215%20C2.92919824%2C33.9313215%202.06451613%2C33.0666394%202.06451613%2C32%20C2.06451613%2C15.4670888%2015.4670888%2C2.06451613%2032%2C2.06451613%20C48.5329112%2C2.06451613%2061.9354839%2C15.4670888%2061.9354839%2C32%20C61.9354839%2C38.6961574%2059.7285058%2C45.0618765%2055.7259583%2C50.2563674%20C50.0938506%2C57.5656952%2041.4065535%2C61.9354839%2032%2C61.9354839%20Z%22%20%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E'));\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  animation-name: spin;\n  animation-duration: 1.367s;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  background-color: transparent;\n  border: none;\n}\n\n/* Removes the default animation from IE */\n.rux-progress progress:indeterminate::-ms-fill {\n  animation-name: none;\n}\n\n.rux-progress progress:indeterminate::-moz-progress-bar {\n  background-color: transparent;\n}\n\n.rux-progress progress:indeterminate::-webkit-progress-value,\n.rux-progress progress:indeterminate::-webkit-progress-bar {\n  background-color: transparent;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*\n**\n** \tASTRO PUSHBUTTONS\n** \t==========================================================================\n**  3.0 Notes\n**\t- Updated with css custom properties for light/dark theme\n**  2.1 Notes\n**\t- Moved Pushbuttons to its own style\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**\t- Removed prefixed transition\n**  - Fixed added colon to checked pseudo class (e.g., checked became :checked)\n**  - Alignment issue fixed on toggle button label\n**  - Updated to WCAG colors\n**  - Updated transition speed\n*/\n.rux-pushbutton {\n  display: inline-block;\n  height: 1.3125rem;\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n\n.rux-pushbutton__input {\n  display: none;\n}\n\n.rux-pushbutton__button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 1.375rem;\n  font-size: 0.75rem !important;\n  font-weight: 600;\n  margin: 0;\n  padding: 0 0.625rem;\n  color: var(--pushbuttonTextColor);\n  background-color: var(--pushbuttonBackgroundColor);\n  border-radius: 3px;\n  border-radius: var(--defaultBorderRadius, 3px);\n  border: 1px solid var(--pushbuttonBorderColor);\n}\n\n.rux-pushbutton__button label {\n  color: var(--pushbuttonTextColor);\n}\n\n.rux-pushbutton__input:checked+.rux-pushbutton__button {\n  display: flex;\n  color: var(--pushbuttonSelectedTextColor);\n  background-color: var(--pushbuttonSelectedBackgroundColor);\n  border-color: var(--pushbuttonSelectedBorderColor);\n}\n\n.rux-pushbutton__input:not(:checked)+.rux-pushbutton__button .on {\n  display: none;\n}\n\n.rux-pushbutton__input:disabled+.rux-pushbutton__button {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n/*\n**\n** \tASTRO SEGMENTED BUTTON\n** \t==========================================================================\n**  3.0 Notes\n**  Don‘t forget to update Sketch with outline border color\n\n*/\n.rux-segmented-button {\n  display: inline-flex;\n  height: 1.6875rem;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  border-radius: 3px;\n  border-radius: var(--controlBorderRadius);\n  border: 1px solid var(--segmentedButtonBorderColor);\n}\n\n.rux-segmented-button:hover {\n  border-color: var(--segmentedButtonHoverBorderColor);\n}\n\n.rux-segmented-button__segment {\n  height: 1.6875rem;\n  width: auto;\n  margin: 0;\n  padding: 0;\n}\n\n.rux-segmented-button__segment label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 1.5625rem;\n  margin: 0;\n  padding: 0 0.75rem;\n  border: none;\n  border-right: 1px solid var(--segmentedButtonBorderColor);\n  color: var(--segmentedButtonTextColor);\n  background-color: var(--segmentedButtonBackgroundColor);\n  font-size: 1rem;\n  user-select: none;\n}\n\n.rux-segmented-button__segment:nth-child(2):not(:last-child) label {\n  border-right: none !important;\n}\n\n.rux-segmented-button__segment input {\n  display: none !important;\n}\n\n.rux-segmented-button__segment label:hover {\n  background-color: var(--segmentedButtonHoverBackgroundColor);\n  border-color: var(--segmentedButtonHoverBorderColor);\n  color: var(--segmentedButtonHoverTextColor);\n  outline: none;\n}\n\n.rux-segmented-button__segment input:checked+label {\n  background-color: var(--segmentedButtonSelectedBackgroundColor);\n  color: var(--segmentedButtonSelectedTextColor);\n}\n\n.rux-segmented-button:nth-child(2):not(:last-child) label {\n  border-right: none;\n  border-left: none;\n}\n\n.rux-segmented-button:first-child label {\n  border-radius: 3px 0 0 3px;\n  border-radius: var(--controlBorderRadius) 0 0 var(--controlBorderRadius);\n}\n\n.rux-segmented-button:last-child label {\n  border-radius: 0 3px 3px 0;\n  border-radius: 0 var(--controlBorderRadius) var(--controlBorderRadius) 0;\n}\n\n/*\n**\n** \tASTRO SLIDER\n** \t==========================================================================\n**  3.0 Notes\n**  Removed SVG dependancy for the thumb element\n**  Updated to 3.0 look/feel\n**  Added CSS Custom Property support for light/dark theming\n**  2.1 Notes\n**  - Added support for bifurcated range slider\n**\t1.4 Notes\n**\t- Added rux_ compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**  - Removed focus ring from Chrome (probably need an actual focus solution)\n**  - Updated SVG\n*/\n/*\n    Internal Variables\n    Because Chrome, Firefox and IE all require explicit declarations to style\n    the slider/range component these minimize the need to add repeat values\n    between the three\n  */\n.rux-slider {\n  display: flex;\n  flex-direction: column;\n}\n\n.rux-slider__label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.25rem;\n  margin-bottom: 9px;\n}\n\n.rux-slider__control {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex-grow: 1;\n  position: relative;\n}\n\n.rux-slider label input {\n  margin-left: auto;\n  margin-right: 0;\n}\n\n.rux-range {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  -ms-appearance: none;\n  appearance: none;\n  background: none;\n  width: 100%;\n  margin: 0px;\n  color: transparent;\n}\n\ninput[type='range']:focus {\n  outline: none;\n}\n\n/****** Track ******/\n/* Track -> WebKit */\n.rux-range::-webkit-slider-runnable-track {\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  height: 3px;\n  height: var(--trackHeight, 2px);\n  cursor: pointer;\n  cursor: var(--trackCursor, pointer);\n  background-color: var(--sliderTrackBackgroundColor);\n  outline: var(--sliderTrackBorderSize) solid transparent;\n  outline: var(--sliderTrackBorderSize) solid var(--sliderTrackBorderColor, transparent);\n  background-image: linear-gradient(to right,\n      var(--sliderSelectedTrackBackgroundColor) 0%,\n      var(--sliderSelectedTrackBackgroundColor) calc(0.99% * var(--value)),\n      var(--sliderTrackBackgroundColor) calc(0.99% * var(--value)),\n      var(--sliderTrackBackgroundColor) 100%);\n}\n\n.rux-range:disabled::-webkit-slider-runnable-track {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n/* Track -> Moz */\n.rux-range::-moz-range-track {\n  display: flex;\n  align-items: center;\n  height: 3px;\n  height: var(--trackHeight);\n  cursor: pointer;\n  cursor: var(--trackCursor, pointer);\n  background-color: var(--sliderTrackBackgroundColor);\n  outline: var(--sliderTrackBorderSize) solid var(--sliderTrackBorderColor);\n}\n\n.rux-range:disabled::-moz-range-track,\n.rux-range:disabled::-moz-range-progress {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-range::-moz-range-progress {\n  background-color: var(--sliderSelectedTrackBackgroundColor);\n}\n\n.rux-input:disabled {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n/* Track -> Ms */\n.rux-range::-ms-track {\n  display: flex;\n  align-items: center;\n  height: 1.25rem;\n  padding: 2px 0;\n  cursor: pointer;\n  color: transparent;\n  background-color: transparent;\n  border: none;\n  outline: var(--sliderTrackBorderSize) solid transparent;\n}\n\n.rux-range::-ms-fill-lower {\n  height: 2px;\n  background-color: #4dacff;\n}\n\n.rux-range::-ms-fill-upper {\n  height: 2px;\n  background-color: var(--sliderTrackBackgroundColor);\n}\n\n/*****  Thumb ******/\n/* Thumb -> Webkit */\n.rux-range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  position: relative;\n  margin-top: calc(1.125rem / -2);\n  margin-top: calc(var(--thumbSize) / -2);\n  transform: translateX(-35%);\n  height: 1.125rem;\n  height: var(--thumbSize);\n  width: 1.125rem;\n  width: var(--thumbSize);\n  border-radius: 100%;\n  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);\n  background-color: var(--sliderThumbBackgroundColor);\n  cursor: pointer;\n  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), var(--thumbShadow);\n  z-index: 6;\n}\n\n.rux-range::-webkit-slider-thumb:hover {\n  border-color: var(--sliderHoverThumbBorderColor);\n}\n\n.rux-range:disabled::-webkit-slider-thumb {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-range:not(:disabled)::-webkit-slider-thumb:active {\n  border-color: var(--sliderSelectedThumbBorderColor);\n  background: radial-gradient(circle, white 40%, var(--primaryDark) 40%);\n  background-color: var(--inputBackground);\n  -webkit-radial-gradient: radial-gradient(circle, white 40%, var(--primaryDark) 40%);\n  box-shadow: inset 0 0 0 4px var(--primary), 0 1px 3px rgba(0, 0, 0, 0.14), 0 1px 4px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.2);\n  box-shadow: var(--thumbShadowActive);\n}\n\n.rux-range:not(:disabled)::-webkit-slider-thumb:focus,\n.rux-range:not(:disabled)::-webkit-slider-thumb:hover:not(:active) {\n  background-color: var(--sliderHoverThumbBackgroundColor);\n  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.14), 0 1px 18px rgba(0, 0, 0, 0.12), 0 3px 5px rgba(0, 0, 0, 0.2);\n  box-shadow: var(--thumbShadowHover);\n}\n\n/* Thumb -> Moz */\n.rux-range::-moz-range-thumb {\n  -moz-appearance: none;\n  position: relative;\n  top: calc(1.125rem / -2);\n  top: calc(var(--thumbSize) / -2);\n  transform: translateX(-35%);\n  height: 1.125rem;\n  height: var(--thumbSize);\n  width: 1.125rem;\n  width: var(--thumbSize);\n  border-radius: 100%;\n  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);\n  background-color: var(--sliderThumbBackgroundColor);\n  cursor: pointer;\n  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), var(--thumbShadow);\n}\n\n.rux-range:not(:disabled)::-moz-range-thumb:active {\n  background: radial-gradient(circle, white 40%, var(--primaryDark) 40%);\n}\n\n.rux-range::-moz-range-thumb:hover {\n  border-color: var(--sliderHoverThumbBorderColor);\n}\n\ninput:-moz-focusring {\n  outline: none;\n}\n\n.rux-range:disabled::-moz-range-thumb {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n/* Thumb -> Ms */\n.rux-range::-ms-thumb {\n  position: relative;\n  top: -10px;\n  height: 1.25rem;\n  width: 1.25rem;\n  border-radius: 100%;\n  border: var(--sliderThumbBorderSize) solid var(--sliderThumbBorderColor);\n  background-color: var(--sliderThumbBackgroundColor);\n  cursor: pointer;\n  box-shadow: inset 0 0 1px 0 rgba(255, 255, 255, 0.9), 0 3px 5px rgba(0, 0, 0, 0.14), 0 1px 9px rgba(0, 0, 0, 0.12), 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.rux-range:disabled::-ms-thumb {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* Labels */\n.rux-slider__control__labels {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  list-style: none;\n  padding: 0;\n  margin: 10px 0 0 0;\n  color: var(--fontColor);\n  font-size: 0.875rem;\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;\n  font-family: var(--fontFamily);\n}\n\n.rux-range:disabled+.rux-slider__control__labels {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n}\n\n.rux-slider__control__labels li {\n  padding: 0px;\n  text-align: left;\n}\n\n.rux-slider__control__labels li:first-child,\n.rux-slider__control__labels li:last-child {\n  margin: 0px;\n}\n\n.rux-slider__control-ticks {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 3px;\n  height: var(--ticksHeight);\n  background: linear-gradient(to right, var(--primaryDark) 1px, transparent 1px) repeat-x;\n  background: linear-gradient(to right, var(--ticksColor) var(--ticksThickness), transparent 1px) repeat-x;\n  background-size: calc(100% / ((100 - 0) / 1) - 0.18%) 3px;\n  background-size: calc(100% / ((var(--max) - var(--min)) / var(--step)) - 0.18%) var(--ticksHeight);\n  background-position: 0;\n  z-index: 5;\n}\n\n.disabled {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.rux-slider__input {\n  margin-right: 0;\n  margin-bottom: 0.75rem;\n  width: 4rem !important;\n}\n\ninput[type='range']::-moz-focus-outer {\n  border: 0;\n}\n\n/*\n**\n** \tASTRO STATUS INDICATOR\n** \t==========================================================================\n**  4.1 Notes\n**  Removed satcom prefix\n**  Replaced SVGs with a single PNG and used sprite pattern to improve performance\n**  Removed ::before psuedo element in favor of simpler background on the div\n**  Removed undocumented and unused small status variant\n**  General clean up\n**  3.0 Notes\n**  Removed margin on status symbols\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**  - Embeded SVG graphics\n*/\n.rux-status-indicator,\n.rux-status {\n  display: block;\n  height: 1rem;\n  width: 1rem;\n  margin: 0.125rem;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position-x: 1rem;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAAgVBMVEUAAAD/tQv/swL/OTn/PDzftl9W8QBW8AAtzP8v0P9Z9gD/tAP/uQb/tAItzf8tzf+eqK2ep60uzP9X8QCfqK4uzf8uzf9X8QAuzP9X8ACeqK4vzP9Y8QAuzv9Y8gCeqq4wz/8xzv9A1f9Y8QD/tAP86DpW8AD/swL/ODgtzP+ep63tgXPUAAAAJXRSTlMAGNfAQAv98/IdG8Io52zz8+DZ2dC9trabm4F+a05OQjAaDG6dAJcYcwAAAfdJREFUWMPtmNlygkAQRScyrBp3QTZFNBj8/w9MCGI3dBOHMg9jyvOmVFnn1HUSULx4LibjN/HMTN7Po2cu+PY/cwUfPYg2XhKsbHsVJJ5gcaf+cjZb+lN3qJjxyWIw/lAwNMALreKKFTIJh215Y3sYFiD5AEn9oWBowM4uEPau65A6JcJJ/2ACg/pDwdCAo1W0sI6ixbTsMH18Akn9oWBgwK7xh4LWBmlJSB+dwCD+pEA5wLMLgo3OwcGpvzhxludZfH1Bz4EZrefzdWSqTSCJPylQDggLhhA+oD6/G7d+5W7qk9yV3C8uPyz2KhMYxJ8UKAd4Fhdg3SZwa3/4wLrA7fhfbuwVJpDEnxQoByQFS9I6wQ7ydR16js0FBCzMuxMY1J8WqAYEfEDQXPcr3RjbxNU7vsBEF0R0dwJJ/LkCxYAVH7Bqri8r3QzbZNU7S4FZ44B1/ymgA4zPfZwUA2w+wG6uzyrdHMvk1TszgZnjgLmgyL4T8Dbq8R+bWgUIgw4ABby/Vl8hIckAUMD7a3WIYQIYgC0Af73+jOIJpKAF1F+vf2QwAQxAC7C/ZrcSeAIpegvAX7ObOZgABiAF2F+322mYAAagBeCv2wMNTEAGIAWVv3aPlDABDMAW1P7aPdQjDBiALaj89ftZBSGl+LXgZIoXL/4VXyptNwzuHR/QAAAAAElFTkSuQmCC');\n  background-image: var(--statusSymbols,\n      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMAAAAAgCAMAAABzRoe3AAAAgVBMVEUAAAD/tQv/swL/OTn/PDzftl9W8QBW8AAtzP8v0P9Z9gD/tAP/uQb/tAItzf8tzf+eqK2ep60uzP9X8QCfqK4uzf8uzf9X8QAuzP9X8ACeqK4vzP9Y8QAuzv9Y8gCeqq4wz/8xzv9A1f9Y8QD/tAP86DpW8AD/swL/ODgtzP+ep63tgXPUAAAAJXRSTlMAGNfAQAv98/IdG8Io52zz8+DZ2dC9trabm4F+a05OQjAaDG6dAJcYcwAAAfdJREFUWMPtmNlygkAQRScyrBp3QTZFNBj8/w9MCGI3dBOHMg9jyvOmVFnn1HUSULx4LibjN/HMTN7Po2cu+PY/cwUfPYg2XhKsbHsVJJ5gcaf+cjZb+lN3qJjxyWIw/lAwNMALreKKFTIJh215Y3sYFiD5AEn9oWBowM4uEPau65A6JcJJ/2ACg/pDwdCAo1W0sI6ixbTsMH18Akn9oWBgwK7xh4LWBmlJSB+dwCD+pEA5wLMLgo3OwcGpvzhxludZfH1Bz4EZrefzdWSqTSCJPylQDggLhhA+oD6/G7d+5W7qk9yV3C8uPyz2KhMYxJ8UKAd4Fhdg3SZwa3/4wLrA7fhfbuwVJpDEnxQoByQFS9I6wQ7ydR16js0FBCzMuxMY1J8WqAYEfEDQXPcr3RjbxNU7vsBEF0R0dwJJ/LkCxYAVH7Bqri8r3QzbZNU7S4FZ44B1/ymgA4zPfZwUA2w+wG6uzyrdHMvk1TszgZnjgLmgyL4T8Dbq8R+bWgUIgw4ABby/Vl8hIckAUMD7a3WIYQIYgC0Af73+jOIJpKAF1F+vf2QwAQxAC7C/ZrcSeAIpegvAX7ObOZgABiAF2F+322mYAAagBeCv2wMNTEAGIAWVv3aPlDABDMAW1P7aPdQjDBiALaj89ftZBSGl+LXgZIoXL/4VXyptNwzuHR/QAAAAAElFTkSuQmCC'));\n}\n\n/* Specific Status Iconography */\n.rux-status--off,\n.rux-status-indicator.rux-status--off,\n.rux-status--off .rux-advanced-status__icon {\n  background-position-x: -5rem;\n}\n\n.rux-status--standby,\n.rux-status-indicator.rux-status--standby,\n.rux-status--standby .rux-advanced-status__icon {\n  background-position-x: -4rem;\n}\n\n.rux-status--normal,\n.rux-status-indicator.rux-status--normal,\n.rux-status-indicator.rux-status--ok,\n.rux-status--normal .rux-advanced-status__icon,\n.rux-status--ok .rux-advanced-status__icon {\n  background-position-x: -3rem;\n}\n\n.rux-status--caution,\n.rux-status-indicator.rux-status--caution,\n.rux-status--caution .rux-advanced-status__icon {\n  background-position-x: -2rem;\n}\n\n.rux-status--serious,\n.rux-status-indicator.rux-status--serious,\n.rux-status-indicator.rux-status--error,\n.rux-status--serious .rux-advanced-status__icon,\n.rux-status--error .rux-advanced-status__icon {\n  background-position-x: -1rem;\n}\n\n.rux-status--critical,\n.rux-status-indicator.rux-status--critical,\n.rux-status-indicator.rux-status--alert,\n.rux-status--critical .rux-advanced-status__icon,\n.rux-status--alert .rux-advanced-status__icon,\n.rux-status--emergency .rux-advanced-status__icon {\n  background-position-x: 0;\n}\n\n/* Specific Color */\n.rux-status--off svg,\n.rux-icon.rux-status--off {\n  fill: #c6ccd1;\n  fill: var(--colorOff, #c6ccd1);\n  color: #c6ccd1;\n  color: var(--colorOff, #c6ccd1);\n}\n\n.rux-status--standby svg,\n.rux-icon.rux-status--standby {\n  fill: #4dacff;\n  fill: var(--colorStandby, #4dacff);\n  color: #4dacff;\n  color: var(--colorStandby, #4dacff);\n}\n\n.rux-icon.rux-status--normal,\n.rux-icon.rux-status--ok,\n.rux-status--normal svg,\n.rux-status--ok svg {\n  fill: #5bff00;\n  fill: var(--colorNormal, #5bff00);\n  color: #5bff00;\n  color: var(--colorNormal, #5bff00);\n}\n\n.rux-status--caution svg,\n.rux-icon.rux-status--caution {\n  fill: #f8e71d;\n  fill: var(--colorCaution, #f8e71d);\n  color: #f8e71d;\n  color: var(--colorCaution, #f8e71d);\n}\n\n.rux-status--serious svg,\n.rux-status--error svg,\n.rux-icon.rux-status--serious,\n.rux-icon.rux-status--error {\n  fill: #ffb000;\n  fill: var(--colorSerious, #ffb000);\n  color: #ffb000;\n  color: var(--colorSerious, #ffb000);\n}\n\n.rux-status--critical svg,\n.rux-status--emergency svg,\n.rux-icon.rux-status--critical,\n.rux-icon.rux-status--emergency {\n  fill: #ff3030;\n  fill: var(--colorCritical, #ff3030);\n  color: #ff3030;\n  color: var(--colorCritical, #ff3030);\n}\n\n/*\n**\n** \tASTRO TABS\n** \t==========================================================================\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**  - Removed prefixed transitions\n**  - Removed prefixed gradients\n**  - Updated colors for WCAG compliance\n**  - Swapped condensed font for standard\n**  2.0 Ideas\n**  - Replace use a radio-button based structure for tabs? (http://alistapart.com/article/radio-controlled-web-design)\n*/\n/* \tREQUIRED CLASSES */\n.rux-tabs {\n  font-size: 1.5rem;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  height: 5.625rem;\n  user-select: none;\n  border-bottom: 5px solid var(--tabBorderColor);\n}\n\n.rux-tabs--small {\n  height: 3.125rem;\n  font-size: 1.125rem;\n  font-size: var(--fontSizeXL);\n  border-bottom: 3px solid var(--tabBorderColor);\n}\n\n.rux-tabs ul {\n  padding: 0;\n  margin: 0;\n  height: 100%;\n  display: flex;\n  list-style: none;\n}\n\n.rux-tabs li {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.rux-tabs li::before {\n  display: none !important;\n}\n\n.rux-tabs a {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 3px 2rem 0;\n  text-decoration: none;\n  color: var(--tabTextColor);\n}\n\n.rux-tabs a[disabled] {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-tabs .selected a {\n  color: var(--tabSelectedTextColor);\n}\n\n.rux-tabs--small .selected a,\n.rux-tabs--small .selected a:hover {\n  color: var(--tabSelectedTextColor);\n}\n\n.rux-tabs .selected a:hover {\n  color: var(--tabSelectedTextColor);\n}\n\n.rux-tabs a:hover:not([disabled]) {\n  color: var(--tabHoverTextColor);\n}\n\n.rux-tabs .rux-tab {\n  border-bottom: 5px solid var(--tabBorderColor);\n}\n\n/*\n**\n** \tASTRO TOGGLE BUTTONS\n** \t==========================================================================\n**  3.0 Notes\n**  - Breaking change to markup of toggle button\n**  2.1 Notes\n**\t- Moved Pushbuttons to its own style sheet\n**\t1.4 Notes\n**\t- Added rux_ and BEM compatible classes to all satcom_ NOTE: satcom_ will be removed in a future version\n**\t- Removed prefixed linear gradients\n**\t- Removed prefixed transition\n**  - Fixed added colon to checked pseudo class (e.g., checked became :checked)\n**  - Alignment issue fixed on toggle button label\n**  - Updated to WCAG colors\n**  - Updated transition speed\n*/\n.rux-toggle--legacy,\n.satcom-toggle--legacy {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  -webkit-font-smoothing: subpixel-antialiased;\n  height: 1.3125rem;\n  width: 4.375rem;\n  border-radius: 3px;\n  border-radius: var(--defaultBorderRadius, 0.1875rem);\n  border: 1px solid black;\n  border: 1px solid var(--toggleBaseBorderColor, black);\n  user-select: none;\n  overflow: hidden;\n}\n\n.rux-toggle--legacy__input,\n.satcom-toggle--legacy input {\n  display: none !important;\n}\n\n.rux-toggle--legacy__button {\n  position: absolute;\n  display: flex;\n  justify-content: space-around;\n  align-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  font-size: 0.75rem !important;\n  height: 100%;\n  width: 100%;\n}\n\n.rux-toggle--legacy__button span {\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  width: 50%;\n  height: 100%;\n  z-index: 1;\n  text-transform: uppercase;\n}\n\n.rux-toggle--legacy__button::before {\n  position: absolute;\n  content: '';\n  display: block;\n  height: 100%;\n  width: 100%;\n  border-radius: 0.1875rem;\n  background: black;\n  background: var(--toggleBaseBackgroundColor, black);\n}\n\n.rux-toggle--legacy__button::after {\n  content: '';\n  display: block;\n  position: absolute;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  transition: left 0.1s ease-out;\n  width: 50%;\n  height: 100%;\n  border-radius: 0.125rem;\n  background: #005a8f url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E %3Cdefs%3E %3ClinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3E %3Cstop offset='0%25' stop-color='%23000'/%3E %3Cstop offset='100%25' stop-color='%23023861' stop-opacity='0'/%3E %3C/linearGradient%3E %3C/defs%3E %3Ccircle cx='3' cy='3' r='3' fill='url(%23a)' fill-rule='evenodd'/%3E %3C/svg%3E\") center center no-repeat;\n  background: var(--toggleButtonBackgroundColor, #005a8f) url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='6' height='6'%3E %3Cdefs%3E %3ClinearGradient id='a' x1='50%25' x2='50%25' y1='0%25' y2='100%25'%3E %3Cstop offset='0%25' stop-color='%23000'/%3E %3Cstop offset='100%25' stop-color='%23023861' stop-opacity='0'/%3E %3C/linearGradient%3E %3C/defs%3E %3Ccircle cx='3' cy='3' r='3' fill='url(%23a)' fill-rule='evenodd'/%3E %3C/svg%3E\") center center no-repeat;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5), 1px 0 2px rgba(0, 0, 0, 0.6);\n  box-shadow: var(--toggleButtonBoxShadow, 0 0 3px rgba(0, 0, 0, 0.5), 1px 0 2px rgba(0, 0, 0, 0.6));\n}\n\n.rux-toggle--legacy .on {\n  font-weight: 600;\n  color: #5bff00;\n  color: var(--toggleBaseSelectedTextColor, #5bff00);\n}\n\n.rux-toggle--legacy .off {\n  color: white;\n  color: var(--toggleBaseTextColor, white);\n}\n\n.rux-toggle--legacy__input:disabled+.rux-toggle--legacy__button {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity, 0.4);\n  cursor: not-allowed;\n}\n\n.rux-toggle--legacy__input:checked+.rux-toggle--legacy__button::after {\n  left: 50%;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5), -1px 0 2px rgba(0, 0, 0, 0.6);\n  box-shadow: var(--toggleButtonSelectedBoxShadow, 0 0 3px rgba(0, 0, 0, 0.5), -1px 0 2px rgba(0, 0, 0, 0.6));\n}\n\n.rux-switch {\n  position: relative;\n  display: flex;\n  height: 22px;\n  width: 42px;\n  overflow: hidden;\n}\n\n.rux-switch__input {\n  display: none;\n}\n\n.rux-switch__button {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n/* Track */\n.rux-switch__button::before {\n  position: relative;\n  display: flex;\n  content: '';\n  border-radius: 5.5px;\n  border: 1px solid;\n  border-color: var(--switchOffColor);\n  background-color: var(--switchOffColor);\n  height: 11px;\n  width: 38px;\n  z-index: 2;\n  transition: 0.1s background-color linear;\n}\n\n/* Track Active */\n.rux-switch__input:checked+.rux-switch__button::before {\n  border-color: var(--switchOnColor);\n  background-color: var(--switchOnColor);\n}\n\n/* Track Hover Unchecked */\n.rux-switch:hover .rux-switch__input:not(:disabled)+.rux-switch__button:before {\n  border-color: var(--switchHoverOffColor);\n  background-color: var(--switchHoverOffColor);\n}\n\n/* Track Hover Checked */\n.rux-switch:hover .rux-switch__input:checked:not(:disabled)+.rux-switch__button:before {\n  border-color: var(--switchHoverOnColor);\n  background-color: var(--switchHoverOnColor);\n}\n\n/* Button */\n.rux-switch__button::after {\n  position: absolute;\n  content: '';\n  top: 1px;\n  left: 0;\n  z-index: 3;\n  height: 19px;\n  width: 19px;\n  border-radius: 50%;\n  border: 1px solid var(--switchOffColor);\n  background-color: var(--inputBackground);\n  transition: 0.1s left linear, 0.1s border-color linear;\n}\n\n/* Button Active */\n.rux-switch__input:checked+.rux-switch__button::after {\n  left: 50%;\n  border-color: var(--switchOnColor);\n  background-color: var(--inputBackground);\n}\n\n/* Button Hover Unchecked */\n.rux-switch:hover .rux-switch__input:not(:disabled)+.rux-switch__button:after {\n  border-color: var(--switchHoverOffColor);\n}\n\n/* Button Hover Checked */\n.rux-switch:hover .rux-switch__input:checked:not(:disabled)+.rux-switch__button:after {\n  border-color: var(--switchHoverOnColor);\n}\n\n/* Disabled */\n.rux-switch__input:disabled+.rux-switch__button::after {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-switch__input:checked:disabled+.rux-switch__button::after {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-switch__input:disabled+.rux-switch__button::before {\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-switch__input:disabled+.rux-switch__button {\n  opacity: 0.4;\n  opacity: var(--disabledOpacity);\n  cursor: not-allowed;\n  cursor: var(--disabledCursor);\n}\n\n.rux-tree {\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  font-size: 1rem;\n  color: var(--treeTextColor);\n  border: solid 1px var(--treeBorderColor);\n  background-color: var(--treeBackgroundColor);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.rux-tree--compact {\n  font-size: 0.875rem;\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\n.rux-tree ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.rux-tree li {\n  font-weight: bold;\n}\n\n/* Parent Elements */\n.rux-tree__parent {\n  display: flex;\n  align-items: center;\n  padding: 0 0.5rem;\n  height: 2rem;\n}\n\n.rux-tree__parent:hover,\n:not([aria-selected='true'])>.rux-tree__parent:hover::after {\n  background: var(--treeHoverBackgroundColor);\n  color: var(--treeHoverTextColor);\n}\n\n:not([aria-selected='true'])>.rux-tree__parent:hover .rux-tree__arrow::after {\n  border-color: transparent transparent transparent var(--treeHoverTextColor);\n}\n\n.rux-tree__label {\n  flex-grow: 1;\n  padding: 0.5rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: calc(100% - 7px);\n}\n\n.rux-tree--compact .rux-tree__label {\n  padding: 0.35rem;\n}\n\n.rux-tree__arrow {\n  position: relative;\n  cursor: pointer;\n  width: 7px;\n  visibility: hidden;\n}\n\n.rux-tree__arrow::after {\n  content: '';\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 7px 0 7px 7px;\n  border-color: transparent transparent transparent var(--treeAccentColor);\n  display: inline-block;\n}\n\n.has-children .rux-tree__arrow {\n  visibility: visible;\n}\n\n/* Child Elements */\n.rux-tree__children {\n  width: 100%;\n  display: none;\n  padding: 0;\n  margin: 0;\n  height: 0;\n}\n\n.rux-tree__child {\n  padding-left: 3rem;\n}\n\n/* Expanded */\n.expanded .rux-tree__arrow::after {\n  transform: rotate(90deg);\n}\n\n.expanded .rux-tree__children {\n  display: block;\n  height: auto;\n}\n\n[aria-expanded='true'][aria-level='1']:not([aria-selected='true'])>.rux-tree__parent:after {\n  border-bottom: solid 1px var(--treeExpandedBorderColor);\n}\n\n.rux-tree .selected,\n[aria-selected='true']>.rux-tree__parent::after,\n[aria-selected='true']>.rux-tree__parent:hover::after {\n  background-color: var(--treeSelectedBackgroundColor);\n  box-shadow: inset 0.25rem 0 0 var(--treeSelectedAccentColor);\n  color: var(--treeSelectedTextColor);\n}\n\n.rux-tree .selected .rux-tree__arrow::after {\n  border-color: transparent transparent transparent var(--treeSelectedAccentColor);\n}\n\n[aria-selected='true']>.rux-tree__parent::after {\n  border-top: 1px solid var(--treeSelectedBorderColor);\n  border-bottom: 1px solid var(--treeSelectedBorderColor);\n}\n\nli[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover:after {\n  box-shadow: inset 0.25rem 0 0 var(--treeSelectedAccentColor) !important;\n  background-color: var(--treeHoverBackgroundColor) !important;\n}\n\nli[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover {\n  color: var(--treeHoverTextColor);\n}\n\nli[aria-selected='true']>.rux-tree__children li:not([aria-selected='undefined']) .rux-tree__parent:hover .rux-tree__arrow:after {\n  border-color: transparent transparent transparent var(--treeHoverTextColor);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
